import { pdf } from "@react-pdf/renderer";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";
import React, { useEffect, useState } from "react";
import { Step, Stepper } from 'react-form-stepper';
import { Helmet } from "react-helmet";
import { useParams, useNavigate } from "react-router-dom";
import car from "../../../src/images/progress/car.png";
import cam from "../../../src/images/techician-inner-page/cam.svg";
import NavbarT from "../../components/navbarTechnican";
import Footer from "../../homeComponents/footer";
import PdiPDF from "./pdiPdf";

const PDI = () => {
  
  const API_URL = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const { serviceId } = useParams();
  const [status, setStatus] = useState("Pending"); // Local state to track status
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [selectedButton, setSelectedButton] = useState(""); // Button state
  const [selectedButtonRLQPS, setSelectedButtonRLQPS] = useState(""); // Button state
  const [selectedButtonRLDS, setSelectedButtonRLDS] = useState(""); // Button state
  const [selectedButtonFLDS, setSelectedButtonFLDS] = useState(""); // Button state
  const [selectedButtonFLF, setSelectedButtonFLF] = useState(""); // Button state
  const [selectedButtonRF, setSelectedButtonRF] = useState(""); // Button state
  const [selectedButtonBRR, setSelectedButtonBRR] = useState(""); // Button state
  const [selectedButtonGOFRD, setSelectedButtonGOFRD] = useState(""); // Button state
  const [selectedButtonGOFLD, setSelectedButtonGOFLD] = useState(""); // Button state
  const [selectedButtonGOBT, setSelectedButtonGOBT] = useState(""); // Button state
  const [selectedButtonGOBL, setSelectedButtonGOBL] = useState(""); // Button state
  const [selectedButtonGORRDR, setSelectedButtonGORRDR] = useState(""); // Button state
  const [selectedButtonGORRLD, setSelectedButtonGORRLD] = useState(""); // Button state
  const [selectedButtonGOBR, setSelectedButtonGOBR] = useState(""); // Button state
  const [selectedButtonBRT, setSelectedButtonBRT] = useState(""); // Button state
  const [selectedButtonBT, setSelectedButtonBT] = useState(""); // Button state
  const [selectedButtonRB, setSelectedButtonRB] = useState(""); // Button state  
  const [selectedButtonBL, setSelectedButtonBL] = useState(""); // Button state
  const [selectedButtonFLD, setSelectedButtonFLD] = useState(""); // Button state
  const [selectedButtonRRDR, setSelectedButtonRRDR] = useState(""); // Button state
  const [selectedButtonRRLR, setSelectedButtonRRLR] = useState(""); // Button state
  const [selectedButtonFRD, setSelectedButtonFRD] = useState(""); // Button state
  const [selectedButtonRRQP, setSelectedButtonRRQP] = useState("");
  const [selectedButtonRO, setSelectedButtonRO] = useState("");
  const [selectedButtonblGO, setSelectedButtonblGO] = useState(""); // Button state
  const [selectedButtonGO, setSelectedButtonGO] = useState(""); // Button state
  const [selectedButtonRRD, setSelectedButtonRRD] = useState(""); // Button state
  const [selectedButtonB, setSelectedButtonB] = useState(""); // Button state
  const [selectedButtonFB, setSelectedButtonFB] = useState(""); // Button state
  const [selectedButtonFD, setSelectedButtonFD] = useState(""); // Button state
  const [selectedButtonFRQP, setSelectedButtonFRQP] = useState(""); // Button state
  const [selected, setSelected] = useState("exterior");
  const [engineNumber, setEngineNumber] = useState("");
  const [emissionType, setEmissionType] = useState("");
  const [transmission , setTransmission ] = useState("");
  const [odometerBasic, setOdometerBasic] = useState("");

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("Online");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isPdfGenerated, setIsPdfGenerated] = useState(false); // Control PDF generation status
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const [serviceData, setServiceData] = useState({});

  // Toggle
  const [isToggled, setIsToggled] = useState(false); // First
  const [isToggledFUB, setIsToggledFUB] = useState(false); // fub
  const [isToggledSR, setIsToggledSR] = useState(false); // Sunroof
  const [isToggledBRLD, setIsToggledBRLD] = useState(false); // BRLD
  const [isToggledBB, setIsToggledBB] = useState(false); // BB
  const [isToggledRW, setIsToggledRW] = useState(false); // RW
  const [isToggledBRRD, setIsToggledBRRD] = useState(false); // BRRD
  const [isToggledBFRD, setIsToggledBFRD] = useState(false); // BFRD
  const [isToggledFWL, setIsToggledFWL] = useState(false); // FWL
  const [isToggledFWR, setIsToggledFWR] = useState(false); // FWR
  const [isToggledFUTB, setIsToggledFUTB] = useState(false); // FUTB
  const [isToggledL, setIsToggledL] = useState(false); // FUTB
  const [isToggledFRDGW, setIsToggledFRDGW] = useState(false); // FRDGW
  const [isToggledFRORVMG, setIsToggledFRORVMG] = useState(false); // FRORVMG
  const [isToggledRRDW, setIsToggledRRDW] = useState(false); // RRDW
  const [isToggledRWGD, setIsToggledRWGD] = useState(false); // RWGD
  const [isToggledRLDWN, setIsToggledRLDWN] = useState(false); // RLDWN
  const [isToggledFLDWN, setIsToggledFLDWN] = useState(false); // RLDWN
  const [isToggledFRT, setIsToggledFRT] = useState(false); // FRT
  const [isToggledFW, setIsToggledFW] = useState(false); // First

  //  Fluid Level
  const [isToggledFluidLevel1, setIsToggledFluidLevel1] = useState(true);
  const [isToggledFluidLevel2, setIsToggledFluidLevel2] = useState(false);
  const [isToggledFluidLevel3, setIsToggledFluidLevel3] = useState(true);
  const [isToggledFluidLevel4, setIsToggledFluidLevel4] = useState(false);
  const [isToggledFluidLevel5, setIsToggledFluidLevel5] = useState(true);
  const [isToggledFluidLevel6, setIsToggledFluidLevel6] = useState(false);
  const [isToggledFluidLevel7, setIsToggledFluidLevel7] = useState(true);
  const [isToggledFluidLevel8, setIsToggledFluidLevel8] = useState(false);
  const [isToggledFluidLevel9, setIsToggledFluidLevel9] = useState(false);
  const [isToggledFluidLevel10, setIsToggledFluidLevel10] = useState(false);
  const [isToggledFluidLevel11, setIsToggledFluidLevel11] = useState(false);

  // CONDITIONS

  const [selectedCondition, setSelectedCondition] = useState("");
  const [selectedConditionBIS, setSelectedConditionBIS] = useState("");
  const [selectedConditionSpare, setSelectedConditionSpare] = useState("");
  const [selectedConditionSparen, setSelectedConditionSparen] = useState("");
  const [selectedConditionFLNT, setSelectedConditionFLNT] = useState("");
  const [selectedConditionFLNS, setSelectedConditionFLNS] = useState("");
  const [selectedConditionDOTFLN, setSelectedConditionDOTFLN] = useState("");
  const [selectedConditionFLN, setSelectedConditionFLN] = useState("");
  const [selectedConditionRL, setSelectedConditionRL] = useState("");
  const [selectedConditionRTN, setSelectedConditionRTN] = useState("");
  const [selectedConditionRLN, setSelectedConditionRLN] = useState("");
  const [selectedConditionRT, setSelectedConditionRT] = useState("");
  const [selectedConditionFT, setSelectedConditionFT] = useState("");
  const [selectedConditionDOTFT, setSelectedConditionDOTFT] = useState("");
  const [selectedConditionDOTSpare, setSelectedConditionDOTSpare] =
    useState("");
  const [selectedConditionDOTRT, setSelectedConditionDOTRT] = useState("");
  const [selectedConditionDOTRL, setSelectedConditionDOTRL] = useState("");
  const [selectedConditionFW, setSelectedConditionFW] = useState("");
  const [selectedConditionSTS, setSelectedConditionSTS] = useState("");

  //Ruber Components
  const [selectedConditionRC1, setSelectedConditionRC1] = useState("");
  const [selectedConditionRC2, setSelectedConditionRC2] = useState("");
  const [selectedConditionRC3, setSelectedConditionRC3] = useState("");
  const [selectedConditionRC4, setSelectedConditionRC4] = useState("");
  const [selectedConditionRC5, setSelectedConditionRC5] = useState("");
  const [selectedConditionRC6, setSelectedConditionRC6] = useState("");

  //Glass And Mirrors
  const [selectedConditionGM1, setSelectedConditionGM1] = useState("");
  const [selectedConditionGM2, setSelectedConditionGM2] = useState("");
  const [selectedConditionGM3, setSelectedConditionGM3] = useState("");
  const [selectedConditionGM4, setSelectedConditionGM4] = useState("");
  const [selectedConditionGM5, setSelectedConditionGM5] = useState("");
  const [selectedConditionGM6, setSelectedConditionGM6] = useState("");
  const [selectedConditionGM7, setSelectedConditionGM7] = useState("");
  const [selectedConditionGM8, setSelectedConditionGM8] = useState("");
  const [selectedConditionGM9, setSelectedConditionGM9] = useState("");
  const [selectedConditionGM10, setSelectedConditionGM10] = useState("");
  const [selectedConditionGM11, setSelectedConditionGM11] = useState("");
  const [selectedConditionGM12, setSelectedConditionGM12] = useState("");
  const [selectedConditionGM13, setSelectedConditionGM13] = useState("");
  const [selectedConditionGM14, setSelectedConditionGM14] = useState("");
  const [selectedConditionGM15, setSelectedConditionGM15] = useState("");
  const [selectedConditionGM16, setSelectedConditionGM16] = useState("");
  const [selectedConditionGM17, setSelectedConditionGM17] = useState("");
  const [selectedConditionGM18, setSelectedConditionGM18] = useState("");
  const [selectedConditionGM19, setSelectedConditionGM19] = useState("");
  const [selectedConditionGM20, setSelectedConditionGM20] = useState("");
  const [selectedConditionGM21, setSelectedConditionGM21] = useState("");

  //  Sensor
  // State to store the current input value
  const [SensorCode, setSensorCode] = useState("");
  // State to store the array of entered error codes
  const [errorCodes, setErrorCodes] = useState([]);
  const [odometers, setOdometer] = useState("");
  const [keyss, setKeys] = useState("");
  const [BatteryEnergy, setBatteryEnergy] = useState("");
  const [LoadEngine, setLoadEngine] = useState("");
  const [idleRPM, setIdleRPM] = useState("");
  const [distKMS, setDistKMS] = useState("");
  const [distCKMS, setDistCKMS] = useState("");
  const [isToggledEngineCrack, setIsToggledEngineCrack] = useState(true); // First
  const [isToggledWarning, setIsToggledWarning] = useState(true); // First
  const [isToggledSuspicious, setIsToggledSuspicious] = useState(true);
  const [isToggledSmoke, setIsToggledSmoke] = useState(true);
  const [isToggledGearshift, setIsToggledGearshift] = useState(true);
  const [isToggledBreak, setIsToggledBreak] = useState(true);
  const [isToggledSteering, setIsToggledSteering] = useState(true);
  const [isToggledHandbreak, setIsToggledHandbreak] = useState(true);
  const [isToggledReverse, setIsToggledReverse] = useState(true);
  const [isToggledSmooth, setIsToggledSmooth] = useState(true);

  // Interior
  //  Carpet
  const [selectedConditionSDS, setSelectedButtonSDS] = useState(""); // DriverSide Button state
  const [selectedConditionHR, setSelectedButtonHR] = useState(""); // DriverSide Button state
  const [selectedConditionCHR, setSelectedButtonCHR] = useState(""); // DriverSide Button state
  const [selectedConditionRHR, setSelectedButtonRHR] = useState(""); // DriverSide Button state
  const [selectedConditionHCDR, setSelectedButtonHCDR] = useState(""); // DriverSide Button state
  const [selectedConditionSCDRS, setSelectedButtonSCDRS] = useState(""); // DriverSide Button state
  const [selectedConditionSDRS, setSelectedButtonSDRS] = useState(""); // DriverSide Button state
  const [selectedConditionSCDS, setSelectedButtonSCDS] = useState(""); // DriverSide Button state
  const [selectedButtonDS, setSelectedButtonDS] = useState(""); // DriverSide Button state
  const [selectedConditionPDS, setSelectedConditionPDS] = useState(""); // DriverSide Plastic Panels Condition state
  const [selectedButtonCDS, setSelectedButtonCDS] = useState(""); // CO DriverSide Button state
  const [selectedConditionDS, setSelectedConditionDS] = useState(""); // DriverSide Condition state
  const [selectedConditionCDS, setSelectedConditionCDS] = useState(""); // CO DriverSide Condition state
  const [selectedConditionPCDS, setSelectedConditionPCDS] = useState(""); // CO DriverSide Plastic Panels Condition state

  const [selectedConditionDRS, setSelectedConditionDRS] = useState(""); // Driver Rear Side Condition state
  const [selectedConditionPDRS, setSelectedConditionPDRS] = useState(""); // Driver Rear Side Plastic Panel Condition state
  const [selectedConditionPCDRS, setSelectedConditionPCDRS] = useState(""); // Co Driver Rear Side Plastic Panel Condition state
  const [selectedButtonDRS, setSelectedButtonDRS] = useState(""); // Driver Rear Side Button state

  const [selectedConditionCDRS, setSelectedConditionCDRS] = useState(""); // co Driver Rear Side Condition state
  const [selectedButtonCDRS, setSelectedButtonCDRS] = useState(""); // co Driver Rear Side Button state

  const [selectedConditionBI, setSelectedConditionBI] = useState(""); // Boot Condition state
  const [selectedConditionGC, setSelectedConditionGC] = useState(""); // Gear Console state
  const [selectedConditionD, setSelectedConditionD] = useState(""); // Dashboard Condition state
  const [selectedButtonBI, setSelectedButtonBI] = useState(""); // Boot Rear Side Button state

  // OBSERVATION

  const [selectedConditionIS, setSelectedConditionIS] = useState(""); // Infortainment System
  const [selectedConditionRLQPS, setSelectedConditionRLQPS] = useState(""); // Infortainment System
  const [selectConditionRF, setSelectedConditionRF] = useState(""); // Infortainment System
  const [isToggledIS, setIsToggledIS] = useState(false); // Infortainment System Toggle

  const [selectedConditionSASQ, setSelectedConditionSASQ] = useState(""); // SASQ
  const [isToggledSASQ, setIsToggledSASQ] = useState(false); // SASQ

  const [selectedConditionPW, setSelectedConditionPW] = useState(""); // SASQ
  const [isToggledPW, setIsToggledPW] = useState(false); // SASQ

  const [selectedConditionGCO, setSelectedConditionGCO] = useState(""); // GC
  const [isToggledGC, setIsToggledGC] = useState(false); // GC

  const [selectedConditionCQ, setSelectedConditionCQ] = useState(""); // CQ
  const [isToggledCQ, setIsToggledCQ] = useState(false); // CQ

  const [selectedConditionGCCO, setSelectedConditionGCCO] = useState(""); // GCCO
  const [isToggleGCCO, setIsToggleGCCO] = useState(false); // GCCO

  const [selectedConditionDO, setSelectedConditionDO] = useState(""); // DO
  const [isToggleDO, setIsToggleDO] = useState(false); // DO

  // Others CLICK THEN CHAMEG TO INPUT FIELD
  const [isOtherSelectedRF, selectedConditionRF] = useState(""); // to store selected option
  const [selectedConditionSensor, setSelectedConditionSensor] = useState(""); // to store selected option
  const [selectedConditionSensor1, setSelectedConditionSensor1] = useState(""); // to store selected option
  const [selectedConditionSensor2, setSelectedConditionSensor2] = useState(""); // to store selected option
  const [isOtherSelectedSensor, setIsOtherSelectedSensor] = useState(false); // to track "Other" selection
  const [isOtherSelectedSensor1, setIsOtherSelectedSensor1] = useState(false); // to track "Other" selection
  const [isOtherSelectedSensor2, setIsOtherSelectedSensor2] = useState(false); // to track "Other" selection
  const [isSelectedConditionCarsCore1, setIsSelectedConditionCarsCore1] =
    useState(false); // to track "Other" selection
  const [isSelectedConditionCarsCore2, setIsSelectedConditionCarsCore2] =
    useState(false); // to track "Other" selection

  const [isSelectedConditionGM1, setIsSelectedConditionGM1] = useState(false);
  const [isSelectedConditionGM2, setIsSelectedConditionGM2] = useState(false);
  const [isSelectedConditionGM3, setIsSelectedConditionGM3] = useState(false);
  const [isSelectedConditionGM4, setIsSelectedConditionGM4] = useState(false);
  const [isSelectedConditionGM5, setIsSelectedConditionGM5] = useState(false);
  const [isSelectedConditionGM6, setIsSelectedConditionGM6] = useState(false);
  const [isSelectedConditionGM7, setIsSelectedConditionGM7] = useState(false);
  const [isSelectedConditionGM8, setIsSelectedConditionGM8] = useState(false);
  const [isSelectedConditionGM9, setIsSelectedConditionGM9] = useState(false);

  const [writtenConditionCarsCore1, setWrittenConditionCarsCore1] =
    useState("");
  const [writtenConditionCarsCore2, setWrittenConditionCarsCore2] =
    useState("");

  const [writtenConditionGM1, setWrittenConditionGM1] = useState("");
  const [writtenConditionGM2, setWrittenConditionGM2] = useState("");
  const [writtenConditionGM3, setWrittenConditionGM3] = useState("");
  const [writtenConditionGM4, setWrittenConditionGM4] = useState("");
  const [writtenConditionGM5, setWrittenConditionGM5] = useState("");
  const [writtenConditionGM6, setWrittenConditionGM6] = useState("");
  const [writtenConditionGM7, setWrittenConditionGM7] = useState("");
  const [writtenConditionGM8, setWrittenConditionGM8] = useState("");
  const [writtenConditionGM9, setWrittenConditionGM9] = useState("");

  const [otherValueSensor, setOtherValueSensor] = useState(""); // to store the custom "Other" input value
  const [otherValueSenso1, setOtherValueSenso1] = useState(""); // to store the custom "Other" input value
  const [otherValueSensor2, setOtherValueSensor2] = useState(""); // to store the custom "Other" input value
  const [otherValueRLQPS, setOtherValueRLQPS] = useState("");
  const [otherValueRF, setOtherValueRF] = useState("");

  //Car's Core Mechanical Area Conditions
  const [selectedConditionCarsCore1, setSelectedConditionCarsCore1] =
    useState("");
  const [selectedConditionCarsCore2, setSelectedConditionCarsCore2] =
    useState("");
  const [selectedConditionCarsCore3, setSelectedConditionCarsCore3] =
    useState("");
  const [selectedConditionCarsCore4, setSelectedConditionCarsCore4] =
    useState("");
  const [selectedConditionCarsCore5, setSelectedConditionCarsCore5] =
    useState("");
  const [selectedConditionCarsCore6, setSelectedConditionCarsCore6] =
    useState("");
  const [selectedConditionCarsCore7, setSelectedConditionCarsCore7] =
    useState("");
  const [selectedConditionCarsCore8, setSelectedConditionCarsCore8] =
    useState("");
  const [selectedConditionCarsCore9, setSelectedConditionCarsCore9] =
    useState("");
  const [selectedConditionCarsCore10, setSelectedConditionCarsCore10] =
    useState("");
  const [selectedConditionCarsCore11, setSelectedConditionCarsCore11] =
    useState("");
  const [selectedConditionCarsCore12, setSelectedConditionCarsCore12] =
    useState("");

  const [technicianName, setTechnicianName] = useState(""); 
  const [dropdownOptions, setDropdownOptions] = useState({});

  const [reportData, setReportData] = useState({
    inspectionType: "",
    customerName: "",
    customerPhone: "",
    technicianName: "",
    date: "",
    vehicleModel: "",
    variant: "",
    allottedVin: "",
    address: "",
    vehicleCondition: "", // New field for vehicle condition
  });

  // Fetch all dropdown configurations
  useEffect(() => {
    const fetchDropdownItems = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/dropdown/getAll`);
        
        // Create options dictionary
        const optionsDict = {};
        response.data.forEach(item => {
          optionsDict[item.subHeading] = item.dropdownOptions;
        });
        
        setDropdownOptions(optionsDict);
      } catch (err) {
        setError('Error fetching dropdown configurations');
        console.error('Fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDropdownItems();
  }, []);  

  useEffect(() => {
    const fetchServiceDetails = async () => {
      try {
        const serviceResponse = await axios.get(
          `${API_URL}/api/services/${serviceId}/get`
        );
        const serviceData = serviceResponse.data;
        setServiceData(serviceData);

        // Set the form state based on the service status
        setStatus(serviceData.status || "Pending"); // Default to 'Pending' if status is not set
        setIsDisabled(serviceData.status === "Arrived"); // Disable if not 'Pending'
        setVinNumber(serviceData.allottedVin);

        if (!serviceData.userId) {
          throw new Error("User ID is missing in the service data");
        }

        const userId = serviceData.userId;
        const userResponse = await axios.get(
          `${API_URL}/api/admin/users/${userId}/get`
        );
        const userData = userResponse.data;

        const technicianId = serviceData.technicianId;
        const technicianResponse = await axios.get(
          `${API_URL}/api/admin/technicians/${technicianId}/get`
        );
        const technicianData = technicianResponse.data;

        const TechnicianName = `${technicianData.firstname} ${technicianData.lastname}`;

        setTechnicianName(TechnicianName);

        setReportData((prevData) => ({
          ...prevData,
          inspectionType: serviceData.inspectionType || "",
          customerName: userData.name || serviceData.customerName || "",
          customerPhone:
            serviceData.customerPhone || userData.phoneNumber || "",
          technicianName: technicianName || "",
          date: new Date(serviceData.deliveryDate).toISOString().substr(0, 10),
          vehicleModel: serviceData.vehicleModel || "",
          variant: serviceData.variant || "",
          allottedVin: serviceData.allottedVin || "",
          address: serviceData.address || "",
        }));

        // Fetch PDI report details if available and status is completed
        if (serviceData.status === "Completed" && serviceData.pdiReportId) {
          await fetchPDIReport(serviceData.pdiReportId);
        }
      } catch (err) {
        setError(
          "Error fetching service details: " +
            (err.response ? err.response.data.message : err.message)
        );
        console.error("Error fetching service details:", err);
      } finally {
        setLoading(false);
      }
    };

    const fetchPDIReport = async (pdiReportId) => {
      try {
        const reportResponse = await axios.get(
          `${API_URL}/api/pdi-reports/${pdiReportId}/get`
        );
        const pdiReportData = reportResponse.data;

        // Populate the form with PDI report data
        setReportData({
          inspectionType: pdiReportData.inspectionType,
          customerName: pdiReportData.customerName,
          technicianName: pdiReportData.technicianName,
          date: new Date(pdiReportData.date).toISOString().substr(0, 10),
          vehicleModel: pdiReportData.vehicleModel,
          variant: pdiReportData.variant,
          allottedVin: pdiReportData.allottedVin,
          address: pdiReportData.address,
          vehicleCondition: pdiReportData.vehicleCondition,
        });

        setIsFormDisabled(true); // Disable form if the PDI report already exists
      } catch (err) {
        setError(
          "Error fetching PDI report: " +
            (err.response ? err.response.data.message : err.message)
        );
        console.error("Error fetching PDI report:", err);
      }
    };

    if (serviceId) {
      fetchServiceDetails();
    }
  }, [serviceId]);

  // Input
  const [vinNumber, setVinNumber] = useState("");
  const [VarientRT, setVarientRT] = useState("");
  const [VarientSpare, setVarientSpare] = useState("");
  const [VarientFLN, setVarientFLN] = useState("");
  const [RLTrend, setRLTrend] = useState("");
  const [VarientRL, setVarientRL] = useState("");
  const [TDRT, setTDRT] = useState("");
  const [FLN, setFLN] = useState("");
  const [Spare, setSpare] = useState("");
  const [BrandT, setBrandT] = useState("");
  const [BrandSpare, setBrandSpare] = useState("");
  const [BrandFLN, setBrandFLN] = useState("");
  const [BrandRL, setBrandRL] = useState("");
  const [BrandRT, setBrandRT] = useState("");
  const [BrandTRFR, setBrandTRFR] = useState("");
  const [BrandTv, setBrandTv] = useState("");
  const [issueBT, setIssueBT] = useState("");
  const [issueRB, setIssueRB] = useState("");  
  const [issueRLQPS, setIssueRLQPS] = useState("");
  const [issueFLF, setIssueFLF] = useState("");
  const [issueFLDS, setIssueFLDS] = useState("");
  const [issueRLDS, setIssueRLDS] = useState("");
  const [issueB, setIssueB] = useState(""); // Bonnet
  const [issueRF, setIssueRF] = useState(""); // Bonnet
  const [issueFB, setIssueFB] = useState(""); // Front Bumper
  const [issueFRQP, setIssueFRQP] = useState("");
  const [percentageValue, setPercentageValue] = useState("");
  const [finalObservations, setFinalObservations] = useState("");

  // Technician's Remarks — a numbered list of free-text lines, each with an
  // optional evidence photo. Source of truth is this array; finalObservations
  // (the pre-existing plain string) is still derived from it at submit time
  // for backward compatibility. photoFile holds a freshly-picked File (not
  // yet uploaded); photoUrl holds an already-stored URL (admin edit / draft
  // restore). A File can't be persisted to a draft, matching how zone photos
  // already behave.
  const [technicianRemarks, setTechnicianRemarks] = useState([
    { text: "", photoFile: null, photoUrl: "" },
  ]);
  const addRemarkRow = () =>
    setTechnicianRemarks((rows) => [...rows, { text: "", photoFile: null, photoUrl: "" }]);
  const removeRemarkRow = (i) =>
    setTechnicianRemarks((rows) => {
      const next = rows.filter((_, idx) => idx !== i);
      return next.length ? next : [{ text: "", photoFile: null, photoUrl: "" }];
    });
  const updateRemarkText = (i, text) =>
    setTechnicianRemarks((rows) => rows.map((r, idx) => (idx === i ? { ...r, text } : r)));
  const setRemarkPhoto = (i, file) =>
    setTechnicianRemarks((rows) =>
      rows.map((r, idx) => (idx === i ? { ...r, photoFile: file || null, photoUrl: "" } : r))
    );
  const clearRemarkPhoto = (i) =>
    setTechnicianRemarks((rows) =>
      rows.map((r, idx) => (idx === i ? { ...r, photoFile: null, photoUrl: "" } : r))
    );
  // Restore drafted/old-shape remarks: prefer the structured array, fall
  // back to splitting a legacy finalObservations string so nothing typed
  // before this change is lost. Files never survive a reload.
  const hydrateRemarks = (data) => {
    if (!data) return;
    const arr = data.technicianRemarks;
    if (Array.isArray(arr) && arr.length > 0) {
      setTechnicianRemarks(
        arr.map((r) => ({
          text: (r && r.text) || "",
          photoFile: null,
          photoUrl: (r && r.photoUrl) || "",
        }))
      );
      return;
    }
    if (typeof data.finalObservations === "string" && data.finalObservations.trim()) {
      setTechnicianRemarks(
        data.finalObservations
          .split("\n")
          .map((line) => line.trim())
          .filter(Boolean)
          .map((text) => ({ text, photoFile: null, photoUrl: "" }))
      );
    }
  };
  // Prepare remarks for submission. `rows` is the empty-filtered, ordered
  // list — its index is the alignment key: remarkPhoto_<i> uploaded to the
  // backend maps onto technicianRemarks[i]. `field` is what goes in
  // reportData (a File as photoUrl renders straight into the client-side
  // preview/blob PDF; JSON.stringify collapses it to {} and the backend
  // then fills in the real S3 URL from the matching remarkPhoto_<i>).
  const prepareRemarks = () => {
    const rows = technicianRemarks
      .map((r) => ({
        text: (r.text || "").trim(),
        photoFile: r.photoFile || null,
        photoUrl: r.photoUrl || "",
      }))
      .filter((r) => r.text || r.photoFile || r.photoUrl);
    return {
      rows,
      field: rows.map((r) => ({ text: r.text, photoUrl: r.photoFile || r.photoUrl || null })),
      finalObservations: rows.map((r) => r.text).filter(Boolean).join("\n"),
    };
  };

  const [issueFD, setIssueFD] = useState("");
  const [issueRRD, setIssueRRD] = useState("");
  const [issueRRQP, setIssueRRQP] = useState("");
  const [keysBasic, setKeysBasic] = useState("");
  const [valueRF, setValuesRF] = useState("");
  const [valueFLF, setValuesFLF] = useState("");
  const [valueRLQPS, setValuesRLQPSS] = useState("");
  const [value, setValues] = useState("");
  const [valueRLAPS, setValuesRLQPS] = useState("");
  const [valueB, setValuesB] = useState("");
  const [valueRLDS, setValuesRLDS] = useState("");
  const [valueGRT1, setValueGRT1] = useState(""); // 1
  const [valueGRT2, setValueGRT2] = useState(""); // 2
  const [valueGRT3, setValueGRT3] = useState(""); // 3
  const [valueGRT4, setValueGRT4] = useState(""); // 4
  const [valueGRT5, setValueGRT5] = useState(""); // 5
  const [valueGRT6, setValueGRT6] = useState(""); // 6
  const [valueGRT7, setValueGRT7] = useState(""); // 7
  const [valueGRT8, setValueGRT8] = useState(""); // 8
  const [valueGRD1, setValueGRD1] = useState(""); // 1
  const [valueGRD2, setValueGRD2] = useState(""); // 2
  const [valueGRD3, setValueGRD3] = useState(""); // 3
  const [valueGRD4, setValueGRD4] = useState(""); // 4
  const [valueGRD5, setValueGRD5] = useState(""); // 5
  const [valueGRD6, setValueGRD6] = useState(""); // 6
  const [valueGRD7, setValueGRD7] = useState(""); // 7
  const [valueGRD8, setValueGRD8] = useState(""); // 8
  const [valueFB, setValuesFB] = useState("");
  const [valueRRD, setValuesRRD] = useState("");
  const [valueFD, setValuesFD] = useState("");
  const [valueFRQP, setValuesFRQP] = useState("");
  const [valueBT, setValuesBT] = useState("");
  const [valueRB, setValuesRB] = useState("");
  const [valueFLDS, setValuesFLDS] = useState("");
  const [valueRRQP, setValuesRRQP] = useState("");
  const [savedBasicMessage, setSavedBasicMessage] = useState("");
  const [savedPaintBodyMessage, setSavedPaintBodyMessage] = useState("");
  const [savedCarpetMessage, setSavedCarpetMessage] = useState("");
  const [savedFlushesAndGapsMessage, setSavedFlushesAndGapsMessage] =
    useState("");
  const [savedPlasticPanelMessage, setSavedPlasticPanelMessage] = useState("");
  const [savedRubberComponentsMessage, setSavedRubberComponentsMessage] =
    useState("");
  const [savedSeatAndObservationsMessage, setSavedSeatAndObservationsMessage] =
    useState("");
  const [savedGlassAndMirrorsMessage, setSavedGlassAndMirrorsMessage] =
    useState("");
  const [savedTyresMessage, setSavedTyresMessage] = useState("");
  const [savedSensorsAndLiveMessage, setSavedSensorsAndLiveMessage] =
    useState("");
  const [savedFluidLevelsMessage, setSavedFluidLevelsMessage] = useState("");
  const [savedCarCoreMessage, setSavedCarCoreMessage] = useState("");
  const [savedPaymentMessage, setSavedPaymentMessage] = useState("");

  //Files
  // Create individual state variables for each file upload
  const [basicFile1, setBasicFile1] = useState(null);
  const [basicFile2, setBasicFile2] = useState(null);
  const [basicFile3, setBasicFile3] = useState(null);
  const [basicFile4, setBasicFile4] = useState(null);

  // 12 states for both paint and body images combined
  const [paintBodyFile1, setPaintBodyFile1] = useState(null);
  const [paintBodyFile2, setPaintBodyFile2] = useState(null);
  const [paintBodyFile3, setPaintBodyFile3] = useState(null);
  const [paintBodyFile4, setPaintBodyFile4] = useState(null);
  const [paintBodyFile5, setPaintBodyFile5] = useState(null);
  const [paintBodyFile6, setPaintBodyFile6] = useState(null);
  const [paintBodyFile7, setPaintBodyFile7] = useState(null);
  const [paintBodyFile8, setPaintBodyFile8] = useState(null);
  const [paintBodyFile9, setPaintBodyFile9] = useState(null);
  const [paintBodyFile10, setPaintBodyFile10] = useState(null);
  const [paintBodyFile11, setPaintBodyFile11] = useState(null);
  const [paintBodyFile12, setPaintBodyFile12] = useState(null);
  const [paintBodyFile13, setPaintBodyFile13] = useState(null);  

  // Create individual state variables for carpet file uploads
  const [carpetFile1, setCarpetFile1] = useState(null);
  const [carpetFile2, setCarpetFile2] = useState(null);
  const [carpetFile3, setCarpetFile3] = useState(null);
  const [carpetFile4, setCarpetFile4] = useState(null);
  const [carpetFile5, setCarpetFile5] = useState(null);

  // Create individual state variables for plastic panel file uploads
  const [plasticPanelFile1, setPlasticPanelFile1] = useState(null);
  const [plasticPanelFile2, setPlasticPanelFile2] = useState(null);
  const [plasticPanelFile3, setPlasticPanelFile3] = useState(null);
  const [plasticPanelFile4, setPlasticPanelFile4] = useState(null);
  const [plasticPanelFile5, setPlasticPanelFile5] = useState(null);
  const [plasticPanelFile6, setPlasticPanelFile6] = useState(null);
  const [plasticPanelFile7, setPlasticPanelFile7] = useState(null);

  // Create individual state variables for rubber component file uploads
  const [rubberComponentFile1, setRubberComponentFile1] = useState(null);
  const [rubberComponentFile2, setRubberComponentFile2] = useState(null);
  const [rubberComponentFile3, setRubberComponentFile3] = useState(null);
  const [rubberComponentFile4, setRubberComponentFile4] = useState(null);
  const [rubberComponentFile5, setRubberComponentFile5] = useState(null);
  const [rubberComponentFile6, setRubberComponentFile6] = useState(null);

  // Create individual state variables for seat file uploads
  const [seatFile1, setSeatFile1] = useState(null);
  const [seatFile2, setSeatFile2] = useState(null);
  const [seatFile3, setSeatFile3] = useState(null);
  const [seatFile4, setSeatFile4] = useState(null);
  const [seatFile5, setSeatFile5] = useState(null);
  const [seatFile6, setSeatFile6] = useState(null);
  const [seatFile7, setSeatFile7] = useState(null);
  const [seatFile8, setSeatFile8] = useState(null);

  // Create individual state variables for glass and mirrors file uploads
  const [glassMirrorFile1, setGlassMirrorFile1] = useState(null);
  const [glassMirrorFile2, setGlassMirrorFile2] = useState(null);
  const [glassMirrorFile3, setGlassMirrorFile3] = useState(null);
  const [glassMirrorFile4, setGlassMirrorFile4] = useState(null);
  const [glassMirrorFile5, setGlassMirrorFile5] = useState(null);
  const [glassMirrorFile6, setGlassMirrorFile6] = useState(null);
  const [glassMirrorFile7, setGlassMirrorFile7] = useState(null);
  const [glassMirrorFile8, setGlassMirrorFile8] = useState(null);
  const [glassMirrorFile9, setGlassMirrorFile9] = useState(null);
  const [glassMirrorFile10, setGlassMirrorFile10] = useState(null);
  const [glassMirrorFile11, setGlassMirrorFile11] = useState(null);
  const [glassMirrorFile12, setGlassMirrorFile12] = useState(null);

  // Create individual state variables for tyre file uploads
  const [tyreFile1, setTyreFile1] = useState(null);
  const [tyreFile2, setTyreFile2] = useState(null);
  const [tyreFile3, setTyreFile3] = useState(null);
  const [tyreFile4, setTyreFile4] = useState(null);
  const [tyreFile5, setTyreFile5] = useState(null);

  // Handle file uploads for each input
  const handleFileUpload = (e, setFile) => {
    const file = e.target.files[0];
    // console.log("File uploaded:", file);
    setFile(file); // Set the file to the corresponding state
  };

  const [base64Image, setBase64Image] = useState("");

  const convertImageToBase64 = async (imageUrl) => {
    try {
      const proxyUrl = `${API_URL}/api/proxy-image?url=${encodeURIComponent(imageUrl)}`;
      const response = await fetch(proxyUrl);
      const blob = await response.blob();

      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result); // ✅ base64 string
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Error converting image to base64:", error);
    }
  };

  useEffect(() => {
    if (serviceData?.vehicleImageUrl) {
      convertImageToBase64(serviceData.vehicleImageUrl);
    }
  }, [serviceData?.vehicleImageUrl]);    

  // Handle input change
  const handleChangeErrorCode = (e) => {
    setSensorCode(e.target.value);
  };

  // Handle add button click
  const handleAddErrorCode = () => {
    if (SensorCode.trim() !== "") {
      // Add the entered SensorCode to the array
      setErrorCodes((prevCodes) => [...prevCodes, SensorCode]);

      // Clear the input field
      setSensorCode("");
    }
  };

  // Handle save functionality
  const handleSaveBasicDetails = () => {
    // Prepare the details to save
    const newDetails = {
      vinNumber,
      engineNumber,
      emissionType,
      transmission,
      odometerBasic,
      keysBasic,
      dealerShowroom: selectedButton, // Save the selected button state
    };

    // Save to localStorage
    localStorage.setItem(
      `basicDetails-${serviceId}`,
      JSON.stringify(newDetails)
    );

    // Update the state to show the saved message
    setSavedBasicMessage("Basic Details Saved!");
  };

  // Handle Save functionality for Paint and Body details
  const handleSavePaintBody = () => {
    // Prepare the details to save
    const newPaintBodyDetails = {
      selectedButtonB,
      valueB,
      issueB,
      selectedButtonFB,
      valueFB,
      issueFB,
      selectedButtonFRQP,
      valueFRQP,
      issueFRQP,
      selectedButtonFD,
      valueFD,
      issueFD,
      selectedButtonRRD,
      valueRRD,
      issueRRD,
      selectedButtonRRQP,
      valueRRQP,
      issueRRQP,
      selectedButtonBT,
      valueBT,
      issueBT,
      selectedButtonFLF,
      valueFLF,
      issueFLF,
      selectedButtonFLDS,
      valueFLDS,
      issueFLDS,
      selectedButtonRLDS,
      valueRLDS,
      issueRLDS,
      selectedButtonRLQPS,
      valueRLQPS,
      selectedConditionRLQPS,
      otherValueRLQPS,
      selectedButtonRF,
      selectConditionRF,
      valueRF,
      otherValueRF,
      selectedConditionSensor1,
      selectedConditionSensor2,
      selectedButtonRB,
      valueRB,
      issueRB
      // isOtherSelectedSensor1,
      // isOtherSelectedSensor2,
    };

    // Save to localStorage
    localStorage.setItem(
      `paintBodyDetails-${serviceId}`,
      JSON.stringify(newPaintBodyDetails)
    );

    // Show the saved message
    setSavedPaintBodyMessage("Paint and Body Details Saved!");
  };

  const handleSaveCarpetDetails = () => {
    // Prepare the carpet details to save
    const newCarpetDetails = {
      selectedButtonDS,
      selectedConditionDS,
      selectedButtonCDS,
      selectedConditionCDS,
      selectedButtonDRS,
      selectedConditionDRS,
      selectedButtonCDRS,
      selectedConditionCDRS,
      selectedButtonBI,
      selectedConditionBI,
    };

    // Save to localStorage
    localStorage.setItem(
      `carpetDetails-${serviceId}`,
      JSON.stringify(newCarpetDetails)
    );

    // Show the saved message
    setSavedCarpetMessage("Carpet Details Saved!");
  };

  // Handle save functionality for flushes and gaps
  const handleSaveFlushesAndGaps = () => {
    // Prepare the details to save
    const flushesAndGapsDetails = {
      selectedButtonRO,
      selectedButtonGO,
      valueGRT1,
      valueGRD1,
      selectedButtonBL,
      selectedButtonGOBL,
      valueGRT2,
      valueGRD2,
      selectedButtonFRD,
      selectedButtonGOFRD,
      valueGRT3,
      valueGRD3,
      selectedButtonFLD,
      selectedButtonGOFLD,
      valueGRT4,
      valueGRD4,
      selectedButtonRRDR,
      selectedButtonGORRDR,
      valueGRT5,
      valueGRD5,
      selectedButtonRRLR,
      selectedButtonGORRLD,
      valueGRT6,
      valueGRD6,
      selectedButtonBRR,
      selectedButtonGOBR,
      valueGRT7,
      valueGRD7,
      selectedButtonBRT,
      selectedButtonGOBT,
      valueGRT8,
      valueGRD8,
    };

    // Save to localStorage
    localStorage.setItem(
      `flushesAndGapsDetails-${serviceId}`,
      JSON.stringify(flushesAndGapsDetails)
    );

    // Update the state to show the saved message
    setSavedFlushesAndGapsMessage("Flushes and Gaps Details Saved!");
  };

  // Handle save functionality for plastic panel conditions
  const handleSavePlasticPanelDetails = () => {
    // Prepare the details to save
    const plasticPanelDetails = {
      selectedConditionPDS,
      selectedConditionPCDS,
      selectedConditionPDRS,
      selectedConditionPCDRS,
      selectedConditionBIS,
      selectedConditionD,
      selectedConditionGC,
    };

    // Save to localStorage
    localStorage.setItem(
      `plasticPanelDetails-${serviceId}`,
      JSON.stringify(plasticPanelDetails)
    );

    // Update the state to show the saved message
    setSavedPlasticPanelMessage("Plastic Panel Details Saved!");
  };

  // Handle save functionality for rubber components
  const handleSaveRubberComponents = () => {
    // Prepare the details to save
    const newDetails = {
      isToggled,
      selectedConditionRC1,
      isToggledBRLD,
      selectedConditionRC2,
      isToggledBB,
      selectedConditionRC3,
      isToggledBRRD,
      selectedConditionRC4,
      isToggledBFRD,
      selectedConditionRC5,
      isToggledFUB,
      selectedConditionRC6,
    };

    // Save to localStorage
    localStorage.setItem(
      `rubberComponentsDetails-${serviceId}`,
      JSON.stringify(newDetails)
    );

    // Update the state to show the saved message
    setSavedRubberComponentsMessage("Rubber Components Details Saved!");
  };

  // Handle save functionality for seat and observations
  const handleSaveSeatAndObservations = () => {
    // Prepare the details to save
    const newDetails = {
      selectedConditionSDS,
      selectedConditionSCDS,
      selectedConditionSDRS,
      selectedConditionSCDRS,
      selectedConditionHR,
      selectedConditionCHR,
      selectedConditionRHR,
      selectedConditionHCDR,
      isToggledIS,
      selectedConditionIS,
      isToggledSASQ,
      selectedConditionSASQ,
      isToggledPW,
      selectedConditionPW,
      isToggledGC,
      selectedConditionGCO,
      isToggledCQ,
      selectedConditionCQ,
    };

    // Save to localStorage
    localStorage.setItem(
      `seatAndObservationsDetails-${serviceId}`,
      JSON.stringify(newDetails)
    );

    // Update the state to show the saved message
    setSavedSeatAndObservationsMessage("Seat and Observations Details Saved!");
  };

  // Handle save functionality for Glass and Mirrors details
  const handleSaveGlassAndMirrorsDetails = () => {
    // Prepare the details to save
    const newDetails = {
      isToggledFW,
      isToggledFWL,
      isToggledFWR,
      isToggledL,
      isToggledFRDGW,
      isToggledFRORVMG,
      isToggledRRDW,
      isToggledRWGD,
      isToggledRW,
      isToggledRLDWN,
      isToggledFLDWN,
      isToggledSR,
      selectedConditionGM1,
      selectedConditionGM2,
      selectedConditionGM3,
      selectedConditionGM4,
      selectedConditionGM5,
      selectedConditionGM6,
      selectedConditionGM7,
      selectedConditionGM8,
      selectedConditionGM9,
      selectedConditionGM10,
      selectedConditionGM11,
      selectedConditionGM12,
      selectedConditionGM13,
      selectedConditionGM14,
      selectedConditionGM15,
      selectedConditionGM16,
      selectedConditionGM17,
      selectedConditionGM18,
      selectedConditionGM19,
      selectedConditionGM20,
      selectedConditionGM21,
      // writtenConditionGM1,
      // writtenConditionGM2,
      // writtenConditionGM3,
      // writtenConditionGM4,
      // writtenConditionGM5,
      // writtenConditionGM6,
      // writtenConditionGM7,
      // writtenConditionGM8,
      // writtenConditionGM9,
    };

    // Save to localStorage
    localStorage.setItem(
      `glassAndMirrorsDetails-${serviceId}`,
      JSON.stringify(newDetails)
    );

    // Update the state to show the saved message
    setSavedGlassAndMirrorsMessage("Glass and Mirrors Details Saved!");
  };

  // Handle save functionality for Tyres details
  const handleSaveTyresDetails = () => {
    // Prepare the details to save
    const newDetails = {
      BrandT,
      BrandTv,
      selectedConditionSTS,
      BrandTRFR,
      selectedConditionDOTFT,
      selectedConditionFT,
      BrandRT,
      VarientRT,
      selectedConditionRT,
      TDRT,
      selectedConditionDOTRT,
      selectedConditionRTN,
      BrandRL,
      VarientRL,
      selectedConditionRL,
      RLTrend,
      selectedConditionDOTRL,
      selectedConditionRLN,
      BrandFLN,
      VarientFLN,
      selectedConditionFLN,
      FLN,
      selectedConditionDOTFLN,
      selectedConditionFLNT,
      BrandSpare,
      Spare,
      VarientSpare,
      selectedConditionSpare,
      selectedConditionDOTSpare,
      selectedConditionSparen,
    };

    // Save to localStorage
    localStorage.setItem(
      `tyresDetails-${serviceId}`,
      JSON.stringify(newDetails)
    );

    // Update the state to show the saved message
    setSavedTyresMessage("Tyres Details Saved!");
  };

  // Save the details to localStorage
  const handleSaveSensorsAndLiveData = () => {
    const newDetails = {
      errorCodes,
      BatteryEnergy,
      LoadEngine,
      idleRPM,
      distKMS,
      distCKMS,
      isToggledEngineCrack,
      isToggledWarning,
      isToggledSuspicious,
      isToggledSmoke,
      isToggledGearshift,
      isToggledBreak,
      isToggledSteering,
      isToggledHandbreak,
      isToggledReverse,
      isToggledSmooth,
    };

    // Save to localStorage
    localStorage.setItem(
      `sensorsAndLiveData-${serviceId}`,
      JSON.stringify(newDetails)
    );

    // Optionally, show a message that the details were saved
    setSavedSensorsAndLiveMessage("Sensors and Live Data Details Saved!");
  };

  // Handle save functionality for fluid levels
  const handleSaveFluidLevels = () => {
    // Prepare the fluid levels data to save
    const fluidLevelsDetails = {
      isToggledFluidLevel1,
      isToggledFluidLevel2,
      isToggledFluidLevel3,
      isToggledFluidLevel4,
      isToggledFluidLevel5,
      isToggledFluidLevel6,
      isToggledFluidLevel7,
      isToggledFluidLevel8,
      isToggledFluidLevel9,
      isToggledFluidLevel10,
      isToggledFluidLevel11,
      percentageValue, // Save the percentage value
    };

    // Save to localStorage
    localStorage.setItem(
      `fluidLevelsDetails-${serviceId}`,
      JSON.stringify(fluidLevelsDetails)
    );

    // Update the state to show the saved message
    setSavedFluidLevelsMessage("Fluid Level Details Saved!");
  };

  // Handle save functionality for car core details
  const handleSaveCarCoreDetails = () => {
    // Prepare the details to save
    const carCoreDetails = {
      selectedConditionCarsCore1,
      selectedConditionCarsCore2,
      selectedConditionCarsCore3,
      selectedConditionCarsCore4,
      selectedConditionCarsCore5,
      selectedConditionCarsCore6,
      selectedConditionCarsCore7,
      selectedConditionCarsCore8,
      selectedConditionCarsCore9,
      selectedConditionCarsCore10,
      selectedConditionCarsCore11,
      selectedConditionCarsCore12,
      writtenConditionCarsCore1,
      writtenConditionCarsCore2,
    };

    // Save to localStorage
    localStorage.setItem(
      `carCoreDetails-${serviceId}`,
      JSON.stringify(carCoreDetails)
    );

    // Update the state to show the saved message
    setSavedCarCoreMessage("Car Core Details Saved!");
  };

  // Handle save functionality for payment details
  const handleSavePaymentDetails = () => {
    // Prepare the details to save
    const paymentDetails = {
      selectedPaymentMethod,
      paymentAmount,
    };

    // Save to localStorage
    localStorage.setItem(
      `paymentDetails-${serviceId}`,
      JSON.stringify(paymentDetails)
    );

    // Update the state to show the saved message
    setSavedPaymentMessage("Payment Details Saved!");
  };

  // Retrieve saved data for both basic and paint/body details
  useEffect(() => {
    // Load saved basic details
    const savedBasicDetails = localStorage.getItem(`basicDetails-${serviceId}`);
    if (savedBasicDetails) {
      const details = JSON.parse(savedBasicDetails);
      setVinNumber(details.vinNumber);
      setEngineNumber(details.engineNumber);
      setTransmission(details.transmission);
      setEmissionType(details.emissionType);
      setOdometerBasic(details.odometerBasic);
      setKeysBasic(details.keysBasic);
      setSelectedButton(details.dealerShowroom);
    }

    // Load saved paint/body details
    const savedPaintBodyDetails = localStorage.getItem(
      `paintBodyDetails-${serviceId}`
    );
    if (savedPaintBodyDetails) {
      const paintBodyDetails = JSON.parse(savedPaintBodyDetails);
      setSelectedButtonB(paintBodyDetails.selectedButtonB);
      setValuesB(paintBodyDetails.valueB);
      setIssueB(paintBodyDetails.issueB);
      setSelectedButtonFB(paintBodyDetails.selectedButtonFB);
      setValuesFB(paintBodyDetails.valueFB);
      setIssueFB(paintBodyDetails.issueFB);
      setSelectedButtonFRQP(paintBodyDetails.selectedButtonFRQP);
      setValuesFRQP(paintBodyDetails.valueFRQP);
      setIssueFRQP(paintBodyDetails.issueFRQP);
      setSelectedButtonFD(paintBodyDetails.selectedButtonFD);
      setValuesFD(paintBodyDetails.valueFD);
      setIssueFD(paintBodyDetails.issueFD);
      setSelectedButtonRRD(paintBodyDetails.selectedButtonRRD);
      setValuesRRD(paintBodyDetails.valueRRD);
      setIssueRRD(paintBodyDetails.issueRRD);
      setSelectedButtonRRQP(paintBodyDetails.selectedButtonRRQP);
      setValuesRRQP(paintBodyDetails.valueRRQP);
      setIssueRRQP(paintBodyDetails.issueRRQP);
      setSelectedButtonBT(paintBodyDetails.selectedButtonBT);
      setValuesBT(paintBodyDetails.valueBT);
      setIssueBT(paintBodyDetails.issueBT);
      setSelectedButtonFLF(paintBodyDetails.selectedButtonFLF);
      setValuesFLF(paintBodyDetails.valueFLF);
      setIssueFLF(paintBodyDetails.issueFLF);
      setSelectedButtonFLDS(paintBodyDetails.selectedButtonFLDS);
      setValuesFLDS(paintBodyDetails.valueFLDS);
      setIssueFLDS(paintBodyDetails.issueFLDS);
      setSelectedButtonRLDS(paintBodyDetails.selectedButtonRLDS);
      setValuesRLDS(paintBodyDetails.valueRLDS);
      setIssueRLDS(paintBodyDetails.issueRLDS);
      setSelectedButtonRLQPS(paintBodyDetails.selectedButtonRLQPS);
      setValuesRLQPSS(paintBodyDetails.valueRLQPS);
      setSelectedConditionRLQPS(paintBodyDetails.selectedConditionRLQPS);
      setOtherValueRLQPS(paintBodyDetails.otherValueRLQPS);
      setSelectedButtonRF(paintBodyDetails.selectedButtonRF);
      setSelectedConditionRF(paintBodyDetails.selectedConditionRF);
      setValuesRF(paintBodyDetails.valueRF);
      setOtherValueRF(paintBodyDetails.otherValueRF);
      setSelectedConditionSensor1(paintBodyDetails.selectedConditionSensor1);
      setSelectedConditionSensor2(paintBodyDetails.selectedConditionSensor2);
      setSelectedButtonRB(paintBodyDetails.selectedButtonRB); 
      setValuesRB(paintBodyDetails.valueRB);
      setIssueRB(paintBodyDetails.issueRB);     
      // setIsOtherSelectedSensor1(paintBodyDetails.isOtherSelectedSensor1);
      // setIsOtherSelectedSensor2(paintBodyDetails.isOtherSelectedSensor2);
    }

    // Load saved carpet details
    const savedCarpetDetails = localStorage.getItem(
      `carpetDetails-${serviceId}`
    );
    if (savedCarpetDetails) {
      const carpetDetails = JSON.parse(savedCarpetDetails);
      setSelectedButtonDS(carpetDetails.selectedButtonDS);
      setSelectedConditionDS(carpetDetails.selectedConditionDS);
      setSelectedButtonCDS(carpetDetails.selectedButtonCDS);
      setSelectedConditionCDS(carpetDetails.selectedConditionCDS);
      setSelectedButtonDRS(carpetDetails.selectedButtonDRS);
      setSelectedConditionDRS(carpetDetails.selectedConditionDRS);
      setSelectedButtonCDRS(carpetDetails.selectedButtonCDRS);
      setSelectedConditionCDRS(carpetDetails.selectedConditionCDRS);
      setSelectedButtonBI(carpetDetails.selectedButtonBI);
      setSelectedConditionBI(carpetDetails.selectedConditionBI);
    }

    // Load saved flushes and gaps details
    const savedFlushesAndGapsDetails = localStorage.getItem(
      `flushesAndGapsDetails-${serviceId}`
    );
    if (savedFlushesAndGapsDetails) {
      const details = JSON.parse(savedFlushesAndGapsDetails);
      // Set the saved values into state variables
      setSelectedButtonRO(details.selectedButtonRO);
      setSelectedButtonGO(details.selectedButtonGO);
      setValueGRT1(details.valueGRT1);
      setValueGRD1(details.valueGRD1);
      setSelectedButtonBL(details.selectedButtonBL);
      setSelectedButtonGOBL(details.selectedButtonGOBL);
      setValueGRT2(details.valueGRT2);
      setValueGRD2(details.valueGRD2);
      setSelectedButtonFRD(details.selectedButtonFRD);
      setSelectedButtonGOFRD(details.selectedButtonGOFRD);
      setValueGRT3(details.valueGRT3);
      setValueGRD3(details.valueGRD3);
      setSelectedButtonFLD(details.selectedButtonFLD);
      setSelectedButtonGOFLD(details.selectedButtonGOFLD);
      setValueGRT4(details.valueGRT4);
      setValueGRD4(details.valueGRD4);
      setSelectedButtonRRDR(details.selectedButtonRRDR);
      setSelectedButtonGORRDR(details.selectedButtonGORRDR);
      setValueGRT5(details.valueGRT5);
      setValueGRD5(details.valueGRD5);
      setSelectedButtonRRLR(details.selectedButtonRRLR);
      setSelectedButtonGORRLD(details.selectedButtonGORRLD);
      setValueGRT6(details.valueGRT6);
      setValueGRD6(details.valueGRD6);
      setSelectedButtonBRR(details.selectedButtonBRR);
      setSelectedButtonGOBR(details.selectedButtonGOBR);
      setValueGRT7(details.valueGRT7);
      setValueGRD7(details.valueGRD7);
      setSelectedButtonBRT(details.selectedButtonBRT);
      setSelectedButtonGOBT(details.selectedButtonGOBT);
      setValueGRT8(details.valueGRT8);
      setValueGRD8(details.valueGRD8);
    }

    // Get the saved plastic panel details from localStorage
    const savedPlasticPanelDetails = localStorage.getItem(
      `plasticPanelDetails-${serviceId}`
    );

    // If the data exists in localStorage
    if (savedPlasticPanelDetails) {
      const details = JSON.parse(savedPlasticPanelDetails);
      // Set the saved values into the corresponding state variables
      setSelectedConditionPDS(details.selectedConditionPDS);
      setSelectedConditionPCDS(details.selectedConditionPCDS);
      setSelectedConditionPDRS(details.selectedConditionPDRS);
      setSelectedConditionPCDRS(details.selectedConditionPCDRS);
      setSelectedConditionBIS(details.selectedConditionBIS);
      setSelectedConditionD(details.selectedConditionD);
      setSelectedConditionGC(details.selectedConditionGC);
    }

    // Load saved rubber components details
    const savedRubberComponentsDetails = localStorage.getItem(
      `rubberComponentsDetails-${serviceId}`
    );
    if (savedRubberComponentsDetails) {
      const details = JSON.parse(savedRubberComponentsDetails);
      setIsToggled(details.isToggled);
      setSelectedConditionRC1(details.selectedConditionRC1);
      setIsToggledBRLD(details.isToggledBRLD);
      setSelectedConditionRC2(details.selectedConditionRC2);
      setIsToggledBB(details.isToggledBB);
      setSelectedConditionRC3(details.selectedConditionRC3);
      setIsToggledBRRD(details.isToggledBRRD);
      setSelectedConditionRC4(details.selectedConditionRC4);
      setIsToggledBFRD(details.isToggledBFRD);
      setSelectedConditionRC5(details.selectedConditionRC5);
      setIsToggledFUB(details.isToggledFUB);
      setSelectedConditionRC6(details.selectedConditionRC6);
    }

    // Load saved seat and observations details
    const savedSeatAndObservationsDetails = localStorage.getItem(
      `seatAndObservationsDetails-${serviceId}`
    );
    if (savedSeatAndObservationsDetails) {
      const details = JSON.parse(savedSeatAndObservationsDetails);
      setSelectedButtonSDS(details.selectedConditionSDS);
      setSelectedButtonSCDS(details.selectedConditionSCDS);
      setSelectedButtonSDRS(details.selectedConditionSDRS);
      setSelectedButtonSCDRS(details.selectedConditionSCDRS);
      setSelectedButtonHR(details.selectedConditionHR);
      setSelectedButtonCHR(details.selectedConditionCHR);
      setSelectedButtonRHR(details.selectedConditionRHR);
      setSelectedButtonHCDR(details.selectedConditionHCDR);
      setIsToggledIS(details.isToggledIS);
      setSelectedConditionIS(details.selectedConditionIS);
      setIsToggledSASQ(details.isToggledSASQ);
      setSelectedConditionSASQ(details.selectedConditionSASQ);
      setIsToggledPW(details.isToggledPW);
      setSelectedConditionPW(details.selectedConditionPW);
      setIsToggledGC(details.isToggledGC);
      setSelectedConditionGCO(details.selectedConditionGCO);
      setIsToggledCQ(details.isToggledCQ);
      setSelectedConditionCQ(details.selectedConditionCQ);
    }

    // Load saved glass and mirrors details
    const savedGlassAndMirrorsDetails = localStorage.getItem(
      `glassAndMirrorsDetails-${serviceId}`
    );
    if (savedGlassAndMirrorsDetails) {
      const glassAndMirrorsDetails = JSON.parse(savedGlassAndMirrorsDetails);
      setIsToggledFW(glassAndMirrorsDetails.isToggledFW);
      setIsToggledFWL(glassAndMirrorsDetails.isToggledFWL);
      setIsToggledFWR(glassAndMirrorsDetails.isToggledFWR);
      setIsToggledL(glassAndMirrorsDetails.isToggledL);
      setIsToggledFRDGW(glassAndMirrorsDetails.isToggledFRDGW);
      setIsToggledFRORVMG(glassAndMirrorsDetails.isToggledFRORVMG);
      setIsToggledRRDW(glassAndMirrorsDetails.isToggledRRDW);
      setIsToggledRWGD(glassAndMirrorsDetails.isToggledRWGD);
      setIsToggledRW(glassAndMirrorsDetails.isToggledRW);
      setIsToggledRLDWN(glassAndMirrorsDetails.isToggledRLDWN);
      setIsToggledFLDWN(glassAndMirrorsDetails.isToggledFLDWN);
      setIsToggledSR(glassAndMirrorsDetails.isToggledSR);
      setSelectedConditionGM1(glassAndMirrorsDetails.selectedConditionGM1);
      setSelectedConditionGM2(glassAndMirrorsDetails.selectedConditionGM2);
      setSelectedConditionGM3(glassAndMirrorsDetails.selectedConditionGM3);
      setSelectedConditionGM4(glassAndMirrorsDetails.selectedConditionGM4);
      setSelectedConditionGM5(glassAndMirrorsDetails.selectedConditionGM5);
      setSelectedConditionGM6(glassAndMirrorsDetails.selectedConditionGM6);
      setSelectedConditionGM7(glassAndMirrorsDetails.selectedConditionGM7);
      setSelectedConditionGM8(glassAndMirrorsDetails.selectedConditionGM8);
      setSelectedConditionGM9(glassAndMirrorsDetails.selectedConditionGM9);
      setSelectedConditionGM10(glassAndMirrorsDetails.selectedConditionGM10);
      setSelectedConditionGM11(glassAndMirrorsDetails.selectedConditionGM11);
      setSelectedConditionGM12(glassAndMirrorsDetails.selectedConditionGM12);
      setSelectedConditionGM13(glassAndMirrorsDetails.selectedConditionGM13);
      setSelectedConditionGM14(glassAndMirrorsDetails.selectedConditionGM14);
      setSelectedConditionGM15(glassAndMirrorsDetails.selectedConditionGM15);
      setSelectedConditionGM16(glassAndMirrorsDetails.selectedConditionGM16);
      setSelectedConditionGM17(glassAndMirrorsDetails.selectedConditionGM17);
      setSelectedConditionGM18(glassAndMirrorsDetails.selectedConditionGM18);
      setSelectedConditionGM19(glassAndMirrorsDetails.selectedConditionGM19);
      setSelectedConditionGM20(glassAndMirrorsDetails.selectedConditionGM20);
      setSelectedConditionGM21(glassAndMirrorsDetails.selectedConditionGM21);
      // setWrittenConditionGM1(glassAndMirrorsDetails.writtenConditionGM1);
      // setWrittenConditionGM2(glassAndMirrorsDetails.writtenConditionGM2);
      // setWrittenConditionGM3(glassAndMirrorsDetails.writtenConditionGM3);
      // setWrittenConditionGM4(glassAndMirrorsDetails.writtenConditionGM4);
      // setWrittenConditionGM5(glassAndMirrorsDetails.writtenConditionGM5);
      // setWrittenConditionGM6(glassAndMirrorsDetails.writtenConditionGM6);
      // setWrittenConditionGM7(glassAndMirrorsDetails.writtenConditionGM7);
      // setWrittenConditionGM8(glassAndMirrorsDetails.writtenConditionGM8);
      // setWrittenConditionGM9(glassAndMirrorsDetails.writtenConditionGM9);
    }

    // Load saved tyres details
    const savedTyresDetails = localStorage.getItem(`tyresDetails-${serviceId}`);
    if (savedTyresDetails) {
      const tyresDetails = JSON.parse(savedTyresDetails);
      setBrandT(tyresDetails.BrandT);
      setBrandTv(tyresDetails.BrandTv);
      setSelectedConditionSTS(tyresDetails.selectedConditionSTS);
      setBrandTRFR(tyresDetails.BrandTRFR);
      setSelectedConditionDOTFT(tyresDetails.selectedConditionDOTFT);
      setSelectedConditionFT(tyresDetails.selectedConditionFT);
      setBrandRT(tyresDetails.BrandRT);
      setVarientRT(tyresDetails.VarientRT);
      setSelectedConditionRT(tyresDetails.selectedConditionRT);
      setTDRT(tyresDetails.TDRT);
      setSelectedConditionDOTRT(tyresDetails.selectedConditionDOTRT);
      setSelectedConditionRTN(tyresDetails.selectedConditionRTN);
      setBrandRL(tyresDetails.BrandRL);
      setVarientRL(tyresDetails.VarientRL);
      setSelectedConditionRL(tyresDetails.selectedConditionRL);
      setRLTrend(tyresDetails.RLTrend);
      setSelectedConditionDOTRL(tyresDetails.selectedConditionDOTRL);
      setSelectedConditionRLN(tyresDetails.selectedConditionRLN);
      setBrandFLN(tyresDetails.BrandFLN);
      setVarientFLN(tyresDetails.VarientFLN);
      setSelectedConditionFLN(tyresDetails.selectedConditionFLN);
      setFLN(tyresDetails.FLN);
      setSelectedConditionDOTFLN(tyresDetails.selectedConditionDOTFLN);
      setSelectedConditionFLNT(tyresDetails.selectedConditionFLNT);
      setBrandSpare(tyresDetails.BrandSpare);
      setSpare(tyresDetails.Spare);
      setVarientSpare(tyresDetails.VarientSpare);
      setSelectedConditionSpare(tyresDetails.selectedConditionSpare);
      setSelectedConditionDOTSpare(tyresDetails.selectedConditionDOTSpare);
      setSelectedConditionSparen(tyresDetails.selectedConditionSparen);
    }

    const savedDetails = localStorage.getItem(
      `sensorsAndLiveData-${serviceId}`
    );
    if (savedDetails) {
      const details = JSON.parse(savedDetails);
      setErrorCodes(details.errorCodes || []);
      setBatteryEnergy(details.BatteryEnergy || "");
      setLoadEngine(details.LoadEngine || "");
      setIdleRPM(details.idleRPM || "");
      setDistKMS(details.distKMS || "");
      setDistCKMS(details.distCKMS || "");
      setIsToggledEngineCrack(details.isToggledEngineCrack || false);
      setIsToggledWarning(details.isToggledWarning || false);
      setIsToggledSuspicious(details.isToggledSuspicious || false);
      setIsToggledSmoke(details.isToggledSmoke || false);
      setIsToggledGearshift(details.isToggledGearshift || false);
      setIsToggledBreak(details.isToggledBreak || false);
      setIsToggledSteering(details.isToggledSteering || false);
      setIsToggledHandbreak(details.isToggledHandbreak || false);
      setIsToggledReverse(details.isToggledReverse || false);
      setIsToggledSmooth(details.isToggledSmooth || false);
    }

    // Load saved fluid levels and percentage values
    const savedFluidLevelsDetails = localStorage.getItem(
      `fluidLevelsDetails-${serviceId}`
    );
    if (savedFluidLevelsDetails) {
      const fluidDetails = JSON.parse(savedFluidLevelsDetails);
      setIsToggledFluidLevel1(fluidDetails.isToggledFluidLevel1);
      setIsToggledFluidLevel2(fluidDetails.isToggledFluidLevel2);
      setIsToggledFluidLevel3(fluidDetails.isToggledFluidLevel3);
      setIsToggledFluidLevel4(fluidDetails.isToggledFluidLevel4);
      setIsToggledFluidLevel5(fluidDetails.isToggledFluidLevel5);
      setIsToggledFluidLevel6(fluidDetails.isToggledFluidLevel6);
      setIsToggledFluidLevel7(fluidDetails.isToggledFluidLevel7);
      setIsToggledFluidLevel8(fluidDetails.isToggledFluidLevel8);
      setIsToggledFluidLevel9(fluidDetails.isToggledFluidLevel9);
      setIsToggledFluidLevel10(fluidDetails.isToggledFluidLevel10);
      setIsToggledFluidLevel11(fluidDetails.isToggledFluidLevel11);

      setPercentageValue(fluidDetails.percentageValue);
    }

    // Load saved car core details
    const savedCarCoreDetails = localStorage.getItem(
      `carCoreDetails-${serviceId}`
    );
    if (savedCarCoreDetails) {
      const carCore = JSON.parse(savedCarCoreDetails);
      setSelectedConditionCarsCore1(carCore.selectedConditionCarsCore1);
      setSelectedConditionCarsCore2(carCore.selectedConditionCarsCore2);
      setSelectedConditionCarsCore3(carCore.selectedConditionCarsCore3);
      setSelectedConditionCarsCore4(carCore.selectedConditionCarsCore4);
      setSelectedConditionCarsCore5(carCore.selectedConditionCarsCore5);
      setSelectedConditionCarsCore6(carCore.selectedConditionCarsCore6);
      setSelectedConditionCarsCore7(carCore.selectedConditionCarsCore7);
      setSelectedConditionCarsCore8(carCore.selectedConditionCarsCore8);
      setSelectedConditionCarsCore9(carCore.selectedConditionCarsCore9);
      setSelectedConditionCarsCore10(carCore.selectedConditionCarsCore10);
      setSelectedConditionCarsCore11(carCore.selectedConditionCarsCore11);
      setSelectedConditionCarsCore12(carCore.selectedConditionCarsCore12);
      setWrittenConditionCarsCore1(carCore.writtenConditionCarsCore1);
      setWrittenConditionCarsCore2(carCore.writtenConditionCarsCore2);
    }

    // Load saved payment details
    const savedPaymentDetails = localStorage.getItem(
      `paymentDetails-${serviceId}`
    );
    if (savedPaymentDetails) {
      const paymentDetails = JSON.parse(savedPaymentDetails);
      setSelectedPaymentMethod(paymentDetails.selectedPaymentMethod);
      setPaymentAmount(paymentDetails.paymentAmount);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setServiceData((prev) => ({ ...prev, [name]: value }));
    setSensorCode(e.target.value);
  };

  const handleSelectChange = (e) => {
    const { value } = e.target;
    setSelectedConditionSensor(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsOtherSelectedSensor(true); // Show the input field for custom condition
    } else {
      setIsOtherSelectedSensor(false); // Hide the input field
      setOtherValueSensor(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectChangePaintBody1 = (e) => {
    const { value } = e.target;
    setSelectedConditionSensor1(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsOtherSelectedSensor1(true); // Show the input field for custom condition
    } else {
      setIsOtherSelectedSensor1(false); // Hide the input field
      setOtherValueRLQPS(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectChangePaintBody2 = (e) => {
    const { value } = e.target;
    setSelectedConditionSensor2(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsOtherSelectedSensor2(true); // Show the input field for custom condition
    } else {
      setIsOtherSelectedSensor2(false); // Hide the input field
      setOtherValueRF(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectCarsCore1 = (event) => {
    const value = event.target.value;
    setSelectedConditionCarsCore11(value);
    setIsSelectedConditionCarsCore1(value === "Others");
  };

  const handleSelectCarsCore2 = (event) => {
    const value = event.target.value;
    setSelectedConditionCarsCore12(value);
    setIsSelectedConditionCarsCore2(value === "Others");
  };

  const handleSelectedConditionGM1 = (e) => {
    const { value } = e.target;
    setSelectedConditionGM1(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsSelectedConditionGM1(true); // Show the input field for custom condition
    } else {
      setIsSelectedConditionGM1(false); // Hide the input field
      setWrittenConditionGM1(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectedConditionGM2 = (e) => {
    const { value } = e.target;
    setSelectedConditionGM2(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsSelectedConditionGM2(true); // Show the input field for custom condition
    } else {
      setIsSelectedConditionGM2(false); // Hide the input field
      setWrittenConditionGM2(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectedConditionGM3 = (e) => {
    const { value } = e.target;
    setSelectedConditionGM3(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsSelectedConditionGM3(true); // Show the input field for custom condition
    } else {
      setIsSelectedConditionGM3(false); // Hide the input field
      setWrittenConditionGM3(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectedConditionGM4 = (e) => {
    const { value } = e.target;
    setSelectedConditionGM4(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsSelectedConditionGM4(true); // Show the input field for custom condition
    } else {
      setIsSelectedConditionGM4(false); // Hide the input field
      setWrittenConditionGM4(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectedConditionGM5 = (e) => {
    const { value } = e.target;
    setSelectedConditionGM5(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsSelectedConditionGM5(true); // Show the input field for custom condition
    } else {
      setIsSelectedConditionGM5(false); // Hide the input field
      setWrittenConditionGM5(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectedConditionGM6 = (e) => {
    const { value } = e.target;
    setSelectedConditionGM6(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsSelectedConditionGM6(true); // Show the input field for custom condition
    } else {
      setIsSelectedConditionGM6(false); // Hide the input field
      setWrittenConditionGM6(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectedConditionGM7 = (e) => {
    const { value } = e.target;
    setSelectedConditionGM7(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsSelectedConditionGM7(true); // Show the input field for custom condition
    } else {
      setIsSelectedConditionGM7(false); // Hide the input field
      setWrittenConditionGM7(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectedConditionGM8 = (e) => {
    const { value } = e.target;
    setSelectedConditionGM8(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsSelectedConditionGM8(true); // Show the input field for custom condition
    } else {
      setIsSelectedConditionGM8(false); // Hide the input field
      setWrittenConditionGM8(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleSelectedConditionGM9 = (e) => {
    const { value } = e.target;
    setSelectedConditionGM9(value);

    // Check if "Others" is selected
    if (value === "Others") {
      setIsSelectedConditionGM9(true); // Show the input field for custom condition
    } else {
      setIsSelectedConditionGM9(false); // Hide the input field
      setWrittenConditionGM9(""); // Reset the custom condition if a predefined option is selected
    }
  };

  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName); // Update selected button
  };

  const handleClick = (option) => {
    setSelected(option);
  };

  // Load saved report data from localStorage on initial load
  useEffect(() => {
    const savedData = localStorage.getItem(`reportData_${serviceId}`);
    if (savedData) {
      const parsed = JSON.parse(savedData);
      setReportData(parsed);
      hydrateRemarks(parsed);
    }
  }, [serviceId]);

  // Function to handle the status update
  const handleConfirm = async () => {
    if (isChecked) {
      try {
        // Update service status to "arrived"
        await axios.patch(`${API_URL}/api/services/${serviceId}/status`, {
          status: "Arrived", // Send the status update
        });

        // After updating, fetch the updated status
        const response = await axios.get(
          `${API_URL}/api/services/${serviceId}`
        );
        setStatus(response.data.service.status); // Update local status state with the latest status
      } catch (error) {
        console.error("Error updating status:", error);
      }
    } else {
      alert("Please confirm your arrival first");
    }
  };

  const handlePaymentChange = (e) => {
    setPaymentAmount(e.target.value);
  };

  const handleFormSubmitPreview = async () => {
    try {
      // Step 1: Validate reportData to ensure all required fields are filled
      // const requiredFields = [
      //   "vehicleCondition",
      //   "address",
      //   "allottedVin",
      //   "variant",
      //   "vehicleModel",
      //   "date",
      //   "technicianName",
      //   "customerName",
      //   "customerPhone",
      //   "inspectionType",
      // ];

      // // Loop through required fields and check for any missing values
      // for (const field of requiredFields) {
      //   if (!reportData[field]) {
      //     alert(`Field ${field} is required. Please fill it in.`);
      //     return;
      //   }
      // }

      // Step 2: Prepare the report data to be submitted
      const remarks = prepareRemarks();
      const pdiReportData = {
        serviceId: serviceId,
        technicianId: serviceData.technicianId,
        userId: serviceData.userId,
        inspectionType: serviceData?.inspectionType,
        customerName: serviceData?.customerName,
        date: serviceData?.deliveryDate,
        vehicleModel: serviceData?.vehicleModel,
        variant: serviceData?.variant,
        allottedVin: serviceData?.allottedVin,
        address: serviceData?.address,
        customerPhone: serviceData?.customerPhone,
        vehicleImageUrl: serviceData.vehicleImageUrl,
        technicianName,
        vinNumber,
        engineNumber,
        emissionType,
        transmission,
        odometerBasic,
        keysBasic,
        selectedButton,
        selectedButtonB,
        valueB,
        issueB,
        selectedButtonFB,
        valueFB,
        issueFB,
        selectedButtonFRQP,
        valueFRQP,
        issueFRQP,
        selectedButtonFD,
        valueFD,
        issueFD,
        selectedButtonRRD,
        valueRRD,
        issueRRD,
        selectedButtonRRQP,
        valueRRQP,
        issueRRQP,
        selectedButtonBT,
        valueBT,
        issueBT,
        selectedButtonFLF,
        valueFLF,
        issueFLF,
        selectedButtonFLDS,
        valueFLDS,
        issueFLDS,
        selectedButtonRLDS,
        valueRLDS,
        issueRLDS,
        selectedButtonRLQPS,
        valueRLQPS,
        selectedConditionRLQPS,
        otherValueRLQPS,
        selectedButtonRF,
        selectConditionRF,
        valueRF,
        otherValueRF,
        selectedConditionSensor1,
        selectedConditionSensor2,
        selectedButtonRB,
        valueRB,
        issueRB,         
        selectedButtonDS,
        selectedConditionDS,
        selectedButtonCDS,
        selectedConditionCDS,
        selectedButtonDRS,
        selectedConditionDRS,
        selectedButtonCDRS,
        selectedConditionCDRS,
        selectedButtonBI,
        selectedConditionBI,
        selectedButtonRO,
        selectedButtonGO,
        valueGRT1,
        valueGRD1,
        selectedButtonBL,
        selectedButtonGOBL,
        valueGRT2,
        valueGRD2,
        selectedButtonFRD,
        selectedButtonGOFRD,
        valueGRT3,
        valueGRD3,
        selectedButtonFLD,
        selectedButtonGOFLD,
        valueGRT4,
        valueGRD4,
        selectedButtonRRDR,
        selectedButtonGORRDR,
        valueGRT5,
        valueGRD5,
        selectedButtonRRLR,
        selectedButtonGORRLD,
        valueGRT6,
        valueGRD6,
        selectedButtonBRR,
        selectedButtonGOBR,
        valueGRT7,
        valueGRD7,
        selectedButtonBRT,
        selectedButtonGOBT,
        valueGRT8,
        valueGRD8,
        selectedConditionPDS,
        selectedConditionPCDS,
        selectedConditionPDRS,
        selectedConditionPCDRS,
        selectedConditionBIS,
        selectedConditionD,
        selectedConditionGC,
        isToggled,
        selectedConditionRC1,
        isToggledBRLD,
        selectedConditionRC2,
        isToggledBB,
        selectedConditionRC3,
        isToggledBRRD,
        selectedConditionRC4,
        isToggledBFRD,
        selectedConditionRC5,
        isToggledFUB,
        selectedConditionRC6,
        selectedConditionSDS,
        selectedConditionSCDS,
        selectedConditionSDRS,
        selectedConditionSCDRS,
        selectedConditionHR,
        selectedConditionCHR,
        selectedConditionRHR,
        selectedConditionHCDR,
        isToggledIS,
        selectedConditionIS,
        isToggledSASQ,
        selectedConditionSASQ,
        isToggledPW,
        selectedConditionPW,
        isToggledGC,
        selectedConditionGCO,
        isToggledCQ,
        selectedConditionCQ,
        isToggledFW,
        isToggledFWL,
        isToggledFWR,
        isToggledL,
        isToggledFRDGW,
        isToggledFRORVMG,
        isToggledRRDW,
        isToggledRWGD,
        isToggledRW,
        isToggledRLDWN,
        isToggledFLDWN,
        isToggledSR,
        selectedConditionGM1,
        selectedConditionGM2,
        selectedConditionGM3,
        selectedConditionGM4,
        selectedConditionGM5,
        selectedConditionGM6,
        selectedConditionGM7,
        selectedConditionGM8,
        selectedConditionGM9,
        selectedConditionGM10,
        selectedConditionGM11,
        selectedConditionGM12,
        selectedConditionGM13,
        selectedConditionGM14,
        selectedConditionGM15,
        selectedConditionGM16,
        selectedConditionGM17,
        selectedConditionGM18,
        selectedConditionGM19,
        selectedConditionGM20,
        selectedConditionGM21,
        BrandT,
        BrandTv,
        selectedConditionSTS,
        BrandTRFR,
        selectedConditionDOTFT,
        selectedConditionFT,
        BrandRT,
        VarientRT,
        selectedConditionRT,
        TDRT,
        selectedConditionDOTRT,
        selectedConditionRTN,
        BrandRL,
        VarientRL,
        selectedConditionRL,
        RLTrend,
        selectedConditionDOTRL,
        selectedConditionRLN,
        BrandFLN,
        VarientFLN,
        selectedConditionFLN,
        FLN,
        selectedConditionDOTFLN,
        selectedConditionFLNT,
        BrandSpare,
        Spare,
        VarientSpare,
        selectedConditionSpare,
        selectedConditionDOTSpare,
        selectedConditionSparen,
        errorCodes,
        BatteryEnergy,
        LoadEngine,
        idleRPM,
        distKMS,
        distCKMS,
        isToggledEngineCrack,
        isToggledWarning,
        isToggledSuspicious,
        isToggledSmoke,
        isToggledGearshift,
        isToggledBreak,
        isToggledSteering,
        isToggledHandbreak,
        isToggledReverse,
        isToggledSmooth,
        isToggledFluidLevel1,
        isToggledFluidLevel2,
        isToggledFluidLevel3,
        isToggledFluidLevel4,
        isToggledFluidLevel5,
        isToggledFluidLevel6,
        isToggledFluidLevel7,
        isToggledFluidLevel8,
        isToggledFluidLevel9,
        isToggledFluidLevel10,
        isToggledFluidLevel11,
        percentageValue,
        selectedConditionCarsCore1,
        selectedConditionCarsCore2,
        selectedConditionCarsCore3,
        selectedConditionCarsCore4,
        selectedConditionCarsCore5,
        selectedConditionCarsCore6,
        selectedConditionCarsCore7,
        selectedConditionCarsCore8,
        selectedConditionCarsCore9,
        selectedConditionCarsCore10,
        selectedConditionCarsCore11,
        selectedConditionCarsCore12,
        writtenConditionCarsCore1,
        writtenConditionCarsCore2,
        selectedPaymentMethod,
        paymentAmount,
        finalObservations: remarks.finalObservations,
        technicianRemarks: remarks.field,
        basicFile1,
        basicFile2,
        basicFile3,
        basicFile4,
        paintBodyFile1,
        paintBodyFile2,
        paintBodyFile3,
        paintBodyFile4,
        paintBodyFile5,
        paintBodyFile6,
        paintBodyFile7,
        paintBodyFile8,
        paintBodyFile9,
        paintBodyFile10,
        paintBodyFile11,
        paintBodyFile12,
        paintBodyFile13,
        carpetFile1,
        carpetFile2,
        carpetFile3,
        carpetFile4,
        carpetFile5,
        plasticPanelFile1,
        plasticPanelFile2,
        plasticPanelFile3,
        plasticPanelFile4,
        plasticPanelFile5,
        plasticPanelFile6,
        plasticPanelFile7,
        rubberComponentFile1,
        rubberComponentFile2,
        rubberComponentFile3,
        rubberComponentFile4,
        rubberComponentFile5,
        rubberComponentFile6,
        seatFile1,
        seatFile2,
        seatFile3,
        seatFile4,
        seatFile5,
        seatFile6,
        seatFile7,
        seatFile8,
        glassMirrorFile1,
        glassMirrorFile2,
        glassMirrorFile3,
        glassMirrorFile4,
        glassMirrorFile5,
        glassMirrorFile6,
        glassMirrorFile7,
        glassMirrorFile8,
        glassMirrorFile9,
        glassMirrorFile10,
        glassMirrorFile11,
        glassMirrorFile12,
        tyreFile1,
        tyreFile2,
        tyreFile3,
        tyreFile4,
        tyreFile5,
      };

      // Step 3: Generate PDF from the TechnicianReportPDF component
      const pdfDoc = (
        <PdiPDF
          reportData={pdiReportData}
          serviceData={serviceData}
          carImageUrl={base64Image}
        />
      );
      const blob = await pdf(pdfDoc).toBlob();

      // Step 4: Download the generated PDF blob
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "job_report.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      alert("PDF downloaded successfully for testing.");

      // // Step 3: Generate PDF from the TechnicianReportPDF component
      // const pdfDoc = <TechnicianReportPDF reportData={reportData} serviceData={serviceData} />;
      // const blob = await pdf(pdfDoc).toBlob();

      // // Step 4: Create a FormData object for sending data
      // const formData = new FormData();
      // formData.append("pdiReportData", JSON.stringify(pdiReportData)); // Attach report data
      // formData.append("pdf", blob, "job_report.pdf"); // Attach PDF file

      // // Step 5: Send report data and PDF to backend
      // const response = await axios.post(
      //   `/api/pdi-reports/create`,
      //   formData,
      //   { headers: { "Content-Type": "multipart/form-data" } }
      // );

      // const pdiReportId = response.data.report._id;

      // // Step 6: If report is saved, update the service status with the report ID
      // if (pdiReportId) {
      //   await axios.patch(
      //     `${API_URL}/api/services/${serviceId}/status`,
      //     { pdiReportId }
      //   );
      //   setIsPdfGenerated(true);
      //   localStorage.removeItem(`reportData_${serviceId}`); // Clear saved data after submission
      // } else {
      //   alert("Failed to save the report and generate PDF. Please try again.");
      // }
    } catch (error) {
      alert("An error occurred while submitting the report. Please try again.");
      console.error("Error submitting PDI report:", error);
    }
  };

  const handleFormSubmit = async () => {
    setIsLoading(true)
    try {
      // Step 1: Validate reportData to ensure all required fields are filled (uncomment and complete if necessary)
      // const requiredFields = [...]; // Add your required fields
      // for (const field of requiredFields) {
      //   if (!reportData[field]) {
      //     alert(`Field ${field} is required. Please fill it in.`);
      //     return;
      //   }
      // }
  
      // Step 2: Prepare the report data to be submitted
      const remarks = prepareRemarks();
      const reportData = {
        inspectionType: serviceData?.inspectionType,
        customerName: serviceData?.customerName,
        date: serviceData?.deliveryDate,
        vehicleModel: serviceData?.vehicleModel,
        variant: serviceData?.variant,
        allottedVin: serviceData?.allottedVin,
        address: serviceData?.address,
        customerPhone: serviceData?.customerPhone,
        vehicleImageUrl: serviceData.vehicleImageUrl,
        technicianName,
        vinNumber,
        engineNumber,
        emissionType,
        transmission,
        odometerBasic,
        keysBasic,
        selectedButton,
        selectedButtonB,
        valueB,
        issueB,
        selectedButtonFB,
        valueFB,
        issueFB,
        selectedButtonFRQP,
        valueFRQP,
        issueFRQP,
        selectedButtonFD,
        valueFD,
        issueFD,
        selectedButtonRRD,
        valueRRD,
        issueRRD,
        selectedButtonRRQP,
        valueRRQP,
        issueRRQP,
        selectedButtonBT,
        valueBT,
        issueBT,
        selectedButtonFLF,
        valueFLF,
        issueFLF,
        selectedButtonFLDS,
        valueFLDS,
        issueFLDS,
        selectedButtonRLDS,
        valueRLDS,
        issueRLDS,
        selectedButtonRLQPS,
        valueRLQPS,
        selectedConditionRLQPS,
        otherValueRLQPS,
        selectedButtonRF,
        selectConditionRF,
        valueRF,
        otherValueRF,
        selectedConditionSensor1,
        selectedConditionSensor2,
        selectedButtonRB,
        valueRB,
        issueRB,        
        selectedButtonDS,
        selectedConditionDS,
        selectedButtonCDS,
        selectedConditionCDS,
        selectedButtonDRS,
        selectedConditionDRS,
        selectedButtonCDRS,
        selectedConditionCDRS,
        selectedButtonBI,
        selectedConditionBI,
        selectedButtonRO,
        selectedButtonGO,
        valueGRT1,
        valueGRD1,
        selectedButtonBL,
        selectedButtonGOBL,
        valueGRT2,
        valueGRD2,
        selectedButtonFRD,
        selectedButtonGOFRD,
        valueGRT3,
        valueGRD3,
        selectedButtonFLD,
        selectedButtonGOFLD,
        valueGRT4,
        valueGRD4,
        selectedButtonRRDR,
        selectedButtonGORRDR,
        valueGRT5,
        valueGRD5,
        selectedButtonRRLR,
        selectedButtonGORRLD,
        valueGRT6,
        valueGRD6,
        selectedButtonBRR,
        selectedButtonGOBR,
        valueGRT7,
        valueGRD7,
        selectedButtonBRT,
        selectedButtonGOBT,
        valueGRT8,
        valueGRD8,
        selectedConditionPDS,
        selectedConditionPCDS,
        selectedConditionPDRS,
        selectedConditionPCDRS,
        selectedConditionBIS,
        selectedConditionD,
        selectedConditionGC,
        isToggled,
        selectedConditionRC1,
        isToggledBRLD,
        selectedConditionRC2,
        isToggledBB,
        selectedConditionRC3,
        isToggledBRRD,
        selectedConditionRC4,
        isToggledBFRD,
        selectedConditionRC5,
        isToggledFUB,
        selectedConditionRC6,
        selectedConditionSDS,
        selectedConditionSCDS,
        selectedConditionSDRS,
        selectedConditionSCDRS,
        selectedConditionHR,
        selectedConditionCHR,
        selectedConditionRHR,
        selectedConditionHCDR,
        isToggledIS,
        selectedConditionIS,
        isToggledSASQ,
        selectedConditionSASQ,
        isToggledPW,
        selectedConditionPW,
        isToggledGC,
        selectedConditionGCO,
        isToggledCQ,
        selectedConditionCQ,
        isToggledFW,
        isToggledFWL,
        isToggledFWR,
        isToggledL,
        isToggledFRDGW,
        isToggledFRORVMG,
        isToggledRRDW,
        isToggledRWGD,
        isToggledRW,
        isToggledRLDWN,
        isToggledFLDWN,
        isToggledSR,
        selectedConditionGM1,
        selectedConditionGM2,
        selectedConditionGM3,
        selectedConditionGM4,
        selectedConditionGM5,
        selectedConditionGM6,
        selectedConditionGM7,
        selectedConditionGM8,
        selectedConditionGM9,
        selectedConditionGM10,
        selectedConditionGM11,
        selectedConditionGM12,
        selectedConditionGM13,
        selectedConditionGM14,
        selectedConditionGM15,
        selectedConditionGM16,
        selectedConditionGM17,
        selectedConditionGM18,
        selectedConditionGM19,
        selectedConditionGM20,
        selectedConditionGM21,
        BrandT,
        BrandTv,
        selectedConditionSTS,
        BrandTRFR,
        selectedConditionDOTFT,
        selectedConditionFT,
        BrandRT,
        VarientRT,
        selectedConditionRT,
        TDRT,
        selectedConditionDOTRT,
        selectedConditionRTN,
        BrandRL,
        VarientRL,
        selectedConditionRL,
        RLTrend,
        selectedConditionDOTRL,
        selectedConditionRLN,
        BrandFLN,
        VarientFLN,
        selectedConditionFLN,
        FLN,
        selectedConditionDOTFLN,
        selectedConditionFLNT,
        BrandSpare,
        Spare,
        VarientSpare,
        selectedConditionSpare,
        selectedConditionDOTSpare,
        selectedConditionSparen,
        errorCodes,
        BatteryEnergy,
        LoadEngine,
        idleRPM,
        distKMS,
        distCKMS,
        isToggledEngineCrack,
        isToggledWarning,
        isToggledSuspicious,
        isToggledSmoke,
        isToggledGearshift,
        isToggledBreak,
        isToggledSteering,
        isToggledHandbreak,
        isToggledReverse,
        isToggledSmooth,
        isToggledFluidLevel1,
        isToggledFluidLevel2,
        isToggledFluidLevel3,
        isToggledFluidLevel4,
        isToggledFluidLevel5,
        isToggledFluidLevel6,
        isToggledFluidLevel7,
        isToggledFluidLevel8,
        isToggledFluidLevel9,
        isToggledFluidLevel10,
        isToggledFluidLevel11,
        percentageValue,
        selectedConditionCarsCore1,
        selectedConditionCarsCore2,
        selectedConditionCarsCore3,
        selectedConditionCarsCore4,
        selectedConditionCarsCore5,
        selectedConditionCarsCore6,
        selectedConditionCarsCore7,
        selectedConditionCarsCore8,
        selectedConditionCarsCore9,
        selectedConditionCarsCore10,
        selectedConditionCarsCore11,
        selectedConditionCarsCore12,
        writtenConditionCarsCore1,
        writtenConditionCarsCore2,
        selectedPaymentMethod,
        paymentAmount,
        finalObservations: remarks.finalObservations,
        technicianRemarks: remarks.field,
        basicFile1,
        basicFile2,
        basicFile3,
        basicFile4,
        paintBodyFile1,
        paintBodyFile2,
        paintBodyFile3,
        paintBodyFile4,
        paintBodyFile5,
        paintBodyFile6,
        paintBodyFile7,
        paintBodyFile8,
        paintBodyFile9,
        paintBodyFile10,
        paintBodyFile11,
        paintBodyFile12,
        paintBodyFile13,
        carpetFile1,
        carpetFile2,
        carpetFile3,
        carpetFile4,
        carpetFile5,
        plasticPanelFile1,
        plasticPanelFile2,
        plasticPanelFile3,
        plasticPanelFile4,
        plasticPanelFile5,
        plasticPanelFile6,
        plasticPanelFile7,
        rubberComponentFile1,
        rubberComponentFile2,
        rubberComponentFile3,
        rubberComponentFile4,
        rubberComponentFile5,
        rubberComponentFile6,
        seatFile1,
        seatFile2,
        seatFile3,
        seatFile4,
        seatFile5,
        seatFile6,
        seatFile7,
        seatFile8,
        glassMirrorFile1,
        glassMirrorFile2,
        glassMirrorFile3,
        glassMirrorFile4,
        glassMirrorFile5,
        glassMirrorFile6,
        glassMirrorFile7,
        glassMirrorFile8,
        glassMirrorFile9,
        glassMirrorFile10,
        glassMirrorFile11,
        glassMirrorFile12,
        tyreFile1,
        tyreFile2,
        tyreFile3,
        tyreFile4,
        tyreFile5,
      };

      // Step 2: Create payload structure
      const payload = {
        serviceId,
        technicianId: serviceData.technicianId,
        userId: serviceData.userId,
        inspectionType: serviceData?.inspectionType, // Still include at top level
        reportData // Contains all inspection-specific data including inspectionType
      };      

      // Step 3: Generate PDF
      const pdfDoc = (
        <PdiPDF reportData={reportData} serviceData={serviceData} carImageUrl={base64Image} />
      );
      const blob = await pdf(pdfDoc).toBlob();

      // Step 4: Create FormData and append all files
      const formData = new FormData();
      
      // Append report data as JSON
      formData.append("pdiReportData", JSON.stringify(payload));
      
      // Append PDF file
      formData.append("pdf", blob, "job_report.pdf");
      
      // Append all image files with their field names
      const imageFields = [
        "basicFile1", "basicFile2", "basicFile3", "basicFile4",
        "paintBodyFile1", "paintBodyFile2", "paintBodyFile3", "paintBodyFile4", 
        "paintBodyFile5", "paintBodyFile6", "paintBodyFile7", "paintBodyFile8",
        "paintBodyFile9", "paintBodyFile10", "paintBodyFile11", "paintBodyFile12", "paintBodyFile13",
        "carpetFile1", "carpetFile2", "carpetFile3", "carpetFile4", "carpetFile5",
        "plasticPanelFile1", "plasticPanelFile2", "plasticPanelFile3", "plasticPanelFile4",
        "plasticPanelFile5", "plasticPanelFile6", "plasticPanelFile7",
        "rubberComponentFile1", "rubberComponentFile2", "rubberComponentFile3", 
        "rubberComponentFile4", "rubberComponentFile5", "rubberComponentFile6",
        "seatFile1", "seatFile2", "seatFile3", "seatFile4", "seatFile5", 
        "seatFile6", "seatFile7", "seatFile8",
        "glassMirrorFile1", "glassMirrorFile2", "glassMirrorFile3", "glassMirrorFile4",
        "glassMirrorFile5", "glassMirrorFile6", "glassMirrorFile7", "glassMirrorFile8",
        "glassMirrorFile9", "glassMirrorFile10", "glassMirrorFile11", "glassMirrorFile12",
        "tyreFile1", "tyreFile2", "tyreFile3", "tyreFile4", "tyreFile5"
      ];

      // Append each image file to formData
      // Correct ✅
      imageFields.forEach(field => {
        if (reportData[field]) {
          formData.append(field, reportData[field]);
        }
      });

      // Append newly-attached remark photos as remarkPhoto_<index>; the
      // index matches technicianRemarks[index] in the JSON payload above so
      // the backend can fold each URL onto the right remark.
      remarks.rows.forEach((r, i) => {
        if (r.photoFile) {
          formData.append(`remarkPhoto_${i}`, r.photoFile);
        }
      });

      // Step 5: Send report data and files to backend
      const response = await axios.post(
        `${API_URL}/api/pdi-reports/create`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      const pdiReportId = response.data.report._id;

      // Step 6: Update service status
      if (pdiReportId) {
        await axios.patch(
          `${API_URL}/api/services/${serviceId}/status`,
          { pdiReportId }
        );
        setIsPdfGenerated(true);
        localStorage.removeItem(`reportData_${serviceId}`);

        navigate("/technician/tasks");
      } else {
        alert("Failed to save the report and generate PDF. Please try again.");
      }
    } catch (error) {
      alert("An error occurred while submitting the report. Please try again.");
      console.error("Error submitting PDI report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // const generatePDF = () => {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       const doc = new jsPDF();
  //       doc.setFontSize(20);
  //       doc.text("Job Report", 10, 20);
  //       doc.setFontSize(12);
  //       doc.text(`Technician: ${reportData.technicianName}`, 10, 30);
  //       doc.text(`Customer: ${reportData.customerName}`, 10, 40);
  //       doc.text(`Date: ${reportData.date}`, 10, 50);
  //       doc.text(`Job Details: ${reportData.inspectionType}`, 10, 60);
  //       doc.text(`Vehicle Model: ${reportData.vehicleModel}`, 10, 70);
  //       doc.text(`Variant: ${reportData.variant}`, 10, 80);
  //       doc.text(`Allotted VIN: ${reportData.allottedVin}`, 10, 90);
  //       doc.text(`Address: ${reportData.address}`, 10, 100);
  //       doc.text(`Vehicle Condition: ${reportData.vehicleCondition}`, 10, 110);

  //       // Instead of saving the PDF, convert it to Blob and resolve it
  //       const pdfBlob = doc.output("blob");
  //       resolve(pdfBlob);
  //     } catch (error) {
  //       console.error("Error generating PDF:", error);
  //       reject(error);
  //     }
  //   });
  // };

  // const handleFormSubmit = async () => {
  //   try {
  //     const pdiReportData = {
  //       serviceId: serviceId,
  //       technicianId: serviceData.technicianId,
  //       userId: serviceData.userId,
  //       ...reportData,
  //     };

  //     const response = await axios.post(
  //       `${API_URL}/api/pdi-reports/create`,
  //       pdiReportData
  //     );
  //     const pdiReportId = response.data.report._id;

  //     if (pdiReportId) {
  //       await axios.patch(
  //         `${API_URL}/api/services/${serviceId}/status`,
  //         { pdiReportId }
  //       );
  //       generatePDF();
  //       setIsPdfGenerated(true);
  //       localStorage.removeItem(`reportData_${serviceId}`); // Clear data from localStorage after submission
  //     } else {
  //       alert("Failed to create PDI report. Please try again.");
  //     }
  //   } catch (err) {
  //     alert("Failed to save the report and generate PDF. Please try again.");
  //     console.error("Error submitting PDI report:", err);
  //   }
  // };

  // const generatePDF = () => {
  //   const doc = new jsPDF();
  //   doc.setFontSize(20);
  //   doc.text("Job Report", 10, 20);
  //   doc.setFontSize(12);
  //   doc.text(`Technician: ${reportData.technicianName}`, 10, 30);
  //   doc.text(`Customer: ${reportData.customerName}`, 10, 40);
  //   doc.text(`Date: ${reportData.date}`, 10, 50);
  //   doc.text(`Job Details: ${reportData.inspectionType}`, 10, 60);
  //   doc.text(`Vehicle Model: ${reportData.vehicleModel}`, 10, 70);
  //   doc.text(`Variant: ${reportData.variant}`, 10, 80);
  //   doc.text(`Allotted VIN: ${reportData.allottedVin}`, 10, 90);
  //   doc.text(`Address: ${reportData.address}`, 10, 100);
  //   doc.text(`Vehicle Condition: ${reportData.vehicleCondition}`, 10, 110);

  //   doc.save("job_report.pdf");
  // };

  const handleSaveProgress = () => {
    // Persist remark text alongside the small reportData draft blob. Photos
    // are Files and can't be serialized — the technician re-attaches them if
    // they reload mid-inspection, same as every zone photo already behaves.
    const draft = {
      ...reportData,
      technicianRemarks: technicianRemarks
        .map((r) => ({ text: (r.text || "").trim(), photoUrl: r.photoUrl || null }))
        .filter((r) => r.text || r.photoUrl),
    };
    localStorage.setItem(`reportData_${serviceId}`, JSON.stringify(draft));
    alert("Progress saved successfully!");
  };

  // Form Tyres

  // const handleSubmit = (event) => {
  //   event.preventDefault();

  //   const formData = {
  //     BrandSpare,
  //     VarientSpare,
  //     selectedConditionSpare,
  //     Spare,
  //     selectedConditionDOTSpare,
  //     selectedConditionSparen,
  //     selectedConditionFLNT,
  //     selectedConditionDOTFLN,
  //     FLN,
  //     selectedConditionFLN,
  //     VarientFLN,
  //     BrandFLN,
  //     selectedConditionRLN,
  //     selectedConditionDOTRL,
  //     RLTrend,
  //     selectedConditionRL,
  //     VarientRL,
  //     BrandRL,
  //     selectedConditionRTN,
  //     selectedConditionDOTRT,
  //     TDRT,
  //     selectedConditionRT,
  //     VarientRT,
  //     BrandRT,
  //     selectedConditionFT,
  //     selectedConditionDOTFT,
  //     BrandTRFR,
  //     selectedConditionSTS,
  //     BrandTv,
  //     BrandT,
  //   };

  //   // Log form data to the console (or send to API)
  //   console.log("Form Data:", formData);

  //   // Optional: Add API call or further data processing here
  // };

  return (
    <div className="font-clash">
         <Helmet>
              <title>Technician Report</title>
              <meta
                name="keywords"
                content="Pdi, Bengaluru, Bangalore, Kardo, Inspection, Ze, Pre delivery, Services, Car, Cars, Vaidya, BHP, Team, CID, Expert, In, Best, 24, BOSS, Dail, Just, New car, Checklist, Detailed, Report, Inspect, Reliable, Blog, Used car inspection, Buying a new car"
              />
              <meta
                name="description"
                content="Explore our reliable pre-delivery inspection services for new and used cars. Detailed reports, expert insights, and the best service in Bangalore and beyond."
              />
            </Helmet>
      <NavbarT />
      <div className=" w-full min-h-screen bg-banner bg-cover bg-center p-6 flex flex-col items-center justify-center pb-32 ">
        {loading ? (
          <div className="min-h-screen pt-20">Loading tasks...</div>
        ) : error ? (
          <div>{error}</div>
        ) : (
          <>
        <div className="flex items-center justify-center py-10 below-1300:scale-75 pt-24 ">
        <Stepper
        connectorStateColors={true}
        styleConfig={{
          size: '2em',
          circleFontSize: '1rem',
          connectorStyleConfig: {
            activeColor: '#ADD144',
            completedColor: '#ADD144',
            disabledColor: '#D4D4D4',
            size: 2,
            style: 'solid',
          },
        }}
      >
        {[
          { label: 'Step 1', condition: status === "Assigned" || "Arrived" },
          { label: 'Step 2', condition: status === "Arrived" },
          { label: 'Step 3', condition: status === "Completed" },
        ].map((step, index) => (
          <Step
            key={index}
            label={
              <span className={`text-[18px] font-semibold ${step.condition ? 'text-[#ADD144]' : 'text-[#D4D4D4]'}`}>
                {step.label}
              </span>
            }
            className={`h-8 w-8 rounded-full flex items-center justify-center ${step.condition ? 'bg-[#ADD144] text-[#1F1F1F]' : 'bg-[#1F1F1F] text-[#ADD144]'}`}
            style={{
              backgroundColor: step.condition ? '#ADD144' : '#1F1F1F',
              color: step.condition ? '#1F1F1F' : '#ADD144',
            }}
          />
        ))}
      </Stepper>
      </div>
            {/* <div className="flex items-center justify-center py-10 below-1300:scale-75 pt-24 ">
              <div className="flex items-center justify-center">
                <div className="flex flex-col items-center justify-center text-center"> */}
                  {/* Step 1 */}
                  {/* <div className="h-8 w-8 rounded-full bg-[#ADD144] flex items-center justify-center">
                    <p className="text-[#1F1F1F] text-[18px]">1</p>
                  </div>
                  <p className="text-[#F0FFC5] text-[18px]">Step 1</p>
                </div> */}

                {/* Horizontal Line */}
                {/* <hr className="border-t border-[#ADD144] lg:w-[200px] below:1300-w-[100px] w-[100px] border-2 lg:mb-6 mb-12 " />
              </div>

              <div className="flex flex-col items-center text-center justify-center"> */}
                {/* Step 2 */}
                {/* <div className="h-8 w-8 rounded-full bg-[#ADD144] flex items-center justify-center">
                  <p className="text-[#1F1F1F] text-[18px]">2</p>
                </div>
                <p className="text-[#F0FFC5] text-[18px]">Step 2</p>
              </div>
              <hr className="border-t border-[#ADD144] lg:w-[200px] below:1300-w-[100px] w-[100px] lg:mb-6 mb-12   border-2 mb-6 flex  items-center justify-center " />

              <div className="flex flex-col items-center justify-center text-center"> */}
                {/* Step 3 */}
                {/* <div className="h-8 w-8 rounded-full bg-[#1F1F1F] flex items-center justify-center">
                  <p className="text-[#D4D4D4] text-[18px]">3</p>
                </div>
                <p className="text-[#D4D4D4] text-[18px]">Step 3</p>
              </div>
            </div> */}

            {/* First Section */}
            <div className="flex w-full lg:flex-row z-10 flex-col items-center justify-center lg:max-w-5xl max-w-[29rem] mx-auto bg-[#1F1F1F] border border-[#ADD144] p-6 rounded-lg shadow-2xl mt-3 mb-24 overflow-x-hidden">
              {/* Left side: Car Image */}
              <div className="lg:w-2/3 w-full flex flex-col justify-center items-center p-4 relative z-10">
                <img
                  src={serviceData.vehicleImageUrl || car}
                  alt="Car"
                  className="h-auto rounded-lg lg:mb-5 mb-0 lg:w-[500px] z-10 object-contain"
                />
                {/* Stats Container */}
                <div className="flex lg:flex-nowrap flex-wrap w-full items-center justify-center gap-2 sm:gap-6 lg:gap-10 border-t border-l border-r border-[#ADD144] shadow-xl p-4 sm:p-6 rounded-lg mt-4 lg:mt-0">
                      {/* Individual Stats */}
                      <div className="flex items-center justify-center gap-2 sm:gap-6">
                        <div className="flex flex-col items-center lg:items-start">
                          <p className="text-[#F0FFC5] text-lg sm:text-xl lg:text-2xl font-semibold">
                          {serviceData.bhp || 'N/A'}
                          </p>
                          <p className="text-[#FFFF] text-sm sm:text-base lg:text-lg">
                            BHP
                          </p>
                        </div>
                        <div className="w-[2px] h-8 sm:h-10 lg:h-12 bg-[#ADD144] hidden sm:block"></div>
                        <div className="flex flex-col items-center lg:items-start">
                          <p className="text-[#F0FFC5] text-lg sm:text-xl lg:text-2xl font-semibold">
                          {serviceData.airbags || 'N/A'}
                          </p>
                          <p className="text-[#FFFF] text-sm sm:text-base lg:text-lg">
                            Airbags
                          </p>
                        </div>
                      </div>
                      <div className="w-[2px] h-8 sm:h-10 lg:h-12 bg-[#ADD144] hidden sm:block"></div>
                      <div className="flex flex-col items-center lg:items-start">
                        <p className="text-[#F0FFC5] text-lg sm:text-xl lg:text-2xl font-semibold">
                        {serviceData.mileage || 'N/A'}
                        </p>
                        <p className="text-[#FFFF] text-sm sm:text-base lg:text-lg">
                          Mileage (kmpl)
                        </p>
                      </div>
                      <div className="w-[2px] h-8 sm:h-10 lg:h-12 bg-[#ADD144] hidden sm:block"></div>
                      <div className="flex flex-col items-center lg:items-start">
                        <p className="text-[#F0FFC5] text-lg sm:text-xl lg:text-2xl font-semibold">
                        {serviceData.ncap || 'N/A'}
                        </p>
                        <p className="text-[#FFFF] text-sm sm:text-base lg:text-lg">
                          NCAP
                        </p>
                      </div>
                    </div>
              </div>
              <div className="lg:w-1/2 w-full flex flex-col items-start p-2">
                <ul className="p-4 w-full mb-6">
                  <li className="relative mb-4 text-[#FFFFFF] text-3xl font-semibold pb-2 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[3px] after:bg-[linear-gradient(to_bottom_right,_rgba(240,255,197,0),_rgba(240,255,197,0.2))]">
                    <span>{serviceData.vehicleMake} {serviceData.variant} {serviceData.vehicleModel}</span>
                  </li>
                  <li className="py-2 text-[#FFFFFF] text-[18px]">
                    <span className="font-semibold">Booking ID</span>
                    {" : "}
                    {serviceId}
                  </li>
                  <li className="text-[#FFFFFF] text-[18px] py-2">
                    <span className="font-semibold">VIN</span>
                    {" : "}
                    {serviceData?.allottedVin}
                  </li>
                  <li className="text-[#FFFFFF] text-[18px] py-2">
                    <span className="font-semibold">Fuel</span> : {serviceData.fuel || 'Not specified'}
                  </li>
                  <li className="text-[#FFFFFF] text-[18px] py-2">
                    <span className="font-semibold">Engine</span> : {serviceData.engine || 'Not specified'}
                    Cylinders Inline 4 valves
                  </li>
                  <li className="text-[#FFFFFF] text-[18px] py-2">
                    <span className="font-semibold">Variant</span> :{" "} {serviceData?.variant}
                  </li>
                  <li className="text-[#FFFFFF] text-[18px] py-2">
                    <span className="font-semibold">Status</span> :{" "} {status}
                  </li>
                  <li className="py-2 text-[#FFFFFF] text-[18px]">
                    <span className="font-semibold">Message</span> : {serviceData?.customMessage ? serviceData?.customMessage : "NIL"}
                  </li>
                </ul>
              </div>
            </div>

            {/* One  */}

            <div className="flex items-center justify-center w-full">
              <div className="flex w-full lg:max-w-5xl max-w-[29rem]  flex-col items-center justify-center space-y-4 border border-gray-300 p-6 rounded-md relative">
                <div className="w-full text-left sm:pt-10">
                  <h4 className="text-[#FFFFFF] text-[24px] sm:text-[16px]">
                    Confirm Your Arrival for PDI
                  </h4>
                  <div className="flex items-center mt-4">
                    <input
                      type="checkbox"
                      id="confirm-arrival"
                      className="mr-2"
                      required
                      checked={status === "Arrived" || isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)} // Handle checkbox state change
                    />
                    <label
                      htmlFor="confirm-arrival"
                      className="text-[#FFFFFF] text-[18px] sm:text-[16px]"
                    >
                      Confirming your arrival
                    </label>
                  </div>
                </div>

                <div className="w-full flex justify-center">
                  <button
                    className={`text-[#F0FFC5] text-md font-semibold py-4 cursor-pointer px-12 ${
                      status === "Arrived" ? "bg-[#ADD144]" : "bg-[#1F1F1F]"
                    } rounded-3xl shadow-inner-custom`}
                    onClick={handleConfirm} // Call handleConfirm on button click
                    disabled={isDisabled}
                  >
                    {status === "Arrived" ? "Confirmed" : "Confirm"}
                  </button>
                </div>

                <div className="absolute h-10 w-10 bg-[#1F1F1F] rounded-full left-[-20px] top-24 flex items-center justify-center">
                  <p className="text-[#ADD144] text-[20px]">1</p>
                </div>

                <div
                  className={`px-12 py-2 text-black absolute top-[-38px] right-10 rounded-full ${
                    status === "Arrived" ? "bg-[#ADD144]" : "bg-[#FFBD6F]"
                  }`}
                >
                  {status}
                </div>
              </div>
            </div>

            {/* Two */}

            {/* Start Pre Delivery Inspection Basic Details */}

            {/* <form> */}
              <div className="flex items-center justify-center w-full pt-20 ">
                <div className="flex w-full lg:max-w-5xl md:max-w-[29rem] sm:max-w-[21rem] flex-col items-center justify-center space-y-4 border border-gray-300 p-6 rounded-md relative">
                  <div className="w-full text-left pb-5 sm:pt-10">
                    <h4 className="text-[#FFFFFF] text-[18px] sm:text-[16px] ">
                      Start Pre Delivery Inspection
                    </h4>
                  </div>

                  <div className="absolute h-10 w-10 bg-[#1F1F1F] rounded-full left-[-20px] top-24 flex items-center justify-center">
                    <p className="text-[#ADD144] text-[20px]  ">2</p>
                  </div>
                  <div className="bg-[#1F1F1F] px-12 py-2 text-[#F0FFC5] absolute top-[-38px] right-10 rounded-full">
                    Activate
                  </div>

                  {/* Basic Details box */}

                  <div className="flex w-full max-w-4xl flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative">
                    <div className="w-full text-left">
                      <h4 className="text-[#FFFFFF] text-[24px] pb-10">
                        Basic Details
                      </h4>
                      <div className="flex flex-wrap lg:space-x-4 w-full max-w-4xl">
                        {/* VIN Number */}
                        <div className="relative mb-8 w-full sm:w-[350px] lg:w-[350px]">
                          <label className="absolute left-6 -top-3 bg-[#1F1F1F]  text-[#F0FFC5] font-semibold px-1">
                            VIN Number
                          </label>
                          <input
                            type="text"
                            name="VIN Number"
                            value={vinNumber}
                            onChange={(e) => setVinNumber(e.target.value)}
                            required
                            className="border rounded-3xl w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                          />
                        </div>

                        {/* Engine Number */}
                        <div className="relative mb-8 w-full sm:w-[350px] lg:w-[350px] ">
                          <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                            Engine Number
                          </label>
                          <input
                            type="text"
                            name="Engine Number"
                            value={engineNumber}
                            onChange={(e) => setEngineNumber(e.target.value)}
                            required
                            className="border rounded-3xl w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                          />
                        </div>

                        <div className="relative mb-8 w-full sm:w-[350px] lg:w-[350px] ">
                          <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                          Emission Type
                          </label>
                          <input
                            type="text"
                            name="Emission Type"
                            value={emissionType}
                            onChange={(e) => setEmissionType(e.target.value)}
                            required
                            className="border rounded-3xl w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                          />
                        </div>

                        <div className="relative mb-8 w-full sm:w-[350px] lg:w-[350px] ">
                          <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                          Transmission
                          </label>
                          <input
                            type="text"
                            name="Transmission"
                            value={transmission}
                            onChange={(e) => setTransmission(e.target.value)}
                            required
                            className="border rounded-3xl w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                          />
                        </div>
                      </div>

                      <div className="">
                        <button
                          onClick={() => {
                            setSelectedButton((prev) =>
                              prev === "dealerShowroom"
                                ? null
                                : "dealerShowroom"
                            );
                          }}
                          className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                            selectedButton === "dealerShowroom"
                              ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                              : "bg-transparent border border-white text-white font-semibold"
                          }`}
                        >
                          <span
                            className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                              selectedButton === "dealerShowroom"
                                ? "bg-[#ADD144]"
                                : "bg-transparent"
                            }`}
                          >
                            {selectedButton === "dealerShowroom" && (
                              <span className="absolute text-[#191F09] text-lg">
                                &#10003; {/* Checkmark */}
                              </span>
                            )}
                          </span>
                          <span>Dealer Showroom</span>
                        </button>

                        <div className="flex flex-wrap pt-16 lg:space-x-4 w-full max-w-4xl">
                          {/* Odometer Reading */}
                          <div className="relative mb-8 w-full sm:w-[350px] lg:w-[350px]">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Odometer Reading
                            </label>
                            <input
                              type="number"
                              name="odometer Reading"
                              value={odometerBasic}
                              onChange={(e) => setOdometerBasic(e.target.value)}
                              required
                              className="border rounded-3xl w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                            />
                          </div>

                          {/* Keys */}
                          <div className="relative mb-8 w-full sm:w-[350px] lg:w-[350px]">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Keys
                            </label>
                            <input
                              type="text"
                              name="Keys"
                              value={keysBasic}
                              onChange={(e) => setKeysBasic(e.target.value)}
                              required
                              className="border rounded-full w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                            />
                          </div>
                        </div>

                        <div className="flex flex-wrap pt-8 lg:space-x-4 w-full max-w-4xl">
                          {/* First File Upload */}
                          <div className="relative mb-8 w-full sm:w-[300px] lg:w-[300px] ">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Upload Picture
                            </label>
                            <input
                              type="file"
                              name="uploadPicture"
                              onChange={(e) =>
                                handleFileUpload(e, setBasicFile1)
                              }
                              required
                              className="border rounded-3xl w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                            />
                            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                              <img
                                src={cam}
                                alt="cam icon"
                                className="w-8 h-8"
                              />
                            </div>
                          </div>

                          {/* Second File Upload */}
                          <div className="relative mb-8 w-full sm:w-[300px] lg:w-[300px]">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Upload Picture
                            </label>
                            <input
                              type="file"
                              name="uploadPicture"
                              onChange={(e) =>
                                handleFileUpload(e, setBasicFile2)
                              }
                              required
                              className="border rounded-3xl w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                            />
                            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                              <img
                                src={cam}
                                alt="cam icon"
                                className="w-8 h-8"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="flex flex-wrap pt-2 lg:space-x-4 w-full max-w-4xl">
                          {/* Third File Upload */}
                          <div className="relative mb-8 w-full sm:w-[300px] lg:w-[300px]">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Upload Picture
                            </label>
                            <input
                              type="file"
                              name="uploadPicture"
                              onChange={(e) =>
                                handleFileUpload(e, setBasicFile3)
                              }
                              required
                              className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                            />
                            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                              <img
                                src={cam}
                                alt="cam icon"
                                className="w-8 h-8"
                              />
                            </div>
                          </div>

                          {/* Fourth File Upload */}
                          <div className="relative mb-8 w-full sm:w-[300px] lg:w-[300px]">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Upload Picture
                            </label>
                            <input
                              type="file"
                              name="uploadPicture"
                              onChange={(e) =>
                                handleFileUpload(e, setBasicFile4)
                              }
                              required
                              className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                            />
                            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                              <img
                                src={cam}
                                alt="cam icon"
                                className="w-8 h-8"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex justify-center">
                      <button
                        className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                        onClick={handleSaveBasicDetails}
                      >
                        {savedBasicMessage ? savedBasicMessage : "Save"}
                      </button>
                    </div>
                  </div>

                  {/* Body and Panels */}

                  <div className="flex w-full max-w-4xl flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative">
                    <div className="w-full text-left">
                      <h4 className="text-[#FFFFFF] text-[24px] pb-10">
                        Body and Panels
                      </h4>

                      {/* Buttons to select Exterior or Interior */}
                      <div className="flex flex-col sm:flex-row items-center justify-center pb-10 gap-2 max-w-[300px] mx-auto">
                        <div
                          onClick={() => handleClick("exterior")}
                          className={`text-center font-semibold cursor-pointer w-full ${
                            selected === "exterior"
                              ? "text-[#ADD144]"
                              : "text-black"
                          }`}
                        >
                          <p
                            className={`px-12 py-2 ${
                              selected === "exterior"
                                ? "bg-[#ADD144] text-black"
                                : "text-[#CBCBCB] bg-transparent"
                            }`}
                          >
                            Exterior
                          </p>
                        </div>

                        <div
                          onClick={() => handleClick("interior")}
                          className={`text-center font-semibold cursor-pointer w-full ${
                            selected === "interior"
                              ? "text-[#ADD144]"
                              : "text-black"
                          }`}
                        >
                          <p
                            className={`px-12 py-2 ${
                              selected === "interior"
                                ? "bg-[#ADD144] text-black"
                                : "text-[#CBCBCB] bg-transparent"
                            }`}
                          >
                            Interior
                          </p>
                        </div>
                      </div>

                      {/* Conditionally render the form based on selection */}

                      {/* Exterior */}

                      <div className="flex w-full max-w-3xl flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative mx-auto">
                        {selected === "exterior" && (
                          <div className="exterior-form space-y-2 w-full">
                            <h4 className="text-[#FFFFFF] text-[24px] pb-5 text-center">
                              Paint & Body
                            </h4>

                            {/* Bonnet */}
                            <div className="flex flex-col items-start lg:mx-10 ">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5 sm:text-[16px]">
                                  Bonnet
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonB((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 w-full  ${
                                    selectedButtonB === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonB === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonB === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="text-sm sm:text-base">
                                    Repainted
                                  </span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-wrap  lg:flex-nowrap space-y-4 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                              <div className="relative mb-4 lg:mb-8 w-full sm:w-[300px] lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number" // Ensure this is set correctly
                                  value={valueB}
                                  onChange={(e) => setValuesB(e.target.value)}
                                  // required={selectedButtonB === "repainted"} // Only required if the button is selected
                                  // disabled={selectedButtonB !== "repainted"} // Disable input if the button is not selected
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>
                              <div className="relative mb-4 lg:mb-8 w-full sm:w-[300px] lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueB}
                                  onChange={(e) => setIssueB(e.target.value)}
                                  className="border rounded-full lg:mb-0 mb-8 w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile1)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                            {/* Front Bumber */}

                            <div className="flex flex-col items-start  pt-10 lg:mx-10 sm:pt-5">
                              <div>
                                <p className="text-[#FFFFFF] text-[20px] pb-5 sm:text-[16px] md:text-[18px]">
                                  Front Bumper
                                </p>
                              </div>
                              <div>
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonFB((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 py-3 px-6 rounded-full transition-all duration-300 sm:py-2 sm:px-4 sm:space-x-3 md:py-2.5 md:px-5 ${
                                    selectedButtonFB === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold"
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 sm:w-4 sm:h-4 ${
                                      selectedButtonFB === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonFB === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg sm:text-sm">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="text-base sm:text-sm md:text-sm">
                                    Repainted
                                  </span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-col lg:flex-row lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                              {/* Value Input */}
                              <div className="relative mb-6 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1 text-sm md:text-base">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number"
                                  value={valueFB}
                                  onChange={(e) => setValuesFB(e.target.value)}
                                  // required={selectedButtonB === "repainted"} // Only required if the button is selected
                                  // disabled={selectedButtonB !== "repainted"} // Disable input if the button is not selected
                                  className="border rounded-full w-full py-5 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] text-sm md:text-base"
                                />
                              </div>

                              {/* Paint Condition Select */}
                              <div className="relative mb-6 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1 text-sm md:text-base">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueFB}
                                  onChange={(e) => setIssueFB(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-5 mb-8 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none text-sm md:text-base pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile2)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                              {/* Front Right Fender */}

                              <div className="flex flex-col items-start  pt-10 lg:mx-10 sm:pt-5">
                              <div>
                                <p className="text-[#FFFFFF] text-[20px] pb-5 sm:text-[16px] md:text-[18px]">
                                  Front Right Fender
                                </p>
                              </div>
                              <div>
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonFRQP((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 py-3 px-6 rounded-full transition-all duration-300 sm:py-2 sm:px-4 sm:space-x-3 md:py-2.5 md:px-5 ${
                                    selectedButtonFRQP === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold"
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 sm:w-4 sm:h-4 ${
                                      selectedButtonFRQP === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonFRQP === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg sm:text-sm">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="text-base sm:text-sm md:text-sm">
                                    Repainted
                                  </span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-col lg:flex-row lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                              {/* Value Input */}
                              <div className="relative mb-6 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1 text-sm md:text-base">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number"
                                  value={valueFRQP}
                                  onChange={(e) => setValuesFRQP(e.target.value)}
                                  // required={selectedButtonB === "repainted"} // Only required if the button is selected
                                  // disabled={selectedButtonB !== "repainted"} // Disable input if the button is not selected
                                  className="border rounded-full w-full py-5 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] text-sm md:text-base"
                                />
                              </div>

                              {/* Paint Condition Select */}
                              <div className="relative mb-6 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1 text-sm md:text-base">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueFRQP}
                                  onChange={(e) => setIssueFRQP(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-5 mb-8 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none text-sm md:text-base pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile3)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                            {/* Front Door */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Front Right Door
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonFD((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                    selectedButtonFD === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonFD === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonFD === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span>Repainted</span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-wrap space-y-6 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-14 lg:mx-10">
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number"
                                  value={valueFD}
                                  onChange={(e) => setValuesFD(e.target.value)}
                                  // required={selectedButtonFD === "repainted"}
                                  // disabled={selectedButtonFD !== "repainted"}
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueFD}
                                  onChange={(e) => setIssueFD(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-5 mb-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                accept="image/*"
                                capture="environment"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile4)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                            {/* Rear Right Door (RRD) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Rear Right Door
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonRRD((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                    selectedButtonRRD === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonRRD === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonRRD === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span>Repainted</span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-wrap space-y-4 sm:space-y-0 sm:space-x-4 w-full max-w-[700px] pt-14 lg:mx-10">
                              {/* Value Input */}
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number"
                                  value={valueRRD}
                                  onChange={(e) => setValuesRRD(e.target.value)}
                                  // required={selectedButtonRRD === "repainted"}
                                  // disabled={selectedButtonRRD !== "repainted"}
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>

                              {/* Paint Condition / Issues Select */}
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueRRD}
                                  onChange={(e) => setIssueRRD(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-5 mb-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile5)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>
                            {/* Rear Right Quarter Panel (RRQP) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Rear Right Quarter Panel
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonRRQP((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                    selectedButtonRRQP === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonRRQP === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonRRQP === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span>Repainted</span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-wrap space-y-4 sm:space-y-0 sm:space-x-4 w-full max-w-[700px] pt-14 lg:mx-10">
                              {/* Value Input Field */}
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number" // Ensure this is set correctly
                                  value={valueRRQP}
                                  onChange={(e) =>
                                    setValuesRRQP(e.target.value)
                                  }
                                  // required={selectedButtonRRQP === "repainted"} // Only required if the button is selected
                                  // disabled={selectedButtonRRQP !== "repainted"} // Disable input if the button is not selected
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>

                              {/* Select Paint Condition / Issues */}
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueRRQP}
                                  onChange={(e) => setIssueRRQP(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-5 mb-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile6)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                            {/* BOOT (BT) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Boot / Trunk
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonBT((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                    selectedButtonBT === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonBT === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonBT === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span>Repainted</span>
                                </button>
                              </div>
                            </div>
                            <div className="flex flex-col lg:flex-row md:space-x-4 w-full max-w-[700px] pt-14 lg:mx-10">
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number"
                                  value={valueBT}
                                  onChange={(e) => setValuesBT(e.target.value)}
                                  // required={selectedButtonBT === "repainted"}
                                  // disabled={selectedButtonBT !== "repainted"}
                                  className="border rounded-full w-full py-4 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueBT}
                                  onChange={(e) => setIssueBT(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-4 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile7)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                           {/*Rear Bumper (RB) new */}

                          <div className="flex flex-col items-start lg:mx-10 pt-3">
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Rear Bumper
                              </p>
                            </div>
                            <div className="">
                              <button
                                onClick={() => {
                                  // Toggle the button selection
                                  setSelectedButtonRB((prev) =>
                                    prev === "repainted" ? null : "repainted"
                                  );
                                }}
                                className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                  selectedButtonRB === "repainted"
                                    ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                    : "bg-transparent border border-white text-white font-semibold"
                                }`}
                              >
                                <span
                                  className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                    selectedButtonRB === "repainted"
                                      ? "bg-[#ADD144]"
                                      : "bg-transparent"
                                  }`}
                                >
                                  {selectedButtonRB === "repainted" && (
                                    <span className="absolute text-[#191F09] text-lg">
                                      &#10003; {/* Checkmark */}
                                    </span>
                                  )}
                                </span>
                                <span>Repainted</span>
                              </button>
                            </div>
                          </div>
                          <div className="flex flex-col lg:flex-row md:space-x-4 w-full max-w-[700px] pt-14 lg:mx-10">
                            <div className="relative mb-8 w-full lg:w-[300px]">
                              <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Value
                              </label>
                              <input
                                type="text"
                                name="Engine Number"
                                value={valueRB}
                                onChange={(e) => setValuesRB(e.target.value)}
                                // required={selectedButtonBT === "repainted"}
                                // disabled={selectedButtonBT !== "repainted"}
                                className="border rounded-full w-full py-4 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                              />
                            </div>

                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueRB}
                                  onChange={(e) => setIssueRB(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-4 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                          </div>

                          <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Upload Picture
                            </label>
                            <input
                              type="file"
                              name="uploadPicture"
                              onChange={(e) =>
                                handleFileUpload(e, setPaintBodyFile13)
                              }
                              // required
                              className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                            />
                            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                              <img
                                src={cam}
                                alt="cam icon"
                                className="w-8 h-8"
                              />
                            </div>
                          </div>                            

                            {/* Front Left Fender */}

                            <div className="flex flex-col items-start lg:mx-10 pt-10">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Front Left Fender
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonFLF((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                    selectedButtonFLF === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonFLF === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonFLF === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span>Repainted</span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-wrap space-x-4 w-full pt-14 lg:mx-10">
                              <div className="relative mb-8 w-full sm:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number" // Ensure this is set correctly
                                  value={valueFLF}
                                  onChange={(e) => setValuesFLF(e.target.value)}
                                  // required={selectedButtonFLF === "repainted"} // Only required if the button is selected
                                  // disabled={selectedButtonFLF !== "repainted"} // Disable input if the button is not selected
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueFLF}
                                  onChange={(e) => setIssueFLF(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-4 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile8)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                            {/* Front lEFT Door */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Front Left Door
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonFLDS((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                    selectedButtonFLDS === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonFLDS === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonFLDS === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span>Repainted</span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-wrap space-x-4 w-full pt-14 lg:mx-10">
                              {/* Value Input Field */}
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number" // Ensure this is set correctly
                                  value={valueFLDS}
                                  onChange={(e) =>
                                    setValuesFLDS(e.target.value)
                                  }
                                  // disabled={selectedButtonRRQP !== "repainted"} // Disable input if the button is not selected
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>

                              {/* Select Paint Condition / Issues */}
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                <select
                                  name="Engine Number"
                                  value={issueFLDS}
                                  onChange={(e) => setIssueFLDS(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-5 mb-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                accept="image/*"
                                capture="environment"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile9)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                            {/* Rear Left Door (RLD) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Rear Left Door
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonRLDS((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                    selectedButtonRLDS === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonRLDS === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonRLDS === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span>Repainted</span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-col lg:flex-row md:space-x-4 w-full max-w-[700px] pt-14 lg:mx-10">
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number" // Ensure this is set correctly
                                  value={valueRLDS}
                                  onChange={(e) =>
                                    setValuesRLDS(e.target.value)
                                  }
                                  // required={selectedButtonRLDS === "repainted"} // Only required if the button is selected
                                  // disabled={selectedButtonRLDS !== "repainted"} // Disable input if the button is not selected
                                  className="border rounded-full w-full py-4 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                {/* <input
                                type="text"
                                name="Engine Number" // Ensure this is set correctly
                                value={issueRLDS}
                                onChange={(e) => setIssueRLDS(e.target.value)}
                                required
                                className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                              /> */}
                                <select
                                  name="Engine Number"
                                  value={issueRLDS}
                                  onChange={(e) => setIssueRLDS(e.target.value)}
                                  // required
                                  className="border rounded-full w-full py-4 px-4 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile10)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                            {/* Rear Left Quarter Panel (RRQP) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Rear Left Quarter Panel
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonRLQPS((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                    selectedButtonRLQPS === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonRLQPS === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonRLQPS === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span>Repainted</span>
                                </button>
                              </div>
                            </div>

                            <div className="flex flex-col lg:flex-row md:space-x-4 w-full max-w-[700px] pt-14 lg:mx-10">
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Engine Number"
                                  value={valueRLQPS}
                                  onChange={(e) =>
                                    setValuesRLQPSS(e.target.value)
                                  }
                                  // required={selectedButtonRLDS === "repainted"} // Only required if the button is selected
                                  // disabled={selectedButtonRLDS !== "repainted"} // Disable input if the button is not selected
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>

                              <div className="w-full">
                                <div className="relative mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                    Enter Paint Condition
                                  </label>
                                  {/* {!isOtherSelectedSensor1 ? ( */}
                                    <select
                                      name="DefectSensor"
                                      value={selectedConditionSensor1}
                                      onChange={(e) => setSelectedConditionSensor1(e.target.value)}
                                      // required
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                      {/* <option
                                        className="bg-gray-600"
                                        value="Others"
                                      >
                                        Others
                                      </option> */}
                                    </select>
                                  {/* ) : (
                                    <input
                                      type="text"
                                      value={otherValueRLQPS}
                                      onChange={(e) =>
                                        setOtherValueRLQPS(e.target.value)
                                      }
                                      placeholder="Enter your condition"
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                    />
                                  )} */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full  lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile11)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                            {/* Roof (RF) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Roof
                                </p>
                              </div>
                              <div className="">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonRF((prev) =>
                                      prev === "repainted" ? null : "repainted"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                    selectedButtonRF === "repainted"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonRF === "repainted"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonRF === "repainted" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span>Repainted</span>
                                </button>
                              </div>
                            </div>
                            <div className="flex flex-wrap space-x-4 pt-14 lg:mx-10">
                              <div className="relative mb-8 w-full lg:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Value
                                </label>
                                <input
                                  type="text"
                                  name="Roof PaintBody" // Ensure this is set correctly
                                  value={valueRF}
                                  onChange={(e) => setValuesRF(e.target.value)}
                                  // required={selectedButtonRF === "repainted"} // Only required if the button is selected
                                  // disabled={selectedButtonRF !== "repainted"} // Disable input if the button is not selected
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />
                              </div>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                                  Enter Paint Condition
                                </label>
                                {/* {!isOtherSelectedSensor2 ? ( */}
                                  <select
                                    name="Paintsnew"
                                    value={selectedConditionSensor2}
                                    onChange={(e) => setSelectedConditionSensor2(e.target.value)}
                                    // required
                                    className="border rounded-full w-full py-5 mb-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Paint & Body']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    {/* <option
                                      className="bg-gray-600"
                                      value="Others"
                                    >
                                      Others
                                    </option> */}
                                  </select>
                                {/* ) : (
                                  <input
                                    type="text"
                                    value={otherValueRF}
                                    onChange={(e) =>
                                      setOtherValueRF(e.target.value)
                                    }
                                    placeholder="Enter your condition"
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                )} */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            <div className="relative mb-8 w-full lg:w-[300px] lg:ml-[38px]">
                              <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                Upload Picture
                              </label>
                              <input
                                type="file"
                                name="uploadPicture"
                                onChange={(e) =>
                                  handleFileUpload(e, setPaintBodyFile12)
                                }
                                // required
                                className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                              />
                              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                <img
                                  src={cam}
                                  alt="cam icon"
                                  className="w-8 h-8"
                                />
                              </div>
                            </div>

                            <div className="w-full flex justify-center pt-10">
                              <button
                                className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                                onClick={handleSavePaintBody}
                              >
                                {savedPaintBodyMessage
                                  ? savedPaintBodyMessage
                                  : "Save"}
                              </button>
                            </div>
                          </div>
                        )}

                        {selected === "interior" && (
                          <div className="exterior-form space-y-2 w-full">
                            <h4 className="text-[#FFFFFF] text-[24px] pb-5 text-center">
                              Carpets
                            </h4>
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Driver side
                              </p>
                            </div>

                            <div className="sm:flex sm:flex-col sm:items-start">
  <button
    onClick={() => {
      // Toggle the button selection
      setSelectedButtonDS((prev) =>
        prev === "Not present in the car" ? null : "Not present in the car"
      );
    }}
    className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
      selectedButtonDS === "Not present in the car"
        ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
        : "bg-transparent border border-white text-white font-semibold"
    } sm:space-x-3 sm:px-4 sm:py-2`}
  >
    <span
      className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
        selectedButtonDS === "Not present in the car"
          ? "bg-[#ADD144]"
          : "bg-transparent"
      }`}
    >
      {selectedButtonDS === "Not present in the car" && (
        <span className="absolute text-[#191F09] text-lg">
          &#10003; {/* Checkmark */}
        </span>
      )}
    </span>
    <span className="sm:text-sm">Not present in the car</span>
  </button>
</div>


                            <div className="flex lg:flex-row flex-col space-x-4  pt-8 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 text-[14px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesDS"
                                  value={selectedConditionDS}
                                  onChange={(e) =>
                                    setSelectedConditionDS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Carpets']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureDS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setCarpetFile1)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Co Driver Side */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Co Driver side
                              </p>
                            </div>

                            <div className="">
                              <button
                                onClick={() => {
                                  // Toggle the button selection
                                  setSelectedButtonCDS((prev) =>
                                    prev === "Not present in the car"
                                      ? null
                                      : "Not present in the car"
                                  );
                                }}
                                className={`flex  items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                  selectedButtonCDS === "Not present in the car"
                                    ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                    : "bg-transparent border border-white text-white font-semibold"
                                }`}
                              >
                                <span
                                  className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                    selectedButtonCDS ===
                                    "Not present in the car"
                                      ? "bg-[#ADD144]"
                                      : "bg-transparent"
                                  }`}
                                >
                                  {selectedButtonCDS ===
                                    "Not present in the car" && (
                                    <span className="absolute text-[#191F09] text-lg">
                                      &#10003; {/* Checkmark */}
                                    </span>
                                  )}
                                </span>
                                <span>Not present in the car</span>
                              </button>
                            </div>
                            <div className="flex flex-col lg:flex-row space-x-4  pt-8 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 text-[14px] -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssuesCDS"
                                  value={selectedConditionCDS}
                                  onChange={(e) =>
                                    setSelectedConditionCDS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Carpets']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureCDS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setCarpetFile2)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Driver Rear Side */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Driver Rear side
                              </p>
                            </div>

                            <div className="">
                              <button
                                onClick={() => {
                                  // Toggle the button selection
                                  setSelectedButtonDRS((prev) =>
                                    prev === "Not present in the car"
                                      ? null
                                      : "Not present in the car"
                                  );
                                }}
                                className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                  selectedButtonDRS === "Not present in the car"
                                    ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                    : "bg-transparent border border-white text-white font-semibold"
                                }`}
                              >
                                <span
                                  className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                    selectedButtonDRS ===
                                    "Not present in the car"
                                      ? "bg-[#ADD144]"
                                      : "bg-transparent"
                                  }`}
                                >
                                  {selectedButtonDRS ===
                                    "Not present in the car" && (
                                    <span className="absolute text-[#191F09] text-lg">
                                      &#10003; {/* Checkmark */}
                                    </span>
                                  )}
                                </span>
                                <span>Not present in the car</span>
                              </button>
                            </div>
                            <div className="flex flex-col lg:flex-row space-x-4  pt-8 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 text-[14px] -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesDRS"
                                  value={selectedConditionDRS}
                                  onChange={(e) =>
                                    setSelectedConditionDRS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Carpets']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureDRS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setCarpetFile3)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* CO Driver Rear Side */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Co Driver Rear Side
                              </p>
                            </div>

                            <div className="">
                              <button
                                onClick={() => {
                                  // Toggle the button selection
                                  setSelectedButtonCDRS((prev) =>
                                    prev === "Not present in the car"
                                      ? null
                                      : "Not present in the car"
                                  );
                                }}
                                className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                  selectedButtonCDRS ===
                                  "Not present in the car"
                                    ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                    : "bg-transparent border border-white text-white font-semibold"
                                }`}
                              >
                                <span
                                  className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                    selectedButtonCDRS ===
                                    "Not present in the car"
                                      ? "bg-[#ADD144]"
                                      : "bg-transparent"
                                  }`}
                                >
                                  {selectedButtonCDRS ===
                                    "Not present in the car" && (
                                    <span className="absolute text-[#191F09] text-lg">
                                      &#10003; {/* Checkmark */}
                                    </span>
                                  )}
                                </span>
                                <span>Not present in the car</span>
                              </button>
                            </div>
                            <div className="flex flex-col lg:flex-row space-x-4 pt-8 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute text-[14px] left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesCDRS"
                                  value={selectedConditionCDRS}
                                  onChange={(e) =>
                                    setSelectedConditionCDRS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Carpets']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureCDRS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setCarpetFile4)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Boot Interior */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Boot
                              </p>
                            </div>

                            <div className="">
                              <button
                                onClick={() => {
                                  // Toggle the button selection
                                  setSelectedButtonBI((prev) =>
                                    prev === "Not present in the car"
                                      ? null
                                      : "Not present in the car"
                                  );
                                }}
                                className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                  selectedButtonBI === "Not present in the car"
                                    ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                    : "bg-transparent border border-white text-white font-semibold"
                                }`}
                              >
                                <span
                                  className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                    selectedButtonBI ===
                                    "Not present in the car"
                                      ? "bg-[#ADD144]"
                                      : "bg-transparent"
                                  }`}
                                >
                                  {selectedButtonBI ===
                                    "Not present in the car" && (
                                    <span className="absolute text-[#191F09] text-lg">
                                      &#10003; {/* Checkmark */}
                                    </span>
                                  )}
                                </span>
                                <span>Not present in the car</span>
                              </button>
                            </div>
                            <div className="flex flex-col lg:flex-row space-x-4  pt-8 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 text-[14px] -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssuesBI"
                                  value={selectedConditionBI}
                                  onChange={(e) =>
                                    setSelectedConditionBI(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Carpets']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureBI"
                                  onChange={(e) =>
                                    handleFileUpload(e, setCarpetFile5)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="w-full flex justify-center pt-10">
                              <button
                                className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                                onClick={handleSaveCarpetDetails}
                              >
                                {savedCarpetMessage
                                  ? savedCarpetMessage
                                  : "Save"}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Second form inner */}

                      {/* Flushes and Gaps */}

                      <div className="flex w-full max-w-3xl mt-10 flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative mx-auto">
                        {selected === "exterior" && (
                          <div className="exterior-form space-y-2 w-full">
                            <h4 className="text-[#FFFFFF] text-[24px] pb-5 text-center">
                              Flushes & Gaps
                            </h4>

                            {/* Bonnet Right (BR) */}

                            <div className="flex flex-col items-start lg:mx-10">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Bonnet Right
                                </p>
                              </div>
                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection for "Rough Operation"
                                    setSelectedButtonRO((prev) =>
                                      prev === "Rough Operation"
                                        ? null
                                        : "Rough Operation"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonRO === "Rough Operation"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Selected state
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonRO === "Rough Operation"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonRO === "Rough Operation" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Rough Operation
                                  </span>
                                </button>
                              </div>

                              <div className="mt-5 "></div>
                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonGO((prev) =>
                                      prev === "Gaps Observed"
                                        ? null
                                        : "Gaps Observed"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonGO === "Gaps Observed"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Selected state
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonGO === "Gaps Observed"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonGO === "Gaps Observed" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Gaps Observed
                                  </span>
                                </button>
                              </div>
                            </div>

                            {selectedButtonGO === "Gaps Observed" && (
                              <div className="flex flex-wrap lg:flex-nowrap space-y-4 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-8 lg:mx-10">
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Top
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Top"
                                    value={valueGRT1}
                                    onChange={(e) =>
                                      setValueGRT1(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGO === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGO !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Down
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Down"
                                    value={valueGRD1}
                                    onChange={(e) =>
                                      setValueGRD1(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGO === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGO !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>
                            )}

                            {/* BONNET LEFT  (BL) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-10">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Bonnet Left
                                </p>
                              </div>
                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection for "Rough Operation"
                                    setSelectedButtonBL((prev) =>
                                      prev === "Rough Operation"
                                        ? null
                                        : "Rough Operation"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonBL === "Rough Operation"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Selected state
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonBL === "Rough Operation"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonBL === "Rough Operation" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Rough Operation
                                  </span>
                                </button>
                              </div>

                              {/* GAP */}

                              <div className="mt-5"></div>
                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection
                                    setSelectedButtonGOBL((prev) =>
                                      prev === "Gaps Observed"
                                        ? null
                                        : "Gaps Observed"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonGOBL === "Gaps Observed"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Selected state
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonGOBL === "Gaps Observed"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonGOBL === "Gaps Observed" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Gaps Observed
                                  </span>
                                </button>
                              </div>
                            </div>

                            {selectedButtonGOBL === "Gaps Observed" && (
                              <div className="flex flex-wrap lg:flex-nowrap space-y-4 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Top
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Top"
                                    value={valueGRT2}
                                    onChange={(e) =>
                                      setValueGRT2(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOBL === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOBL !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Down
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Down"
                                    value={valueGRD2}
                                    onChange={(e) =>
                                      setValueGRD2(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOBL === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOBL !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>
                            )}

                            {/* Front Right Door  (FRD)*/}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Front Right Door
                                </p>
                              </div>
                              {/* Rough */}

                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection for "Rough Operation"
                                    setSelectedButtonFRD((prev) =>
                                      prev === "Rough Operation"
                                        ? null
                                        : "Rough Operation"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonFRD === "Rough Operation"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonFRD === "Rough Operation"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonFRD ===
                                      "Rough Operation" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Rough Operation
                                  </span>
                                </button>
                              </div>

                              <div className="mt-5"></div>
                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection for "Gaps Observed"
                                    setSelectedButtonGOFRD((prev) =>
                                      prev === "Gaps Observed"
                                        ? null
                                        : "Gaps Observed"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonGOFRD === "Gaps Observed"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonGOFRD === "Gaps Observed"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonGOFRD ===
                                      "Gaps Observed" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Gaps Observed
                                  </span>
                                </button>
                              </div>
                            </div>

                            {selectedButtonGOFRD === "Gaps Observed" && (
                              <div className="flex flex-wrap lg:flex-nowrap space-y-4 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Top
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Top"
                                    value={valueGRT3}
                                    onChange={(e) =>
                                      setValueGRT3(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOFRD === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOFRD !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Down
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Down"
                                    value={valueGRD3}
                                    onChange={(e) =>
                                      setValueGRD3(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOFRD === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOFRD !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>
                            )}

                            {/* Front Left Door (FLD) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Front Left Door
                                </p>
                              </div>
                              {/* Rough */}

                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection for "Rough Operation"
                                    setSelectedButtonFLD((prev) =>
                                      prev === "Rough Operation"
                                        ? null
                                        : "Rough Operation"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonFLD === "Rough Operation"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Selected state
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonFLD === "Rough Operation"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    { selectedButtonFLD  === "Rough Operation" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Rough Operation
                                  </span>
                                </button>
                              </div>

                         

                              <div className="mt-5"></div>
                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection for "Gaps Observed"
                                    setSelectedButtonGOFLD((prev) =>
                                      prev === "Gaps Observed"
                                        ? null
                                        : "Gaps Observed"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonGOFLD === "Gaps Observed"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonGOFLD === "Gaps Observed"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonGOFLD ===
                                      "Gaps Observed" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Gaps Observed
                                  </span>
                                </button>
                              </div>
                            </div>

                            {/* Condionally render GAP */}

                            {selectedButtonGOFLD === "Gaps Observed" && (
                              <div className="flex flex-wrap lg:flex-nowrap space-y-4 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Top
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Top"
                                    value={valueGRT4}
                                    onChange={(e) =>
                                      setValueGRT4(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOFLD === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOFLD !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Down
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Down"
                                    value={valueGRD4}
                                    onChange={(e) =>
                                      setValueGRD4(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOFLD === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOFLD !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>
                            )}

                            {/* Rear Right Door (RRDR) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Rear Right Door
                                </p>
                              </div>
                              {/* Rough */}

                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection for "Rough Operation"
                                    setSelectedButtonRRDR((prev) =>
                                      prev === "Rough Operation"
                                        ? null
                                        : "Rough Operation"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonRRDR === "Rough Operation"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonRRDR === "Rough Operation"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonRRDR ===
                                      "Rough Operation" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Rough Operation
                                  </span>
                                </button>
                              </div>

                              <div className="mt-5"></div>
                              <div className="w-full sm:w-auto">
                                <button
                                  onClick={() => {
                                    // Toggle the button selection for "Gaps Observed"
                                    setSelectedButtonGORRDR((prev) =>
                                      prev === "Gaps Observed"
                                        ? null
                                        : "Gaps Observed"
                                    );
                                  }}
                                  className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
                                    selectedButtonGORRDR === "Gaps Observed"
                                      ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
                                      : "bg-transparent border border-white text-white font-semibold"
                                  }`}
                                >
                                  <span
                                    className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
                                      selectedButtonGORRDR === "Gaps Observed"
                                        ? "bg-[#ADD144]"
                                        : "bg-transparent"
                                    }`}
                                  >
                                    {selectedButtonGORRDR ===
                                      "Gaps Observed" && (
                                      <span className="absolute text-[#191F09] text-lg">
                                        &#10003; {/* Checkmark */}
                                      </span>
                                    )}
                                  </span>
                                  <span className="truncate">
                                    Gaps Observed
                                  </span>
                                </button>
                              </div>
                            </div>

                            {/* Condionally render GAP */}

                            {selectedButtonGORRDR === "Gaps Observed" && (
                              <div className="flex flex-wrap lg:flex-nowrap space-y-4 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-banner bg-opacity-70 text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Top
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Top"
                                    value={valueGRT5}
                                    onChange={(e) =>
                                      setValueGRT5(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGORRDR === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGORRDR !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Down
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Down"
                                    value={valueGRD5}
                                    onChange={(e) =>
                                      setValueGRD5(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGORRDR === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGORRDR !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>
                            )}

                            {/* Rear Left Door (RRLR) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Rear Left Door
                                </p>
                              </div>
                              {/* Rough */}

                              <div className="w-full sm:w-auto">
  <button
    onClick={() => {
      // Toggle the button selection for "Rough Operation"
      setSelectedButtonRRLR((prev) =>
        prev === "Rough Operation" ? null : "Rough Operation"
      );
    }}
    className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
      selectedButtonRRLR === "Rough Operation"
        ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
        : "bg-transparent border border-white text-white font-semibold"
    }`}
  >
    <span
      className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
        selectedButtonRRLR === "Rough Operation" ? "bg-[#ADD144]" : "bg-transparent"
      }`}
    >
      {selectedButtonRRLR === "Rough Operation" && (
        <span className="absolute text-[#191F09] text-lg">
          &#10003; {/* Checkmark */}
        </span>
      )}
    </span>
    <span className="truncate">Rough Operation</span>
  </button>
</div>

                              <div className="mt-5"></div>
                              <div className="w-full sm:w-auto">
  <button
    onClick={() => {
      // Toggle the button selection for "Gaps Observed"
      setSelectedButtonGORRLD((prev) =>
        prev === "Gaps Observed" ? null : "Gaps Observed"
      );
    }}
    className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
      selectedButtonGORRLD === "Gaps Observed"
        ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
        : "bg-transparent border border-white text-white font-semibold"
    }`}
  >
    <span
      className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
        selectedButtonGORRLD === "Gaps Observed" ? "bg-[#ADD144]" : "bg-transparent"
      }`}
    >
      {selectedButtonGORRLD === "Gaps Observed" && (
        <span className="absolute text-[#191F09] text-lg">
          &#10003; {/* Checkmark */}
        </span>
      )}
    </span>
    <span className="truncate">Gaps Observed</span>
  </button>
</div>

                            </div>

                            {/* Condionally render GAP */}

                            {selectedButtonGORRLD === "Gaps Observed" && (
                              <div className="flex flex-wrap lg:flex-nowrap space-y-4 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-banner bg-opacity-70 text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Top
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Top"
                                    value={valueGRT6}
                                    onChange={(e) =>
                                      setValueGRT6(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGORRLD === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGORRLD !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Down
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Down"
                                    value={valueGRD6}
                                    onChange={(e) =>
                                      setValueGRD6(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGORRLD === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGORRLD !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>
                            )}

                            {/* Boot Right (BRR) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Boot Right
                                </p>
                              </div>
                              {/* Rough */}

                              <div className="w-full sm:w-auto">
  <button
    onClick={() => {
      // Toggle the button selection for "Rough Operation"
      setSelectedButtonBRR((prev) =>
        prev === "Rough Operation" ? null : "Rough Operation"
      );
    }}
    className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
      selectedButtonBRR === "Rough Operation"
        ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
        : "bg-transparent border border-white text-white font-semibold"
    }`}
  >
    <span
      className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
        selectedButtonBRR === "Rough Operation" ? "bg-[#ADD144]" : "bg-transparent"
      }`}
    >
      {selectedButtonBRR === "Rough Operation" && (
        <span className="absolute text-[#191F09] text-lg">
          &#10003; {/* Checkmark */}
        </span>
      )}
    </span>
    <span className="truncate">Rough Operation</span>
  </button>
</div>

                              <div className="mt-5"></div>
                              <div className="w-full sm:w-auto">
  <button
    onClick={() => {
      // Toggle the button selection for "Gaps Observed"
      setSelectedButtonGOBR((prev) =>
        prev === "Gaps Observed" ? null : "Gaps Observed"
      );
    }}
    className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
      selectedButtonGOBR === "Gaps Observed"
        ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
        : "bg-transparent border border-white text-white font-semibold"
    }`}
  >
    <span
      className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
        selectedButtonGOBR === "Gaps Observed" ? "bg-[#ADD144]" : "bg-transparent"
      }`}
    >
      {selectedButtonGOBR === "Gaps Observed" && (
        <span className="absolute text-[#191F09] text-lg">
          &#10003; {/* Checkmark */}
        </span>
      )}
    </span>
    <span className="truncate">Gaps Observed</span>
  </button>
</div>

                            </div>

                            {/* Condionally render GAP */}

                            {selectedButtonGOBR === "Gaps Observed" && (
                              <div className="flex flex-wrap lg:flex-nowrap space-y-4 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Top
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Top"
                                    value={valueGRT7}
                                    onChange={(e) =>
                                      setValueGRT7(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOBR === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOBR !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Down
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Down"
                                    value={valueGRD7}
                                    onChange={(e) =>
                                      setValueGRD7(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOBR === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOBR !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>
                            )}

                            {/* BOOT lEFT (BRT) */}

                            <div className="flex flex-col items-start lg:mx-10 pt-3">
                              <div className="">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Boot Left
                                </p>
                              </div>
                              {/* Rough */}

                              <div className="w-full sm:w-auto">
  <button
    onClick={() => {
      // Toggle the button selection for "Rough Operation"
      setSelectedButtonBRT((prev) =>
        prev === "Rough Operation" ? null : "Rough Operation"
      );
    }}
    className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
      selectedButtonBRT === "Rough Operation"
        ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
        : "bg-transparent border border-white text-white font-semibold"
    }`}
  >
    <span
      className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
        selectedButtonBRT === "Rough Operation" ? "bg-[#ADD144]" : "bg-transparent"
      }`}
    >
      {selectedButtonBRT === "Rough Operation" && (
        <span className="absolute text-[#191F09] text-lg">
          &#10003; {/* Checkmark */}
        </span>
      )}
    </span>
    <span className="truncate">Rough Operation</span>
  </button>
</div>

                              <div className="mt-5"></div>
                              <div className="w-full sm:w-auto">
  <button
    onClick={() => {
      // Toggle the button selection for "Gaps Observed"
      setSelectedButtonGOBT((prev) =>
        prev === "Gaps Observed" ? null : "Gaps Observed"
      );
    }}
    className={`flex items-center justify-center space-x-5 w-full sm:w-auto py-3 px-6 rounded-full transition-all duration-300 text-sm sm:text-base ${
      selectedButtonGOBT === "Gaps Observed"
        ? "bg-[#191F09] text-[#ADD144] font-semibold" // Text color when selected
        : "bg-transparent border border-white text-white font-semibold"
    }`}
  >
    <span
      className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 border-2 border-white rounded-full transition-colors duration-300 ${
        selectedButtonGOBT === "Gaps Observed" ? "bg-[#ADD144]" : "bg-transparent"
      }`}
    >
      {selectedButtonGOBT === "Gaps Observed" && (
        <span className="absolute text-[#191F09] text-lg">
          &#10003; {/* Checkmark */}
        </span>
      )}
    </span>
    <span className="truncate">Gaps Observed</span>
  </button>
</div>

                            </div>

                            {/* Condionally render GAP */}

                            {selectedButtonGOBT === "Gaps Observed" && (
                              <div className="flex flex-wrap lg:flex-nowrap space-y-4 lg:space-y-0 lg:space-x-4 w-full lg:w-[700px] pt-8  lg:mx-10">
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Top
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Top"
                                    value={valueGRT8}
                                    onChange={(e) =>
                                      setValueGRT8(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOBT === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOBT !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                                <div className="relative mb-4 lg:mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-4 lg:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Gap Reading Down
                                  </label>
                                  <input
                                    type="text"
                                    name="Gap Reading Down"
                                    value={valueGRD8}
                                    onChange={(e) =>
                                      setValueGRD8(e.target.value)
                                    }
                                    // required={
                                    //   selectedButtonGOBT === "Gaps Observed"
                                    // } // Only required if the button is selected
                                    // disabled={
                                    //   selectedButtonGOBT !== "Gaps Observed"
                                    // } // Disable input if the button is not selected
                                    className="border rounded-full w-full py-4 px-4 lg:py-5 lg:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>
                            )}

                            <div
                              className="w-full flex justify-center "
                              onClick={handleSaveFlushesAndGaps}
                            >
                              <button className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full sm:mt-8 ">
                                {savedFlushesAndGapsMessage
                                  ? savedFlushesAndGapsMessage
                                  : "Save"}
                              </button>
                            </div>
                          </div>
                        )}

                        {selected === "interior" && (
                          <div className="exterior-form space-y-2 w-full">
                            {/* Plastic Panles */}

                            <h4 className="text-[#FFFFFF] text-[24px] pb-5 text-center">
                              Plastic Panels
                            </h4>
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Driver side
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesPDS"
                                  value={selectedConditionPDS}
                                  onChange={(e) =>
                                    setSelectedConditionPDS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Plastic Panels']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPicturePDS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setPlasticPanelFile1)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Co Driver Side */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Co Driver side
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesPCDS"
                                  value={selectedConditionPCDS}
                                  onChange={(e) =>
                                    setSelectedConditionPCDS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Plastic Panels']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPicturePCDS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setPlasticPanelFile2)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Driver Rear Side */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Driver Rear Side
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesPDRS"
                                  value={selectedConditionPDRS}
                                  onChange={(e) =>
                                    setSelectedConditionPDRS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Plastic Panels']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPicturePDRS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setPlasticPanelFile3)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Co Driver Rear Side */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Co Driver Rear Side
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesPCDRS"
                                  value={selectedConditionPCDRS}
                                  onChange={(e) =>
                                    setSelectedConditionPCDRS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Plastic Panels']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPicturePCDRS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setPlasticPanelFile4)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Boot (BI) */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Boot
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssuesBIS"
                                  value={selectedConditionBIS}
                                  onChange={(e) =>
                                    setSelectedConditionBIS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Plastic Panels']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPicturePCDRS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setPlasticPanelFile5)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Dashboard */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Dashboard
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesD"
                                  value={selectedConditionD}
                                  onChange={(e) =>
                                    setSelectedConditionD(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Plastic Panels']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureD"
                                  onChange={(e) =>
                                    handleFileUpload(e, setPlasticPanelFile6)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Gear Console */}

                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Gear Console
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesGC"
                                  value={selectedConditionGC}
                                  onChange={(e) =>
                                    setSelectedConditionGC(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Plastic Panels']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureGC"
                                  onChange={(e) =>
                                    handleFileUpload(e, setPlasticPanelFile7)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="w-full flex justify-center">
                              <button
                                className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                                onClick={handleSavePlasticPanelDetails}
                              >
                                {savedPlasticPanelMessage
                                  ? savedPlasticPanelMessage
                                  : "Save"}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Third Form */}

                      {/* Rubber Components */}

                      <div className="flex w-full max-w-3xl mt-10 flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative mx-auto">
                        {selected === "exterior" && (
                          <div className="exterior-form space-y-2 w-full">
                            <h4 className="text-[#FFFFFF] text-[24px] pb-5 text-center">
                              Rubber Components
                            </h4>

                            {/* Beading : Front Left Door */}
                            <div className="flex flex-col items-start  lg:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Beading: Front Left Door
                                </p>

                                {/* Toggle Button */}
                                <div
                                  onClick={() => setIsToggled(!isToggled)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggled ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggled
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggled ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>

                              {/* Conditional Content */}
                              {isToggled && (
                                <div className="flex flex-col lg:flex-row  space-y-6 sm:space-y-0 w-full pt-6 pb-6 lg:pl-10">
                                {/* Condition/Issues Dropdown */}
                                <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                  <label className="absolute left-4 top-[-10px] bg-[#1F1F1F] text-[12px]  text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions 
                                  </label>
                                  <select
                                      name="conditionIssues"
                                      value={selectedConditionRC1}
                                      onChange={(e) => setSelectedConditionRC1(e.target.value)}
                                     
                                    // required={isToggledBB} // Only required if the button is selected
                                    // disabled={!isToggledBB} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Rubber Components']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              
                                {/* Upload Picture */}
                                <div className="relative w-full lg:w-[300px]">
                                  <label className="absolute left-4 top-[-10px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) => handleFileUpload(e, setRubberComponentFile1)
                                    
                                    }
                                    // required={isToggledBB} // Only required if the button is selected
                                    // disabled={!isToggledBB} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-6 h-6 sm:w-8 sm:h-8"
                                    />
                                  </div>
                                </div>
                              </div>
                              
                              )}
                            </div>

                            {/* Beading Rear Left Door  (BRLD) */}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Beading : Rear Left Door
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledBRLD(!isToggledBRLD)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledBRLD
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledBRLD
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledBRLD ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledBRLD && (
                              <div className="flex flex-col lg:flex-row  space-y-6 sm:space-y-0 w-full pt-6 pb-6 lg:pl-10">
                                {/* Condition/Issues Dropdown */}
                                <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                  <label className="absolute left-4 top-[-10px] bg-[#1F1F1F] text-[12px]  text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions 
                                  </label>
                                  <select
                                     name="conditionIssues"
                                     value={selectedConditionRC2}
                                     onChange={(e) =>
                                       setSelectedConditionRC2(e.target.value)
                                     }
                                    // required={isToggledBB} // Only required if the button is selected
                                    // disabled={!isToggledBB} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Rubber Components']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>

                                {/* Upload Picture */}
                                <div className="relative w-full lg:w-[300px]">
                                  <label className="absolute left-4 top-[-10px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setRubberComponentFile2
                                      )
                                    
                                    }
                                    // required={isToggledBB} // Only required if the button is selected
                                    // disabled={!isToggledBB} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-6 h-6 sm:w-8 sm:h-8"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Beading : Boot (BB) */}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Beading : Boot
                                </p>
                                <div
                                  onClick={() => setIsToggledBB(!isToggledBB)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledBB ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledBB
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledBB ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledBB && (
                              <div className="flex flex-col lg:flex-row  space-y-6 sm:space-y-0 w-full pt-6 pb-6  lg:pl-10">
                                {/* Condition/Issues Dropdown */}
                                <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                  <label className="absolute left-4 top-[-10px] bg-[#1F1F1F] text-[12px]  text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions 
                                  </label>
                                  <select
                                    name="conditionIssues"
                                    value={selectedConditionRC3}
                                    onChange={(e) =>
                                      setSelectedConditionRC3(e.target.value)
                                    }
                                    // required={isToggledBB} // Only required if the button is selected
                                    // disabled={!isToggledBB} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Rubber Components']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>

                                {/* Upload Picture */}
                                <div className="relative w-full lg:w-[300px]">
                                  <label className="absolute left-4 top-[-10px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setRubberComponentFile3
                                      )
                                    }
                                    // required={isToggledBB} // Only required if the button is selected
                                    // disabled={!isToggledBB} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-6 h-6 sm:w-8 sm:h-8"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Beading : Rear Right Door (BRRD) */}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Beading : Rear Right Door
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledBRRD(!isToggledBRRD)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledBRRD
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledBRRD
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledBRRD ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledBRRD && (
                              <div className="flex flex-col lg:flex-row  space-y-6 sm:space-y-0 w-full pt-6 pb-6 lg:pl-10">
                                {/* Condition/Issues Dropdown */}
                                <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                  <label className="absolute left-4 top-[-10px] text-[12px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions 
                                  </label>
                                  <select
                                    name="conditionIssues"
                                    value={selectedConditionRC4}
                                    onChange={(e) =>
                                      setSelectedConditionRC4(e.target.value)
                                    }
                                    // required={isToggledBRRD} // Only required if the button is selected
                                    // disabled={!isToggledBRRD} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Rubber Components']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>

                                {/* Upload Picture */}
                                <div className="relative w-full lg:w-[300px]">
                                  <label className="absolute left-4 top-[-10px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setRubberComponentFile4
                                      )
                                    }
                                    // required={isToggledBRRD} // Only required if the button is selected
                                    // disabled={!isToggledBRRD} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-6 h-6 sm:w-8 sm:h-8"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Beading : Front Right Door ( BFRD) */}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Beading : Front Right Door
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledBFRD(!isToggledBFRD)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledBFRD
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledBFRD
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledBFRD ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledBFRD && (
                              <div className="flex flex-col lg:flex-row  space-y-6 sm:space-y-0 w-full pt-6 pb-6 lg:pl-10">
                                {/* Condition/Issues Dropdown */}
                                <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                  <label className="absolute left-4 top-[-10px] text-[12px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions
                                  </label>
                                  <select
                                    name="conditionIssues"
                                    value={selectedConditionRC5}
                                    onChange={(e) =>
                                      setSelectedConditionRC5(e.target.value)
                                    }
                                    // required={isToggledBFRD} // Only required if the button is selected
                                    // disabled={!isToggledBFRD} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Rubber Components']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>

                                {/* Upload Picture */}
                                <div className="relative w-full lg:w-[300px]">
                                  <label className="absolute left-4 top-[-10px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setRubberComponentFile5
                                      )
                                    }
                                    // required={isToggledBFRD} // Only required if the button is selected
                                    // disabled={!isToggledBFRD} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-6 h-6 sm:w-8 sm:h-8"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Front Under The Bonnet (FUB) */}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4 mb-5 lg:mb-0">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Front Under The Bonnet
                                </p>
                                <div
                                  onClick={() => setIsToggledFUB(!isToggledFUB)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledFUB
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledFUB
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledFUB ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledFUB && (
                              <div className="flex flex-col lg:flex-row  space-y-6 sm:space-y-0 w-full pt-6 pb-6 lg:pl-10">
                                {/* Condition/Issues Dropdown */}
                                <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                  <label className="absolute left-4 top-[-10px] text-[12px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions
                                  </label>
                                  <select
                                    name="conditionIssues"
                                    value={selectedConditionRC6}
                                    onChange={(e) =>
                                      setSelectedConditionRC6(e.target.value)
                                    }
                                    // required={isToggledFUB} // Only required if the button is selected
                                    // disabled={!isToggledFUB} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Rubber Components']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>

                                {/* Upload Picture */}
                                <div className="relative w-full lg:w-[300px] mb-5 lg:mb-0">
                                  <label className="absolute left-4 top-[-10px] bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        setRubberComponentFile6
                                      )
                                    }
                                    // required={isToggledFUB} // Only required if the button is selected
                                    // disabled={!isToggledFUB} // Disable input if the button is not selected
                                    className="border rounded-lg w-full py-3 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-6 h-6 sm:w-8 sm:h-8"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Save Btn */}

                            <div className="w-full flex justify-center mt-5">
                              <button
                                className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                                onClick={handleSaveRubberComponents}
                              >
                                {savedRubberComponentsMessage
                                  ? savedRubberComponentsMessage
                                  : "Save"}
                              </button>
                            </div>
                          </div>
                        )}

                        {selected === "interior" && (
                          <div className="exterior-form space-y-2 w-full">
                            {/* Seat */}
                            <h4 className="text-[#FFFFFF] text-[24px] pb-5 text-center">
                              Seat
                            </h4>

                            {/* Driver Side */}
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Driver side
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesSDS"
                                  value={selectedConditionSDS}
                                  onChange={(e) =>
                                    setSelectedButtonSDS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Seat']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureSDS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setSeatFile1)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/*Co Driver Side */}
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Co Driver seat
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesSCDS"
                                  value={selectedConditionSCDS}
                                  onChange={(e) =>
                                    setSelectedButtonSCDS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Seat']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureSCDS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setSeatFile2)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Driver Rear Side */}
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Driver Rear seat
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesSDRS"
                                  value={selectedConditionSDRS}
                                  onChange={(e) =>
                                    setSelectedButtonSDRS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Seat']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureSDRS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setSeatFile3)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Co Driver Rear Side */}
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Co Driver Rear seat
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4 pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssuesSCDRS"
                                  value={selectedConditionSCDRS}
                                  onChange={(e) =>
                                    setSelectedButtonSCDRS(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Seat']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureSCDRS"
                                  onChange={(e) =>
                                    handleFileUpload(e, setSeatFile4)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Headrest Driver Side */}
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Driver Headrest
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4 pt-4 lg:x-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesHR"
                                  value={selectedConditionHR}
                                  onChange={(e) =>
                                    setSelectedButtonHR(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Seat']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureHR"
                                  onChange={(e) =>
                                    handleFileUpload(e, setSeatFile5)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/*Co Driver Headrest Side */}
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Co Driver Headrest
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4 pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssuesCHR"
                                  value={selectedConditionCHR}
                                  onChange={(e) =>
                                    setSelectedButtonCHR(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Seat']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureCHR"
                                  onChange={(e) =>
                                    handleFileUpload(e, setSeatFile6)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Driver Rear Headrset Side */}
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Rear Left Headrset
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4  pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssuesRHR"
                                  value={selectedConditionRHR}
                                  onChange={(e) =>
                                    setSelectedButtonRHR(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Seat']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureRHR"
                                  onChange={(e) =>
                                    handleFileUpload(e, setSeatFile7)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>

                            {/*  Rear Right Headrest Side */}
                            <div className="">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                                Rear Right Headrest
                              </p>
                            </div>

                            <div className="flex flex-col lg:flex-row space-x-4 pt-4 lg:mx-10">
                              <div className="relative mb-8 lg:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssuesHCDR"
                                  value={selectedConditionHCDR}
                                  onChange={(e) =>
                                    setSelectedButtonHCDR(e.target.value)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Seat']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                {/* SVG Icon */}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                              <div className="relative mb-8 lg:w-[300px] w-full lg:mx-10">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Upload Picture
                                </label>
                                <input
                                  type="file"
                                  name="uploadPictureHCDR"
                                  onChange={(e) =>
                                    handleFileUpload(e, setSeatFile8)
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                />
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                  <img
                                    src={cam}
                                    alt="cam icon"
                                    className="w-8 h-8"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* FOURTH Compoent */}

                      {/* Glass & Mirrors Components */}

                      <div className="flex w-full max-w-3xl mt-10 flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative mx-auto">
                        {selected === "exterior" && (
                          <div className="exterior-form space-y-2 w-full">
                            <h4 className="text-[#FFFFFF] text-[24px] pb-5 text-center">
                              Glass & Mirrors
                            </h4>

                            {/* Beading : Front Left Door */}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Front Windscreen
                                </p>
                                <div
                                  onClick={() => setIsToggledFW(!isToggledFW)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledFW ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledFW
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledFW ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledFW && (
                       <div className="flex flex-col lg:flex-row items-start gap-8 lg:w-[700px] w-full  pt-8 lg:mx-10 md:mx-5 ">
                       {/* First Row: Two input fields */}
                       <div className="flex flex-col item-center lg:space-x-4  lg:space-y-4 md:space-y-4 sm:space-y-4 w-full lg:mb-8 mb-4">
                         {/* Select Brand */}
                         <div className="relative lg:w-[300px] w-full lg:ml-4 ">
                           <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                             Select Brand
                           </label>
                           <input
                             type="text"
                             name="conditionIssues"
                             value={selectedConditionGM1}
                             onChange={(e) => setSelectedConditionGM1(e.target.value)}
                             className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                           />
                         </div>
                     
                         {/* Upload Picture */}
                         <div className="relative lg:w-[300px]  w-full mt-8 ">
                           <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold ">
                             Upload Picture
                           </label>
                           <input
                             type="file"
                             name="uploadPicture"
                             onChange={(e) => handleFileUpload(e, setGlassMirrorFile1)}
                             className="border rounded-full w-full py-5  px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                           />
                           <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                             <img src={cam} alt="cam icon" className="w-8 h-8" />
                           </div>
                         </div>
                       </div>
                     
                       {/* Second Row: Issue Input */}
                       <div className="w-full mb-8">
                         <div className="relative lg:w-[300px] w-full">
                           <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-[12px] font-semibold px-1">
                             Enter the conditions 
                           </label>
                           <select
                             name="conditionIssues"
                             value={selectedConditionGM2}
                             onChange={(e) => setSelectedConditionGM2(e.target.value)}
                             className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                           >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                           </select>
                           <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                             <svg
                               width="18"
                               height="12"
                               viewBox="0 0 18 12"
                               fill="none"
                               xmlns="http://www.w3.org/2000/svg"
                             >
                               <path
                                 d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                 fill="#F0FFC5"
                               />
                             </svg>
                           </div>
                         </div>
                       </div>
                     </div>
                     
                          
                            )}

                            {/* Front Wiper Left (FWL) */}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Front Wiper Left
                                </p>
                                <div
                                  onClick={() => setIsToggledFWL(!isToggledFWL)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledFWL
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledFWL
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledFWL ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledFWL && (
  <div className="flex flex-col lg:flex-row lg:space-x-10 md:space-x-2 sm:space-y-4 lg:w-[700px] md:w-full sm:w-full pt-8 lg:mx-10 sm:mx-4 md:mx-6">
    {/* Wrapper for each section */}
    <div className="flex flex-col items-center  lg:flex-row md:space-x-4 lg:flex-row lg:space-x-4">
      {/* Select Conditions/Issues */}
      <div className="relative lg:w-[300px] w-full">
        <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
          Enter the conditions
        </label>
        <select
          name="conditionIssues"
          value={selectedConditionGM3}
          onChange={(e) => setSelectedConditionGM3(e.target.value)}
          className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
        >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
        </select>
        {/* SVG Icon */}
        <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
          <svg
            width="18"
            height="12"
            viewBox="0 0 18 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
              fill="#F0FFC5"
            />
          </svg>
        </div>
      </div>

      {/* Upload Picture */}
      <div className="relative lg:w-[300px] w-full mt-10 lg:mt-0">
        <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
          Upload Picture
        </label>
        <input
          type="file"
          name="uploadPicture"
          onChange={(e) => handleFileUpload(e, setGlassMirrorFile2)}
          className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
        />
        <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
          <img src={cam} alt="cam icon" className="w-8 h-8" />
        </div>
      </div>
    </div>
  </div>
)}

                            {/* Front Wiper Right (FWR) */}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Front Wiper Right
                                </p>
                                <div
                                  onClick={() => setIsToggledFWR(!isToggledFWR)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledFWR
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledFWR
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledFWR ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledFWR && (
                              <div className="flex flex-col lg:flex-row lg:space-x-4 md:space-x-2 sm:space-y-4 lg:w-[700px] md:w-full sm:w-full pt-8 lg:mx-10 sm:mx-4 md:mx-6">
                                {/* Wrapper for both fields */}
                                <div className="flex flex-col items-center  lg:flex-row md:space-x-4 lg:flex-row lg:space-x-4">
                                  {/* Select Conditions/Issues */}
                                  <div className="relative mb-10 lg:mb-8 lg:w-[300px] w-full">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[12px]  text-[#F0FFC5] font-semibold px-1">
                                      Enter the conditions 
                                    </label>
                                    <select
                                      name="conditionIssues"
                                      value={selectedConditionGM4}
                                      onChange={(e) =>
                                        setSelectedConditionGM4(e.target.value)
                                      }
                                      // required={isToggledFWR}
                                      // disabled={!isToggledFWR}
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    </select>

                                    {/* SVG Icon */}
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                      <svg
                                        width="18"
                                        height="12"
                                        viewBox="0 0 18 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                          fill="#F0FFC5"
                                        />
                                      </svg>
                                    </div>
                                  </div>

                                  {/* Upload Picture */}
                                  <div className="relative mb-0 lg:mb-8 lg:w-[300px] w-full">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Upload Picture
                                    </label>
                                    <input
                                      type="file"
                                      name="uploadPicture"
                                      onChange={(e) =>
                                        handleFileUpload(e, setGlassMirrorFile3)
                                      }
                                      // required={isToggledFWR}
                                      // disabled={!isToggledFWR}
                                      className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                    />
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                      <img
                                        src={cam}
                                        alt="cam icon"
                                        className="w-8 h-8"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Front Left ORVM Glass (l)*/}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Front Left ORVM Glass
                                </p>
                                <div
                                  onClick={() => setIsToggledL(!isToggledL)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledL ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledL
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledL ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledL && (
                              <div className="flex flex-col lg:flex-row items-start  lg:w-[700px] w-full  pt-8 lg:mx-10 md:mx-5">
                                {/* First Row: Two input fields */}
                                <div className="flex flex-col item-center lg:space-x-4  lg:space-y-4 md:space-y-4 sm:space-y-4 w-full lg:mb-8 mb-4">
                                  {/* Select Brand */}
                                  <div className="relative lg:w-[300px] w-full lg:mb-4 mb-10">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Select Brand
                                    </label>
                                    <input
                                      type="text"
                                      name="conditionIssues"
                                      value={selectedConditionGM5}
                                      onChange={(e) =>
                                        setSelectedConditionGM5(e.target.value)
                                      }
                                      // required={isToggledL}
                                      // disabled={!isToggledL}
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                    />
                                  </div>

                                  {/* Upload Picture */}
                                  <div className="relative lg:w-[300px] w-full">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Upload Picture
                                    </label>
                                    <input
                                      type="file"
                                      name="uploadPicture"
                                      onChange={(e) =>
                                        handleFileUpload(e, setGlassMirrorFile4)
                                      }
                                      // required={isToggledL}
                                      // disabled={!isToggledL}
                                      className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                    />
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                      <img
                                        src={cam}
                                        alt="cam icon"
                                        className="w-8 h-8"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Second Row: Issue Input */}
                                <div className="flex w-full justify-center lg:mt-0 mt-5 lg:mb-0 mb-5">
                                  <div className="relative lg:w-[300px] w-full">
                                    <label className="absolute left-6 -top-3  bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Enter the conditions
                                    </label>
                                    <select
                                      name="conditionIssues"
                                      value={selectedConditionGM6}
                                      onChange={(e) =>
                                        setSelectedConditionGM6(e.target.value)
                                      }
                                      // required={isToggledL}
                                      // disabled={!isToggledL}
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    </select>
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                      <svg
                                        width="18"
                                        height="12"
                                        viewBox="0 0 18 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                          fill="#F0FFC5"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Front Right Door (FRDGW)*/}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Front Right Door Window
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledFRDGW(!isToggledFRDGW)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledFRDGW
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledFRDGW
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledFRDGW ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledFRDGW && (
                              <div className="flex flex-col lg:flex-row items-start gap-0 lg:w-[700px] w-full  pt-8 lg:mx-10 md:mx-5">
                                {/* First Row: Two input fields */}
                                <div className="flex flex-col item-center lg:space-x-4  lg:space-y-4 md:space-y-4 sm:space-y-4 w-full lg:mb-8 mb-4">
                                  {/* Select Brand */}
                                  <div className="relative w-full lg:w-[300px] lg:mb-4 mb-7">
                                    <label className="absolute left-4 sm:left-6 -top-3 bg-[#1F1F1F]  text-[#F0FFC5] font-semibold px-1">
                                      Select Brand
                                    </label>
                                    <input
                                      type="text"
                                      name="conditionIssues"
                                      value={selectedConditionGM7}
                                      onChange={(e) =>
                                        setSelectedConditionGM7(e.target.value)
                                      }
                                      // required={isToggledFRDGW}
                                      // disabled={!isToggledFRDGW}
                                      className="border rounded-full w-full py-4 px-4 sm:py-5 sm:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                    />
                                  </div>

                                  {/* Upload Picture */}
                                  <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5 lg:mr-10">
                                    <label className="absolute left-4 sm:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Upload Picture
                                    </label>
                                    <input
                                      type="file"
                                      name="uploadPicture"
                                      onChange={(e) =>
                                        handleFileUpload(e, setGlassMirrorFile5)
                                      }
                                      // required={isToggledFRDGW}
                                      // disabled={!isToggledFRDGW}
                                      className="border rounded-full w-full py-4 px-4 sm:py-5 sm:pr-12 sm:pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                    />
                                    <div className="absolute right-4 sm:right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                      <img
                                        src={cam}
                                        alt="cam icon"
                                        className="w-6 h-6 sm:w-8 sm:h-8"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Second Row: Issue Input */}
                                <div className="flex w-full justify-center mb-5 lg:mb-0">
                                  <div className="relative lg:w-[300px] w-full">
                                    <label className="absolute left-6 -top-3  bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Enter the conditions
                                    </label>
                                    <select
                                      name="conditionIssues"
                                      value={selectedConditionGM8}
                                      onChange={(e) =>
                                        setSelectedConditionGM8(e.target.value)
                                      }
                                      // required={isToggledL}
                                      // disabled={!isToggledL}
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    </select>
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                      <svg
                                        width="18"
                                        height="12"
                                        viewBox="0 0 18 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                          fill="#F0FFC5"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Front Right ORVM Glass (FRORVMG)*/}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Front Right ORVM Glass
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledFRORVMG(!isToggledFRORVMG)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledFRORVMG
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledFRORVMG
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledFRORVMG ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledFRORVMG && (
                              <div className="flex flex-wrap item-start lg:w-[700px] w-full pt-8 lg:mx-10 sm:mx-4">
                                {/* First Row: Two input fields */}
                                <div className="flex flex-wrap w-full lg:flex-nowrap sm:space-x-4 mb-8">
                                  {/* Select Brand */}
                                  <div className="relative w-full lg:w-[300px] lg:mb-4 mb-5">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Select Brand
                                    </label>
                                    <input
                                      type="text"
                                      name="conditionIssues"
                                      value={selectedConditionGM9}
                                      onChange={(e) =>
                                        setSelectedConditionGM9(e.target.value)
                                      }
                                      // required={isToggledFRORVMG}
                                      // disabled={!isToggledFRORVMG}
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                    />
                                  </div>

                                  {/* Upload Picture */}
                                  <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Upload Picture
                                    </label>
                                    <input
                                      type="file"
                                      name="uploadPicture"
                                      onChange={(e) =>
                                        handleFileUpload(e, setGlassMirrorFile6)
                                      }
                                      // required={isToggledFRORVMG}
                                      // disabled={!isToggledFRORVMG}
                                      className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                    />
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                      <img
                                        src={cam}
                                        alt="cam icon"
                                        className="w-8 h-8"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Second Row: Issue Input */}
                                <div className="w-full">
                                  <div className="relative w-full lg:w-[300px] mb-5 lg:mb-0">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Enter the conditions
                                    </label>
                                    <select
                                      name="conditionIssues"
                                      value={selectedConditionGM10}
                                      onChange={(e) =>
                                        setSelectedConditionGM10(e.target.value)
                                      }
                                      // required={isToggledFRORVMG}
                                      // disabled={!isToggledFRORVMG}
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    </select>
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                      <svg
                                        width="18"
                                        height="12"
                                        viewBox="0 0 18 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                          fill="#F0FFC5"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Rear Right Door Window (RRDW)*/}

                            <div className="flex flex-col items-start px-4 sm:px-10  ">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Rear Right Door Window
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledRRDW(!isToggledRRDW)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledRRDW
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledRRDW
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledRRDW ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledRRDW && (
                              <div className="flex flex-wrap w-full lg:w-[700px] pt-8 lg:mx-4 ">
                                {/* First Row: Two input fields */}
                                <div className="flex flex-col lg:flex-row sm:space-x-4 w-full mb-8">
                                  {/* Select Brand */}
                                  <div className="relative w-full lg:w-[300px] mb-5 lg:mb-0">
                                    <label className="absolute left-6 -top-3 bg-banner bg-opacity-70 text-[#F0FFC5] font-semibold px-1">
                                      Select Brand
                                    </label>
                                    <input
                                      type="text"
                                      name="conditionIssues"
                                      value={selectedConditionGM11}
                                      onChange={(e) =>
                                        setSelectedConditionGM11(e.target.value)
                                      }
                                      // required={isToggledRRDW} // Only required if the button is selected
                                      // disabled={!isToggledRRDW} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                    />
                                  </div>

                                  {/* Upload Picture */}
                                  <div className="relative w-full lg:w-[300px]">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Upload Picture
                                    </label>
                                    <input
                                      type="file"
                                      name="uploadPicture"
                                      onChange={(e) =>
                                        handleFileUpload(e, setGlassMirrorFile7)
                                      }
                                      // required={isToggledRRDW} // Only required if the button is selected
                                      // disabled={!isToggledRRDW} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                    />
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                      <img
                                        src={cam}
                                        alt="cam icon"
                                        className="w-8 h-8"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Second Row: Issue Input */}
                                <div className="w-full">
                                  <div className="relative w-full lg:w-[300px] mb-5 lg:mb-0">
                                    <label className="absolute left-6 text-[12px] -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Enter the conditions 
                                    </label>
                                    <select
                                      name="conditionIssues"
                                      value={selectedConditionGM12}
                                      onChange={(e) =>
                                        setSelectedConditionGM12(e.target.value)
                                      }
                                      // required={isToggledFRORVMG}
                                      // disabled={!isToggledFRORVMG}
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    </select>
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                      <svg
                                        width="18"
                                        height="12"
                                        viewBox="0 0 18 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                          fill="#F0FFC5"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Rear Windscreen (RWGD)*/}

                            <div className="flex flex-col items-start px-4 sm:px-10 ">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Rear Windscreen
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledRWGD(!isToggledRWGD)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledRWGD
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledRWGD
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledRWGD ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledRWGD && (
                              <div className="flex flex-wrap w-full lg:w-[700px] pt-8 lg:mx-4">
                                {/* First Row: Two input fields */}
                                <div className="flex flex-col lg:flex-row space-y-4 sm:space-y-0 sm:space-x-4 w-full mb-8">
                                  {/* Select Brand */}
                                  <div className="relative w-full lg:w-[300px]">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Select Brand
                                    </label>
                                    <input
                                      type="text"
                                      name="conditionIssues"
                                      value={selectedConditionGM13}
                                      onChange={(e) =>
                                        setSelectedConditionGM13(e.target.value)
                                      }
                                      // required={isToggledRWGD} // Only required if the button is selected
                                      // disabled={!isToggledRWGD} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                    />
                                  </div>

                                  {/* Upload Picture */}
                                  <div className="relative w-full lg:w-[300px] mb-5 mt-5 lg:mt-0 lg:mb-0">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Upload Picture
                                    </label>
                                    <input
                                      type="file"
                                      name="uploadPicture"
                                      onChange={(e) =>
                                        handleFileUpload(e, setGlassMirrorFile8)
                                      }
                                      // required={isToggledRWGD} // Only required if the button is selected
                                      // disabled={!isToggledRWGD} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                    />
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                      <img
                                        src={cam}
                                        alt="cam icon"
                                        className="w-8 h-8"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Second Row: Issue Input */}
                                <div className="w-full mb-8">
                                  <div className="relative w-full lg:w-[300px]">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Enter the conditions 
                                    </label>
                                    <select
                                      name="conditionIssues"
                                      value={selectedConditionGM14}
                                      onChange={(e) =>
                                        setSelectedConditionGM14(e.target.value)
                                      }
                                      // required={isToggledRWGD} // Only required if the button is selected
                                      // disabled={!isToggledRWGD} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    </select>
                                    {/* SVG Icon */}
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                      <svg
                                        width="18"
                                        height="12"
                                        viewBox="0 0 18 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                          fill="#F0FFC5"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Rear Wiper (RW) */}

                            <div className="flex flex-col items-start px-4 sm:px-10 ">
                              <div className="flex flex-col lg:flex-row flex-wrap items-start lg:justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Rear Wiper
                                </p>
                                <div
                                  onClick={() => setIsToggledRW(!isToggledRW)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledRW ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledRW
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledRW ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledRW && (
                              <div className="flex flex-col lg:flex-row sm:space-x-4 w-full lg:w-[700px] pt-8 lg:mx-4 ">
                                {/* First input: Condition select */}
                                <div className="relative mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions
                                  </label>
                                  <select
                                    name="conditionIssues"
                                    value={selectedConditionGM15}
                                    onChange={(e) =>
                                      setSelectedConditionGM15(e.target.value)
                                    }
                                    // required={isToggledRW} // Only required if the button is selected
                                    // disabled={!isToggledRW} // Disable input if the button is not selected
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>
                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>

                                {/* Second input: Upload Picture */}
                                <div className="relative mb-8 w-full lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(e, setGlassMirrorFile9)
                                    }
                                    // required={isToggledRW} // Only required if the button is selected
                                    // disabled={!isToggledRW} // Disable input if the button is not selected
                                    className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-8 h-8"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Rear Left Door Window (RLDWN)*/}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Rear Left Door Window
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledRLDWN(!isToggledRLDWN)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledRLDWN
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledRLDWN
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledRLDWN ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledRLDWN && (
                              <div className="flex flex-wrap w-full lg:w-[700px] pt-8 lg:mx-4">
                                {/* First Row: Two input fields */}
                                <div className="flex flex-col lg:flex-row space-y-4 sm:space-y-0 sm:space-x-4 w-full mb-8">
                                  {/* Select Brand */}
                                  <div className="relative w-full lg:w-[300px] mb-4 sm:mb-5">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Select Brand
                                    </label>
                                    <input
                                      type="text"
                                      name="conditionIssues"
                                      value={selectedConditionGM16}
                                      onChange={(e) =>
                                        setSelectedConditionGM16(e.target.value)
                                      }
                                      // required={isToggledRLDWN} // Only required if the button is selected
                                      // disabled={!isToggledRLDWN} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                    />
                                  </div>

                                  {/* Upload Picture */}
                                  <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Upload Picture
                                    </label>
                                    <input
                                      type="file"
                                      name="uploadPicture"
                                      onChange={(e) =>
                                        handleFileUpload(
                                          e,
                                          setGlassMirrorFile10
                                        )
                                      }
                                      // required={isToggledRLDWN} // Only required if the button is selected
                                      // disabled={!isToggledRLDWN} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                    />
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                      <img
                                        src={cam}
                                        alt="cam icon"
                                        className="w-8 h-8"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Second Row: Issue Input */}
                                <div className="w-full mb-8">
                                  <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Enter the conditions 
                                    </label>
                                    <select
                                      name="conditionIssues"
                                      value={selectedConditionGM17}
                                      onChange={(e) =>
                                        setSelectedConditionGM17(e.target.value)
                                      }
                                      // required={isToggledRLDWN} // Only required if the button is selected
                                      // disabled={!isToggledRLDWN} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    </select>
                                    {/* SVG Icon */}
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                      <svg
                                        width="18"
                                        height="12"
                                        viewBox="0 0 18 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                          fill="#F0FFC5"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Front Left Door Window (FLDWN)*/}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-wrap items-center justify-between w-full gap-4">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Front Left Door Window
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledFLDWN(!isToggledFLDWN)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledFLDWN
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledFLDWN
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledFLDWN ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledFLDWN && (
                              <div className="flex flex-wrap w-full pt-8 lg:mx-10">
                                {/* First Row: Two input fields */}
                                <div className="flex flex-col lg:flex-row space-y-4 sm:space-y-0 sm:space-x-4 w-full mb-8">
                                  {/* Select Brand */}
                                  <div className="relative w-full lg:w-[300px] lg:mb-0 mb-5">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Select Brand
                                    </label>
                                    <input
                                      type="text"
                                      name="conditionIssues"
                                      value={selectedConditionGM18}
                                      onChange={(e) =>
                                        setSelectedConditionGM18(e.target.value)
                                      }
                                      // required={isToggledFLDWN}
                                      // disabled={!isToggledFLDWN}
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                    />
                                  </div>

                                  {/* Upload Picture */}
                                  <div className="relative w-full lg:w-[300px] lg:mt-0 mt-5 lg:mb-0 mb-5">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Upload Picture
                                    </label>
                                    <input
                                      type="file"
                                      name="uploadPicture"
                                      onChange={(e) =>
                                        handleFileUpload(
                                          e,
                                          setGlassMirrorFile11
                                        )
                                      }
                                      // required={isToggledFLDWN}
                                      // disabled={!isToggledFLDWN}
                                      className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                    />
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                      <img
                                        src={cam}
                                        alt="cam icon"
                                        className="w-8 h-8"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Second Row: Issue Input */}
                                <div className="w-full mb-8">
                                  <div className="relative w-full sm:w-full lg:w-[300px]">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Enter the conditions 
                                    </label>
                                    <select
                                      name="conditionIssues"
                                      value={selectedConditionGM19}
                                      onChange={(e) =>
                                        setSelectedConditionGM19(e.target.value)
                                      }
                                      // required={isToggledFLDWN}
                                      // disabled={!isToggledFLDWN}
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    </select>
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                      <svg
                                        width="18"
                                        height="12"
                                        viewBox="0 0 18 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                          fill="#F0FFC5"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Sunroof (SR)*/}

                            <div className="flex flex-col items-start px-4 sm:px-10">
                              <div className="flex flex-col lg:flex-row flex-wrap items-start justify-between w-full gap-4 mb-5 lg:mb-0">
                                {/* Label */}
                                <p className="text-[#FFFFFF] text-[16px] sm:text-[20px] pb-3 sm:pb-5">
                                  Sunroof
                                </p>
                                <div
                                  onClick={() => setIsToggledSR(!isToggledSR)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledSR ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledSR
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledSR ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledSR && (
                              <div className="lex flex-wrap w-full pt-8 lg:mx-10">
                                {/* First Row: Two input fields */}
                                <div className="flex flex-col lg:flex-row sm:space-x-4 w-full mb-8">
                                  {/* Select Brand */}
                                  <div className="relative w-full lg:w-[300px] lg:mb-4 mb-5">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Select Brand
                                    </label>
                                    <input
                                      type="text"
                                      name="conditionIssues"
                                      value={selectedConditionGM20}
                                      onChange={(e) =>
                                        setSelectedConditionGM20(e.target.value)
                                      }
                                      // required={isToggledSR} // Only required if the button is selected
                                      // disabled={!isToggledSR} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                    />
                                  </div>

                                  {/* Upload Picture */}
                                  <div className="relative w-full lg:w-[300px] mb-5 lg:mb-0">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Upload Picture
                                    </label>
                                    <input
                                      type="file"
                                      name="uploadPicture"
                                      onChange={(e) =>
                                        handleFileUpload(
                                          e,
                                          setGlassMirrorFile12
                                        )
                                      }
                                      // required={isToggledSR} // Only required if the button is selected
                                      // disabled={!isToggledSR} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                    />
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                      <img
                                        src={cam}
                                        alt="cam icon"
                                        className="w-8 h-8"
                                      />
                                    </div>
                                  </div>
                                </div>

                                {/* Second Row: Issue Input */}
                                <div className="w-full mb-8">
                                  <div className="relative w-full lg:w-[300px] mb-5 lg:mb-0">
                                    <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                      Enter the conditions
                                    </label>
                                    <select
                                      name="conditionIssues"
                                      value={selectedConditionGM21}
                                      onChange={(e) =>
                                        setSelectedConditionGM21(e.target.value)
                                      }
                                      // required={isToggledSR} // Only required if the button is selected
                                      // disabled={!isToggledSR} // Disable input if the button is not selected
                                      className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                    >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Glass & Mirrors']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    </select>
                                    {/* SVG Icon */}
                                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                      <svg
                                        width="18"
                                        height="12"
                                        viewBox="0 0 18 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                          fill="#F0FFC5"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Save BTn  */}

                            <div className="w-full flex justify-center mt-5">
                              <button
                                className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                                onClick={handleSaveGlassAndMirrorsDetails}
                              >
                                {savedGlassAndMirrorsMessage
                                  ? savedGlassAndMirrorsMessage
                                  : "Save"}
                              </button>
                            </div>
                          </div>
                        )}

                        {selected === "interior" && (
                          <div className="exterior-form space-y-2 w-full">
                            {/* Observations */}

                            <h4 className="text-[#FFFFFF] text-[24px] pb-5 text-center">
                              Observations
                            </h4>

                            {/* Infortainment Systems */}

                            <div className="flex flex-col items-start lg:mx-10">
                              <div className="flex flex-col lg:flex-row item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Infotainment Systems
                                </p>
                                <div
                                  onClick={() => setIsToggledIS(!isToggledIS)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledIS ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledIS
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledIS ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledIS && (
                              <div className="flex space-x-4  pt-8 lg:mx-10">
                                <div className="relative mb-8 lg:w-[300px] w-full ">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions 
                                  </label>
                                  <select
                                    name="conditionIssuesIS"
                                    value={selectedConditionIS}
                                    onChange={(e) =>
                                      setSelectedConditionIS(e.target.value)
                                    }
                                    // required={isToggledIS} // Only required if the button is selected
                                    // disabled={!isToggledIS} // Disable input if the button is not selected
                                    className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Infotainment Systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Speaker And Sound Quality */}

                            <div className="flex flex-col items-start lg:mx-10">
                              <div className="flex flex-col lg:flex-row item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Speaker & Sound Quality
                                </p>
                                <div
                                  onClick={() =>
                                    setIsToggledSASQ(!isToggledSASQ)
                                  }
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledSASQ
                                      ? "bg-[#ADD144]"
                                      : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledSASQ
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledSASQ ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledSASQ && (
                              <div className="flex space-x-4  pt-8 lg:mx-10">
                                <div className="relative mb-8 lg:w-[300px] w-full">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions 
                                  </label>
                                  <select
                                    name="conditionIssuesSASQ"
                                    value={selectedConditionSASQ}
                                    onChange={(e) =>
                                      setSelectedConditionSASQ(e.target.value)
                                    }
                                    // required={isToggledSASQ} // Only required if the button is selected
                                    // disabled={!isToggledSASQ} // Disable input if the button is not selected
                                    className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Speaker & Sound Quality']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Power Windows */}

                            <div className="flex flex-col items-start lg:mx-10">
                              <div className="flex flex-col lg:flex-row item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Power Windows
                                </p>
                                <div
                                  onClick={() => setIsToggledPW(!isToggledPW)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledPW ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledPW
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledPW ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledPW && (
                              <div className="flex space-x-4  pt-8 lg:mx-10">
                                <div className="relative mb-8 lg:w-[300px] w-full">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions
                                  </label>
                                  <select
                                    name="conditionIssuesPW"
                                    value={selectedConditionPW}
                                    onChange={(e) =>
                                      setSelectedConditionPW(e.target.value)
                                    }
                                    // required={isToggledPW} // Only required if the button is selected
                                    // disabled={!isToggledPW} // Disable input if the button is not selected
                                    className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Power Windows']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Guester Controls */}

                            <div className="flex flex-col items-start lg:mx-10">
                              <div className="flex flex-col lg:flex-row item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Guester Controls
                                </p>
                                <div
                                  onClick={() => setIsToggledGC(!isToggledGC)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledGC ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledGC
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledGC ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledGC && (
                              <div className="flex space-x-4  pt-8 lg:mx-10">
                                <div className="relative mb-8 lg:w-[300px] w-full">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter the conditions 
                                  </label>
                                  <select
                                    name="conditionIssuesGCO"
                                    value={selectedConditionGCO}
                                    onChange={(e) =>
                                      setSelectedConditionGCO(e.target.value)
                                    }
                                    // required={isToggledGC} // Only required if the button is selected
                                    // disabled={!isToggledGC} // Disable input if the button is not selected
                                    className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Guester Controls']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>

                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Camera Quality */}

                            <div className="flex flex-col items-start lg:mx-10">
                              <div className="flex flex-col lg:flex-row item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Camera Quality
                                </p>
                                <div
                                  onClick={() => setIsToggledCQ(!isToggledCQ)}
                                  className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                    isToggledCQ ? "bg-[#ADD144]" : "bg-gray-400"
                                  } transition-all duration-300`}
                                >
                                  <div
                                    className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                      isToggledCQ
                                        ? "translate-x-[30px]"
                                        : "translate-x-0"
                                    } transition-transform duration-300`}
                                  />
                                  <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                    {isToggledCQ ? "Yes" : "No"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {isToggledCQ && (
                          <div className="flex flex-col sm:flex-row sm:space-x-4 sm:w-full md:w-[500px] lg:flex lg:space-x-4 lg:w-[500px] pt-8  lg::mx-10">
                          {/* Condition Issues Select */}
                          <div className="relative mb-8 lg:w-[300px] -fukk">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Enter the conditions
                            </label>
                            <select
                              name="conditionIssuesCQ"
                              value={selectedConditionCQ}
                              onChange={(e) => setSelectedConditionCQ(e.target.value)}
                              className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                            >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Camera Quality']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                            </select>
                        
                            {/* SVG Icon */}
                            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                              <svg
                                width="18"
                                height="12"
                                viewBox="0 0 18 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                  fill="#F0FFC5"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                        
                            )}

                            {/* Dashboard */}

                            {/* <div className="flex flex-col items-start mx-10">
                            <div className="flex item-center justify-between w-full">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                              Dashboard
                              </p>
                              <div
                                onClick={() => setIsToggleDO(!isToggleDO)}
                                className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                  isToggleDO ? "bg-[#ADD144]" : "bg-gray-400"
                                } transition-all duration-300`}
                              >
                                <div
                                  className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                    isToggleDO
                                      ? "translate-x-[30px]"
                                      : "translate-x-0"
                                  } transition-transform duration-300`}
                                />
                                <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                  {isToggleDO ? "Yes" : "No"}
                                </span>
                              </div>
                            </div>
                          </div> */}

                            {/* {isToggleDO && (
                            <div className="flex space-x-4 w-[500px] pt-8 mx-10">
                              <div className="relative mb-8 w-[300px]">
                                <label className="absolute left-6 -top-3 bg-banner bg-opacity-70 text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions / issues
                                </label>
                                <select
                                  name="conditionIssuesDO"
                                  value={selectedConditionDO}
                                  onChange={(e) =>
                                    setSelectedConditionDO(e.target.value)
                                  }
                                  required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option
                                    className="bg-gray-600"
                                    value=""
                                    disabled
                                  >
                                    Select an option
                                  </option>
                                  <option
                                    className="bg-gray-600"
                                    value="Condition 1"
                                  >
                                    Condition 1
                                  </option>
                                  <option
                                    className="bg-gray-600"
                                    value="Condition 2"
                                  >
                                    Condition 2
                                  </option>
                                  <option
                                    className="bg-gray-600"
                                    value="Condition 3"
                                  >
                                    Condition 3
                                  </option>
                                </select>

                               
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                             
                            </div>
                          )} */}

                            {/* Gear Console */}

                            {/* <div className="flex flex-col items-start mx-10">
                            <div className="flex item-center justify-between w-full">
                              <p className="text-[#FFFFFF] text-[20px] pb-5">
                              Gear Console 
                              </p>
                              <div
                                onClick={() => setIsToggleGCCO(!isToggleGCCO)}
                                className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 ${
                                  isToggleGCCO ? "bg-[#ADD144]" : "bg-gray-400"
                                } transition-all duration-300`}
                              >
                                <div
                                  className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                    isToggleGCCO
                                      ? "translate-x-[30px]"
                                      : "translate-x-0"
                                  } transition-transform duration-300`}
                                />
                                <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                  {isToggleGCCO ? "Yes" : "No"}
                                </span>
                              </div>
                            </div>
                          </div> */}

                            {/* {isToggleGCCO && (
                            <div className="flex space-x-4 w-[500px] pt-8 mx-10">
                              <div className="relative mb-8 w-[300px]">
                                <label className="absolute left-6 -top-3 bg-banner bg-opacity-70 text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions / issues
                                </label>
                                <select
                                  name="conditionIssuesGCCO"
                                  value={selectedConditionGCCO}
                                  onChange={(e) =>
                                    setSelectedConditionGCCO(e.target.value)
                                  }
                                  required
                                  className="border rounded-full w-full py-5   px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option
                                    className="bg-gray-600"
                                    value=""
                                    disabled
                                  >
                                    Select an option
                                  </option>
                                  <option
                                    className="bg-gray-600"
                                    value="Condition 1"
                                  >
                                    Condition 1
                                  </option>
                                  <option
                                    className="bg-gray-600"
                                    value="Condition 2"
                                  >
                                    Condition 2
                                  </option>
                                  <option
                                    className="bg-gray-600"
                                    value="Condition 3"
                                  >
                                    Condition 3
                                  </option>
                                </select>

                               
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>

                             
                            </div>
                          )} */}

                            <div className="w-full flex justify-center mt-5">
                              <button
                                className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                                onClick={handleSaveSeatAndObservations}
                              >
                                {savedSeatAndObservationsMessage
                                  ? savedSeatAndObservationsMessage
                                  : "Save"}
                              </button>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Fifth Compoent */}

                      {/*Tyre */}
                      {selected === "exterior" && (
                        <div className="flex w-full max-w-3xl mt-10 flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative mx-auto">
                          <div className="exterior-form space-y-2 w-full">
                            <h4 className="text-[#FFFFFF] text-[24px] pb-5 text-center">
                              Tyres
                            </h4>

                            {/* Front Right (FRT) */}

                            <div className="flex flex-col items-start mx-10">
                              <div className="flex item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Front Right
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-wrap lg:w-[700px] pt-5 lg:mx-10 ">
                              {/* First Row: Two input fields */}
                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                {/* Select Brand */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Brand
                                  </label>
                                  <input
                                    type="text"
                                    name="FRTBrand"
                                    value={BrandT}
                                    onChange={(e) => setBrandT(e.target.value)}
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Variant */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Variant
                                  </label>
                                  <input
                                    type="text"
                                    name="FRTVarient"
                                    value={BrandTv}
                                    onChange={(e) => setBrandTv(e.target.value)}
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Tyre Size
                                  </label>
                                  <input
                                    type="text"
                                    name="conditionIssues"
                                    value={selectedConditionSTS}
                                    onChange={(e) =>
                                      setSelectedConditionSTS(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Enter Tread Depth  */}
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter Tread Depth
                                  </label>
                                  <input
                                    type="text"
                                    name="TRFR"
                                    value={BrandTRFR}
                                    onChange={(e) =>
                                      setBrandTRFR(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Third Row */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8  pt-5">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter DOT (WW/YY)
                                  </label>
                                  <input
                                    type="text"
                                    name="TRFR"
                                    value={selectedConditionDOTFT}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ); // Remove all non-digit characters
                                      if (value.length > 2) {
                                        value =
                                          value.slice(0, 2) +
                                          "/" +
                                          value.slice(2, 4); // Add slash after first 2 digits
                                      }
                                      setSelectedConditionDOTFT(value);
                                    }}
                                    maxLength="5" // Limit the input to 4 digits plus the slash
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(e, setTyreFile1)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-8 h-8"
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Fourth Row */}

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8 pt-5">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Condition
                                  </label>
                                  <select
                                    name="conditionFT"
                                    value={selectedConditionFT}
                                    onChange={(e) =>
                                      setSelectedConditionFT(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Tyres']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>
                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Front tyre End Point */}

                            {/* Rear Right (RT) */}

                            <div className="flex flex-col items-start mx-10">
                              <div className="flex item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Rear Right
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-wrap lg:w-[700px] pt-5 lg:mx-10">
                              {/* First Row: Two input fields */}
                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                {/* Select Brand */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Brand
                                  </label>
                                  <input
                                    type="text"
                                    name="RTBrand"
                                    value={BrandRT}
                                    onChange={(e) => setBrandRT(e.target.value)}
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Variant */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Variant
                                  </label>
                                  <input
                                    type="text"
                                    name="RTVarient"
                                    value={VarientRT}
                                    onChange={(e) =>
                                      setVarientRT(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Tyre Size
                                  </label>
                                  <input
                                    type="text"
                                    name="conditionIssuesRT"
                                    value={selectedConditionRT}
                                    onChange={(e) =>
                                      setSelectedConditionRT(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Enter Tread Depth  */}
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter Tread Depth
                                  </label>
                                  <input
                                    type="text"
                                    name="TDRT"
                                    value={TDRT}
                                    onChange={(e) => setTDRT(e.target.value)}
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Third Row */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter DOT (WW/YY)
                                  </label>
                                  <input
                                    type="text"
                                    name="TRFR"
                                    value={selectedConditionDOTRT}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ); // Remove all non-digit characters
                                      if (value.length > 2) {
                                        value =
                                          value.slice(0, 2) +
                                          "/" +
                                          value.slice(2, 4); // Add slash after first 2 digits
                                      }
                                      setSelectedConditionDOTRT(value);
                                    }}
                                    maxLength="5" // Limit the input to 4 digits plus the slash
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                  {/* <select
                                  name="conditionDOTRT"
                                  value={selectedConditionDOTRT}
                                  onChange={(e) =>
                                    setSelectedConditionDOTRT(e.target.value)
                                  }
                                  required
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option
                                    className="bg-gray-600"
                                    value=""
                                    disabled
                                  >
                                    Select an option
                                  </option>
                                  <option
                                    className="bg-gray-600"
                                    value="Condition 1"
                                  >
                                    Condition 1
                                  </option>
                                  <option
                                    className="bg-gray-600"
                                    value="Condition 2"
                                  >
                                    Condition 2
                                  </option>
                                  <option
                                    className="bg-gray-600"
                                    value="Condition 3"
                                  >
                                    Condition 3
                                  </option>
                                </select> */}
                                  {/* SVG Icon */}
                                  {/* <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div> */}
                                </div>

                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(e, setTyreFile2)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-8 h-8"
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Fourth Row */}

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Condition
                                  </label>
                                  <select
                                    name="conditionRTN"
                                    value={selectedConditionRTN}
                                    onChange={(e) =>
                                      setSelectedConditionRTN(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Tyres']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>
                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Rear Tyre End Point */}

                            {/* Rear Left (RL) */}

                            <div className="flex flex-col items-start mx-10">
                              <div className="flex item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Rear Left
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-wrap lg:w-[700px] pt-5 lg:mx-10">
                              {/* First Row: Two input fields */}
                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                {/* Select Brand */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Brand
                                  </label>
                                  <input
                                    type="text"
                                    name="RLBrand"
                                    value={BrandRL}
                                    onChange={(e) => setBrandRL(e.target.value)}
                                    //  required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Variant */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Variant
                                  </label>
                                  <input
                                    type="text"
                                    name="RLVarient"
                                    value={VarientRL}
                                    onChange={(e) =>
                                      setVarientRL(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Tyre Size
                                  </label>
                                  <input
                                    type="text"
                                    name="conditionIssuesRL"
                                    value={selectedConditionRL}
                                    onChange={(e) =>
                                      setSelectedConditionRL(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Enter Tread Depth  */}
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter Tread Depth
                                  </label>
                                  <input
                                    type="text"
                                    name="RLTD"
                                    value={RLTrend}
                                    onChange={(e) => setRLTrend(e.target.value)}
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Third Row */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8  pt-5">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter DOT (WW/YY)
                                  </label>
                                  <input
                                    type="text"
                                    name="TRFR"
                                    value={selectedConditionDOTRL}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ); // Remove all non-digit characters
                                      if (value.length > 2) {
                                        value =
                                          value.slice(0, 2) +
                                          "/" +
                                          value.slice(2, 4); // Add slash after first 2 digits
                                      }
                                      setSelectedConditionDOTRL(value);
                                    }}
                                    maxLength="5" // Limit the input to 4 digits plus the slash
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(e, setTyreFile3)
                                    }
                                    //  required
                                    className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-8 h-8"
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Fourth Row */}

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8 pt-5">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Condition
                                  </label>
                                  <select
                                    name="conditionRLN"
                                    value={selectedConditionRLN}
                                    onChange={(e) =>
                                      setSelectedConditionRLN(e.target.value)
                                    }
                                    //  required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Tyres']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>
                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Rear Left End Pont */}

                            {/* Front Left */}

                            <div className="flex flex-col items-start mx-10">
                              <div className="flex item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Front Left
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-wrap lg:w-[700px] pt-5 lg:mx-10">
                              {/* First Row: Two input fields */}
                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                {/* Select Brand */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Brand
                                  </label>
                                  <input
                                    type="text"
                                    name="FLNBrand"
                                    value={BrandFLN}
                                    onChange={(e) =>
                                      setBrandFLN(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Variant */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Variant
                                  </label>
                                  <input
                                    type="text"
                                    name="FLNVarient"
                                    value={VarientFLN}
                                    onChange={(e) =>
                                      setVarientFLN(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-banner bg-opacity-70 text-[#F0FFC5] font-semibold px-1">
                                    Select Tyre Size
                                  </label>
                                  <input
                                    type="text"
                                    name="conditionIssuesFLN"
                                    value={selectedConditionFLN}
                                    onChange={(e) =>
                                      setSelectedConditionFLN(e.target.value)
                                    }
                                    //  required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Enter Tread Depth  */}
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter Tread Depth
                                  </label>
                                  <input
                                    type="text"
                                    name="FLN"
                                    value={FLN}
                                    onChange={(e) => setFLN(e.target.value)}
                                    //  required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Third Row */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8  pt-5">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter DOT (WW/YY)
                                  </label>
                                  <input
                                    type="text"
                                    name="TRFR"
                                    value={selectedConditionDOTFLN}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ); // Remove all non-digit characters
                                      if (value.length > 2) {
                                        value =
                                          value.slice(0, 2) +
                                          "/" +
                                          value.slice(2, 4); // Add slash after first 2 digits
                                      }
                                      setSelectedConditionDOTFLN(value);
                                    }}
                                    maxLength="5" // Limit the input to 4 digits plus the slash
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(e, setTyreFile4)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-8 h-8"
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Fourth Row */}

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8 pt-5">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Condition
                                  </label>
                                  <select
                                    name="conditionFLNT"
                                    value={selectedConditionFLNT}
                                    onChange={(e) =>
                                      setSelectedConditionFLNT(e.target.value)
                                    }
                                    //  required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Tyres']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>
                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Front Left End Point */}

                            {/* Spare (S) */}

                            <div className="flex flex-col items-start mx-10">
                              <div className="flex item-center justify-between w-full">
                                <p className="text-[#FFFFFF] text-[20px] pb-5">
                                  Spare
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-wrap lg:w-[700px] pt-5 lg:mx-10">
                              {/* First Row: Two input fields */}
                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                {/* Select Brand */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Brand
                                  </label>
                                  <input
                                    type="text"
                                    name="BrandSpare"
                                    value={BrandSpare}
                                    onChange={(e) =>
                                      setBrandSpare(e.target.value)
                                    }
                                    //  required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Variant */}
                                <div className="relative w-[200px] lg:w-[300px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Variant
                                  </label>
                                  <input
                                    type="text"
                                    name="VarientSpare"
                                    value={VarientSpare}
                                    onChange={(e) =>
                                      setVarientSpare(e.target.value)
                                    }
                                    //  required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Tyre Size
                                  </label>
                                  <input
                                    type="text"
                                    name="conditionIssuesSpare"
                                    value={selectedConditionSpare}
                                    onChange={(e) =>
                                      setSelectedConditionSpare(e.target.value)
                                    }
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                {/* Enter Tread Depth  */}
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter Tread Depth
                                  </label>
                                  <input
                                    type="text"
                                    name="SpareTD"
                                    value={Spare}
                                    onChange={(e) => setSpare(e.target.value)}
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>
                              </div>

                              {/* Third Row */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8  pt-5">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Enter DOT (WW/YY)
                                  </label>
                                  <input
                                    type="text"
                                    name="TRFR"
                                    value={selectedConditionDOTSpare}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ); // Remove all non-digit characters
                                      if (value.length > 2) {
                                        value =
                                          value.slice(0, 2) +
                                          "/" +
                                          value.slice(2, 4); // Add slash after first 2 digits
                                      }
                                      setSelectedConditionDOTSpare(value);
                                    }}
                                    maxLength="5" // Limit the input to 4 digits plus the slash
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                </div>

                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Upload Picture
                                  </label>
                                  <input
                                    type="file"
                                    name="uploadPicture"
                                    onChange={(e) =>
                                      handleFileUpload(e, setTyreFile5)
                                    }
                                    //  required
                                    className="border rounded-full w-full py-5 pr-12 pl-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none file:hidden"
                                  />
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer">
                                    <img
                                      src={cam}
                                      alt="cam icon"
                                      className="w-8 h-8"
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Fourth Row */}

                              {/* Second Row: Issue Input */}

                              <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0 w-full mb-8 pt-5">
                                <div className="relative lg:w-[300px] w-[200px]">
                                  <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                    Select Condition
                                  </label>
                                  <select
                                    name="conditionSpare"
                                    value={selectedConditionSparen}
                                    onChange={(e) =>
                                      setSelectedConditionSparen(e.target.value)
                                    }
                                    //  required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Tyres']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                  </select>
                                  {/* SVG Icon */}
                                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <svg
                                      width="18"
                                      height="12"
                                      viewBox="0 0 18 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                        fill="#F0FFC5"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Save BTn  */}

                            <div className="w-full flex justify-center mt-5">
                              <button
                                type="submit"
                                className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                                onClick={handleSaveTyresDetails}
                              >
                                {savedTyresMessage ? savedTyresMessage : "Save"}
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Sensor/ Live Data */}

                  {selected === "exterior" && (
                    <div className="flex w-full max-w-4xl flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F]  border-gray-300 p-6 rounded-md relative">
                      <div className="w-full text-left">
                        <h4 className="text-[#FFFFFF] text-[24px] pb-10">
                          Sensors / Live Data
                        </h4>

                        <p className="mt-[-30px] pb-8 text-[#FFFF] text-[18px] pl-16">
                          Sensor & CanBus Systems
                        </p>
                        <div className="flex flex-col justify-center w-full">
                          <div className="flex flex-col items-center justify-center space-y-4 lg:flex-row lg:space-x-4 lg:space-y-0 w-full lg:w-[700px]">
                            <div className="mb-8 w-full lg:w-[700px] px-4">
                              <div className="relative w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter Error Code
                                </label>
                                <input
                                  type="text"
                                  name="SensorCode"
                                  value={SensorCode}
                                  onChange={handleChangeErrorCode}
                                  // required
                                  className="border rounded-full w-full py-5 px-5 pr-20 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                />

                                <div
                                  onClick={handleAddErrorCode}
                                  className="absolute right-4 top-1/2 transform -translate-y-1/2 border border-[#F0FFC5] rounded-full px-6 lg:px-12 py-2 text-[#F0FFC5] bg-banner bg-opacity-70 cursor-pointer"
                                >
                                  Add
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Display entered error codes */}
                          {errorCodes.length > 0 && (
                            <div className="mt-2 mb-8 w-[500px] pl-16">
                              <p className="flex flex-col align-start justify-center text-wrap flex-wrap text-[#F0FFC5] text-[18px]">
                                Entered Error Codes
                              </p>
                              <ul className="list-disc pl-6 text-[#F0FFC5]">
                                {errorCodes.map((code, index) => (
                                  <li key={index} className="py-1">
                                    {code}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                        <div className="flex item-center justify-between w-full lg:pl-20 lg:pb-0 pb-16 ">
                          <p className="text-[#FFFFFF] text-[20px] ">
                            Live Data Parameters
                          </p>
                        </div>
                        <div className="flex flex-col lg:flex-row   lg:space-x-4 space-y-4 lg:space-y-0 w-full px-4 sm:mt-16">
                          {/* Enter Battery Voltage (V) */}
                          <div className="relative  lg:w-[300px] w-full lg:mb-0 mb-5">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Enter Battery Voltage (V)
                            </label>
                            <input
                              type="text"
                              name="BatteryEnergy"
                              value={BatteryEnergy}
                              onChange={(e) => setBatteryEnergy(e.target.value)}
                              // required
                              className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                            />
                          </div>

                          {/* Enter Engine Load (%) */}
                          <div className="relative w-full lg:w-[300px]">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Enter Engine Load (%)
                            </label>
                            <input
                              type="text"
                              name="EngineLoad"
                              value={LoadEngine}
                              onChange={(e) => setLoadEngine(e.target.value)}
                              // required
                              className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                            />
                          </div>
                        </div>

                        <div className="flex flex-col lg:flex-row   lg:space-x-4 space-y-4 lg:space-y-0 w-full px-4 mt-10">
                          {/* Enter Idle RPM */}
                          <div className="relative w-full lg:w-[300px]">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Enter Idle RPM
                            </label>
                            <input
                              type="text"
                              name="RPM"
                              value={idleRPM}
                              onChange={(e) => setIdleRPM(e.target.value)}
                              // required
                              className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                            />
                          </div>

                          {/* Dist. Since Codes Cleared (KMS) */}
                          <div className="relative w-full lg:w-[300px] lg:mt-0 mt-5">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Dist. Since Codes Cleared (KMS)
                            </label>
                            <input
                              type="text"
                              name="DistanceLMS"
                              value={distKMS}
                              onChange={(e) => setDistKMS(e.target.value)}
                              // required
                              className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                            />
                          </div>
                        </div>

                        <div className="flex items-left justify-left gap-8 w-full pt-8 px-4 ">
                          {/*  Dist. In Current 10K Block (KMS) */}

                          <div className="relative w-full lg:w-[300px] ">
                            <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Dist. In Current 10K Block (KMS)
                            </label>
                            <input
                              type="text"
                              name="KMSdist"
                              value={distCKMS}
                              onChange={(e) => setDistCKMS(e.target.value)}
                              // required
                              className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                            />
                          </div>
                        </div>

                        <div className="flex item-center justify-between w-full lg:pl-20 pt-16 pb-7">
                          <p className="text-[#FFFFFF] text-[20px] ">
                            Other Issues & Observations
                          </p>
                        </div>

                        <div classname="flex flex-col items-center gap-10 justify-center w-[700px]  ">
                          {/* Engine Cracking In Single Star */}
                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] text-center sm:text-left">
                              Engine Cranking In Single Start
                            </p>
                            <div
                              onClick={() =>
                                setIsToggledEngineCrack(!isToggledEngineCrack)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 ${
                                isToggledEngineCrack
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledEngineCrack
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledEngineCrack ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* No Warning Instrument Cluster */}

                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between pt-8">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] text-center sm:text-left">
                              No Warning Instrument Cluster
                            </p>
                            <div
                              onClick={() =>
                                setIsToggledWarning(!isToggledWarning)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 ${
                                isToggledWarning
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledWarning
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledWarning ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* No Suspicious Noise, Vibration, & Smell */}

                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between pt-8">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] text-center sm:text-left">
                              No Suspicious Noise, Vibration, & Smell
                            </p>
                            <div
                              onClick={() =>
                                setIsToggledSuspicious(!isToggledSuspicious)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 ${
                                isToggledSuspicious
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledSuspicious
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledSuspicious ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* No Excessive Smoke From The Exhaust */}

                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between pt-8 ">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] text-center sm:text-left">
                              No Excessive Smoke From The Exhaust
                            </p>
                            <div
                              onClick={() => setIsToggledSmoke(!isToggledSmoke)}
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 ${
                                isToggledSmoke ? "bg-[#ADD144]" : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledSmoke
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledSmoke ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* Gearshift And Pedals Are Smooth */}

                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between pt-8">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] text-center sm:text-left">
                              Gearshift And Pedals Are Smooth
                            </p>
                            <div
                              onClick={() =>
                                setIsToggledGearshift(!isToggledGearshift)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 ${
                                isToggledGearshift
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledGearshift
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledGearshift ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>
                          {/* Brake Pedal Does Not Have A Long Play */}

                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between pt-8">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] text-center sm:text-left">
                              Brake Pedal Does Not Have A Long Play
                            </p>
                            <div
                              onClick={() => setIsToggledBreak(!isToggledBreak)}
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 ${
                                isToggledBreak ? "bg-[#ADD144]" : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledBreak
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledBreak ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* The steering wheel is responsive and has no clicking sounds */}

                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between pt-8">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] text-center sm:text-left">
                              The steering wheel is responsive and has no
                              clicking sounds
                            </p>
                            <div
                              onClick={() =>
                                setIsToggledSteering(!isToggledSteering)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 ${
                                isToggledSteering
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledSteering
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledSteering ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* handbrake is smooth and easy to apply */}

                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between pt-8 ">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] text-center sm:text-left">
                              Handbrake is smooth and easy to apply
                            </p>
                            <div
                              onClick={() =>
                                setIsToggledHandbreak(!isToggledHandbreak)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 ${
                                isToggledHandbreak
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledHandbreak
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledHandbreak ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* reverse gear, sensor and camera are working properly */}

                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between pt-8 ">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] lg:text-center text-left">
                              reverse gear, sensor and camera are working
                              properly
                            </p>
                            <div
                              onClick={() =>
                                setIsToggledReverse(!isToggledReverse)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 ${
                                isToggledReverse
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledReverse
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledReverse ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* Speedometer, tachometer and other indicators on driver dashboard are working smoothly */}

                          <div className="w-full flex flex-col sm:flex-row sm:items-center sm:gap-6 justify-between pt-8">
                            <p className="text-[#FFFFFF] text-[16px] lg:text-[18px] text-center sm:text-left">
                              Speedometer, tachometer and other indicators on
                              driver dashboard are working smoothly
                            </p>
                            <div
                              onClick={() =>
                                setIsToggledSmooth(!isToggledSmooth)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 lg:mt-0 mt-5 lg:mb-0 mb-5 ${
                                isToggledSmooth ? "bg-[#ADD144]" : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledSmooth
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledSmooth ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="w-full flex justify-center">
                        <button
                          className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                          onClick={handleSaveSensorsAndLiveData}
                        >
                          {savedSensorsAndLiveMessage
                            ? savedSensorsAndLiveMessage
                            : "Save"}
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Fluid Level */}
                  {selected === "exterior" && (
                    <div className="flex w-full max-w-4xl flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F]  border-gray-300 p-6 rounded-md relative">
                      <div className="w-full text-left">
                        <h4 className="text-[#FFFFFF] text-[24px] pb-10">
                          Fluid Level
                        </h4>

                        {/* Table */}

                        <div className=" grid grid-cols-3 gap-4 border border-gray-300 p-6 rounded-md mx-auto">
                          {/* Header Row */}
                          <div className="text-[#FFFFFF] text-center font-bold">
                            Part Name
                          </div>
                          <div className="text-[#FFFFFF] text-center font-bold">
                            Within Range
                          </div>
                          <div className="text-[#FFFFFF] text-center font-bold">
                            Contamination Observed
                          </div>

                          {/* Data Row 1 */}
                          <div className="text-[#FFFFFF] text-center">
                            Coolant
                          </div>
                          <div className="flex justify-center">
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel1(!isToggledFluidLevel1)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel1
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel1
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel1 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel2(!isToggledFluidLevel2)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel2
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel2
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel2 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* Data Row 2 */}
                          <div className="text-[#FFFFFF] text-center">
                            Engine Oil
                          </div>
                          <div className="flex justify-center">
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel3(!isToggledFluidLevel3)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel3
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel3
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel3 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel4(!isToggledFluidLevel4)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel4
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel4
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel4 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* Data Row 3 */}
                          <div className="text-[#FFFFFF] text-center">
                            Brake Oil
                          </div>
                          <div className="flex justify-center">
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel5(!isToggledFluidLevel5)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel5
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel5
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel5 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel6(!isToggledFluidLevel6)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel6
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel6
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel6 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* Data Row 4 */}
                          <div className="text-[#FFFFFF] text-center">
                            Washer Fluid
                          </div>
                          <div className="flex justify-center">
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel7(!isToggledFluidLevel7)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel7
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel7
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel7 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>
                          <div className="flex justify-center">
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel8(!isToggledFluidLevel8)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel8
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel8
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel8 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="w-full flex flex-col">
                          {/* Auxiliary Belts Condition */}
                          <div className="w-full  lg:w-[700px] flex items-center justify-between p-4 md:p-6 rounded-md mx-auto">
                            {/* Text on the left */}
                            <p className="text-[#FFFFFF] text-sm md:text-base">
                              Auxiliary Belts condition
                            </p>

                            {/* Toggle button on the right */}
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel9(!isToggledFluidLevel9)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel9
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel9
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[10px] md:text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel9 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* DEF */}
                          <div className="w-full  lg:w-[700px] flex items-center justify-between p-4 md:p-6 rounded-md mx-auto">
                            {/* Text on the left */}
                            <p className="text-[#FFFFFF] text-sm md:text-base font-semibold">
                              DEF/DPF
                            </p>

                            {/* Percentage input in the middle */}
                            <div className="flex items-center space-x-2">
                              <input
                                type="number"
                                min="0"
                                max="100"
                                value={percentageValue} // Replace with your state variable
                                onChange={(e) =>
                                  setPercentageValue(e.target.value)
                                } // Replace with your state setter
                                placeholder="--"
                                // required={isToggledFluidLevel10} // Only required if the button is selected
                                // disabled={!isToggledFluidLevel10} // Disable input if the button is not selected
                                className="w-[40px] md:w-[50px] text-center py-1 bg-transparent border-none rounded-md text-[#F0FFC5] text-sm md:text-base"
                              />
                              <span className="text-[#FFFFFF] text-sm md:text-base">
                                %
                              </span>
                            </div>

                            {/* Toggle button on the right */}
                            <div
                              onClick={() => {
                                if (isToggledFluidLevel10) {
                                  setPercentageValue(""); // Clear the value when toggling off
                                }
                                setIsToggledFluidLevel10(!isToggledFluidLevel10);
                              }}
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel10
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel10
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[10px] md:text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel10 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>

                          {/* Leakages Observed */}
                          <div className="w-full  lg:w-[700px] flex items-center justify-between p-4 md:p-6 rounded-md mx-auto">
                            {/* Text on the left */}
                            <p className="text-[#FFFFFF] text-sm md:text-base">
                              Leakages Observed
                            </p>

                            {/* Toggle button on the right */}
                            <div
                              onClick={() =>
                                setIsToggledFluidLevel11(!isToggledFluidLevel11)
                              }
                              className={`flex items-center cursor-pointer w-[60px] h-[30px] rounded-full px-1 relative ${
                                isToggledFluidLevel11
                                  ? "bg-[#ADD144]"
                                  : "bg-gray-400"
                              } transition-all duration-300`}
                            >
                              <div
                                className={`w-[22px] h-[22px] rounded-full bg-white transform ${
                                  isToggledFluidLevel11
                                    ? "translate-x-[30px]"
                                    : "translate-x-0"
                                } transition-transform duration-300`}
                              />
                              <span className="absolute text-[10px] md:text-[12px] text-[#191F09] font-semibold pl-2">
                                {isToggledFluidLevel11 ? "Yes" : "No"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="w-full flex justify-center">
                        <button
                          className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                          onClick={handleSaveFluidLevels}
                        >
                          {savedFluidLevelsMessage
                            ? savedFluidLevelsMessage
                            : "Save"}
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Observation */}
                  {selected === "exterior" && (
                    <div className="flex w-full max-w-4xl flex-col items-center justify-center space-y-4 border   bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative">
                      <div className="w-full text-left">
                        <h4 className="text-[#FFFFFF] text-[24px] pb-10">
                          Car's Core Mechanical Area Conditions
                        </h4>

                        <div className="max-w-[700px] lg:mx-auto">
                          <div className="flex flex-col lg:flex-row  space-y-4 md:space-y-0 md:space-x-4 w-full lg:w-[700px] pt-8  md:mx-6 lg:mx-10">
                            {/* HVAC / AC Systems Section */}
                            <div className="w-full md:w-1/2">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                HVAC / AC Systems
                              </h3>
                              <div className="relative mb-8  md:w-[300px] w-full">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore1}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore1(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['HVAC / AC Systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            {/* Engine Systems Section */}
                            <div className="w-full md:w-1/2">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Engine Systems
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore2}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore2(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Engine Systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-wrap lg:flex-nowrap space-x-4 w-full lg:w-[700px] pt-0 lg:mx-10 mt-4">
                            {/* Brake Systems */}
                            <div className="w-full lg:w-1/2">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Brake Systems
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore3}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore3(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Brake Systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            {/* Steering & Suspension Systems */}
                            <div className="w-full lg:w-1/2">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Steering & Suspensions Systems
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore4}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore4(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none lg:pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Steering & Suspensions Systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-wrap lg:flex-nowrap space-x-4 w-full lg:w-[700px] pt-0 lg:mx-10 mt-4">
                            {/*  Fuel Systems */}
                            <div className="w-full lg:w-1/2">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Fuel Systems
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore5}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore5(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none lg:pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Fuel Systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            {/* Battery Systems */}
                            <div className="w-full lg:w-1/2">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Battery Systems
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore6}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore6(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none lg:pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Battery Systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-col space-y-4 lg:space-y-0 lg:flex-row lg:space-x-4 w-full lg:w-[700px] pt-0  md:mx-6 lg:mx-10 mt-4">
                            {/* Exhaust systems */}
                            <div className="w-full">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Exhaust systems
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore7}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore7(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Exhaust systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            {/* Filters */}
                            <div className="w-full">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Filters
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore8}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore8(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none lg:pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Filters']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-col space-y-4 lg:space-y-0 lg:flex-row lg:space-x-4 w-full lg:w-[700px] pt-0  md:mx-6 lg:mx-10 mt-4">
                            {/* Ignition Systems */}
                            <div className="w-full md:w-1/2 mb-4 md:mb-0">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Ignition systems
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-4 md:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore9}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore9(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-4 md:py-5 px-4 md:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none lg:pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Ignition systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            {/* Lighting Systems */}
                            <div className="w-full md:w-1/2">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Lighting Systems
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-4 md:left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions
                                </label>
                                <select
                                  name="conditionIssues"
                                  value={selectedConditionCarsCore10}
                                  onChange={(e) =>
                                    setSelectedConditionCarsCore10(
                                      e.target.value
                                    )
                                  }
                                  // required
                                  className="border rounded-full w-full py-4 md:py-5 px-4 md:px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none lg:pr-10"
                                >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Lighting Systems']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-col space-y-4 lg:space-y-0 lg:flex-row lg:space-x-4 w-full lg:w-[700px] pt-0  md:mx-6 lg:mx-10 mt-4">
                            {/* Clutch & Transmission */}
                            <div className="w-full md:w-1/2 mb-4 md:mb-0">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Clutch & Transmission
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                {!isSelectedConditionCarsCore1 ? (
                                  <select
                                    name="DefectSensor"
                                    value={selectedConditionCarsCore11}
                                    onChange={handleSelectCarsCore1}
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none lg:pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Clutch & Transmission']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    <option
                                      className="bg-gray-600"
                                      value="Others"
                                    >
                                      Others
                                    </option>                                  
                                  </select>
                                ) : (
                                  <input
                                    type="text"
                                    value={selectedConditionCarsCore11}
                                    onChange={(e) => setSelectedConditionCarsCore11(e.target.value)}
                                    placeholder="Enter your condition"
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                )}
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>

                            {/* Sensors */}
                            <div className="w-full md:w-1/2">
                              <h3 className="text-[#FFFF] text-[20px] font-semibold mb-2 pb-5">
                                Sensors
                              </h3>
                              <div className="relative mb-8 w-full md:w-[300px]">
                                <label className="absolute left-6 -top-3 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                                  Enter the conditions 
                                </label>
                                {!isSelectedConditionCarsCore2 ? (
                                  <select
                                    name="DefectSensor"
                                    value={selectedConditionCarsCore12}
                                    onChange={handleSelectCarsCore2}
                                    // required
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5] appearance-none lg:pr-10"
                                  >
                                  <option className="bg-gray-600" value="">
                                    Select an option
                                  </option>
                                  
                                  {/* Dynamically render options */}
                                  {dropdownOptions['Sensors - PDI']?.map((option) => (
                                    <option 
                                      key={option} 
                                      value={option}
                                      className="bg-gray-600"
                                    >
                                      {option}
                                    </option>
                                  ))}
                                    <option
                                      className="bg-gray-600"
                                      value="Others"
                                    >
                                      Others
                                    </option>                                  
                                  </select>
                                ) : (
                                  <input
                                    type="text"
                                    value={selectedConditionCarsCore12}
                                    onChange={(e) => setSelectedConditionCarsCore12(e.target.value)}
                                    placeholder="Enter your condition"
                                    className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                                  />
                                )}
                                {!isSelectedConditionCarsCore2 ? (
                                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.61701 11.54L1.18701 2.624C0.992368 2.39032 0.868359 2.106 0.829513 1.80437C0.790667 1.50274 0.838592 1.19628 0.967673 0.920906C1.09675 0.645534 1.30164 0.412653 1.55833 0.249552C1.81503 0.086451 2.11288 -0.00011398 2.41701 1.12635e-07H15.585C15.889 0.000265948 16.1866 0.0871067 16.4429 0.250357C16.6993 0.413607 16.9039 0.646511 17.0328 0.92181C17.1616 1.19711 17.2094 1.50341 17.1704 1.80487C17.1315 2.10632 17.0075 2.39045 16.813 2.624L9.38501 11.54C9.33808 11.5963 9.27936 11.6415 9.21301 11.6726C9.14665 11.7037 9.07428 11.7198 9.00101 11.7198C8.92774 11.7198 8.85536 11.7037 8.78901 11.6726C8.72265 11.6415 8.66393 11.5963 8.61701 11.54Z"
                                      fill="#F0FFC5"
                                    />
                                  </svg>
                                </div>
                                ) : (
                                  null
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="w-full flex justify-center pt-8">
                          <button
                            className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                            onClick={handleSaveCarCoreDetails}
                          >
                            {savedCarCoreMessage ? savedCarCoreMessage : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {selected === "exterior" && (
                    <div className="flex w-full max-w-4xl flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative">
                      <div className="w-full text-left">
                        <h4 className="text-[#FFFFFF] text-[24px] pb-10">
                          Confirm Payment
                        </h4>
                      </div>

                      <div className="w-full lg:w-[700px] flex flex-col lg:flex-row justify-between items-start md:space-y-0 space-y-6">
                        {/* Button Group */}
                        <div className="flex flex-col gap-4 items-start">
                          <div className="flex flex-col lg:flex-row flex-row items-center gap-7">
                            {/* Online Payment Button */}
                            <button
                              onClick={() => setSelectedPaymentMethod("Online")}
                              className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                selectedPaymentMethod === "Online"
                                  ? "bg-[#191F09] text-[#ADD144] font-semibold"
                                  : "bg-transparent border border-white text-white font-semibold"
                              }`}
                            >
                              <span
                                className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                  selectedPaymentMethod === "Online"
                                    ? "bg-[#ADD144]"
                                    : "bg-transparent"
                                }`}
                              >
                                {selectedPaymentMethod === "Online" && (
                                  <span className="absolute text-[#191F09] text-lg">
                                    &#10003;
                                  </span>
                                )}
                              </span>
                              <span>Online</span>
                            </button>

                            {/* Cash Payment Button */}
                            <button
                              onClick={() => setSelectedPaymentMethod("Cash")}
                              className={`flex items-center justify-center space-x-5 flex-1 py-3 px-6 rounded-full transition-all duration-300 ${
                                selectedPaymentMethod === "Cash"
                                  ? "bg-[#191F09] text-[#ADD144] font-semibold"
                                  : "bg-transparent border border-white text-white font-semibold"
                              }`}
                            >
                              <span
                                className={`relative flex items-center justify-center w-5 h-5 border-2 border-white rounded-full transition-colors duration-300 ${
                                  selectedPaymentMethod === "Cash"
                                    ? "bg-[#ADD144]"
                                    : "bg-transparent"
                                }`}
                              >
                                {selectedPaymentMethod === "Cash" && (
                                  <span className="absolute text-[#191F09] text-lg">
                                    &#10003;
                                  </span>
                                )}
                              </span>
                              <span>Cash</span>
                            </button>
                          </div>

                          {/* Text Field Below Buttons */}
                          <div className="relative lg:w-full w-[250px] pt-8">
                            <label className="absolute left-6 top-5 bg-[#1F1F1F] text-[#F0FFC5] font-semibold px-1">
                              Amount (Rs)
                            </label>
                            <input
                              type="number"
                              name="paymentAmount"
                              value={paymentAmount}
                              onChange={handlePaymentChange}
                              placeholder="Payment Amount"
                              // required
                              className="border rounded-full w-full py-5 px-5 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
                            />
                          </div>
                        </div>

                        {/* QR Code Image */}
                        <div className="flex justify-center lg:justify-end items-center w-full lg:w-auto">
                          {paymentAmount &&
                            selectedPaymentMethod === "Online" && (
                              <QRCodeCanvas
                                value={`upi://pay?pa=carvetpro123@fbl&am=${paymentAmount}`}
                                size={256}
                              />
                            )}
                        </div>
                      </div>

                      <div className="w-full flex justify-center pt-8">
                        <button
                          className="text-[#F0FFC5] text-md font-semibold py-3 px-20 bg-[#0B7300] rounded-full"
                          onClick={handleSavePaymentDetails}
                        >
                          {savedPaymentMessage ? savedPaymentMessage : "Save"}
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Observations */}
                  {selected === "exterior" && (
                    <div className="flex w-full max-w-4xl flex-col items-center justify-center space-y-4 border  bg-[#1F1F1F] border-gray-300 p-6 rounded-md relative">
                      <div className="w-full text-left">
                        <h4 className="text-[#FFFFFF] text-[24px] pb-10 sm:text-[28px]">
                          Additional Observations
                        </h4>
                      </div>

                      <div className="w-full sm:w-[85%] md:w-[75%] max-w-2xl flex flex-col gap-5">
                        {technicianRemarks.map((remark, i) => {
                          const previewSrc = remark.photoFile
                            ? URL.createObjectURL(remark.photoFile)
                            : remark.photoUrl || "";
                          return (
                            <div
                              key={i}
                              className="flex flex-col gap-3 border border-[#F0FFC5]/40 rounded-md p-4"
                            >
                              <div className="flex items-start gap-3">
                                <span className="text-[#F0FFC5] font-semibold pt-3">{i + 1}.</span>
                                <textarea
                                  className="flex-1 h-20 p-3 bg-transparent border border-[#F0FFC5] rounded-md text-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition"
                                  placeholder="Enter a remark..."
                                  value={remark.text}
                                  onChange={(e) => updateRemarkText(i, e.target.value)}
                                />
                                <button
                                  type="button"
                                  onClick={() => removeRemarkRow(i)}
                                  className="text-[#F0FFC5] border border-[#F0FFC5] rounded-full w-8 h-8 flex items-center justify-center shrink-0 mt-1"
                                  title="Remove this remark"
                                >
                                  ×
                                </button>
                              </div>

                              <div className="flex items-center gap-4 pl-6">
                                <div className="relative w-[220px]">
                                  <label className="absolute left-4 -top-3 bg-[#1F1F1F] text-[#F0FFC5] text-sm font-semibold px-1">
                                    {previewSrc ? "Change photo" : "Attach photo"}
                                  </label>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setRemarkPhoto(i, e.target.files[0])}
                                    className="border rounded-3xl w-full py-4 pr-10 pl-4 bg-transparent border-[#F0FFC5] focus:outline-none text-[#F0FFC5] appearance-none file:hidden"
                                  />
                                  <div className="absolute right-3 top-1/2 -translate-y-1/2">
                                    <img src={cam} alt="cam icon" className="w-7 h-7" />
                                  </div>
                                </div>

                                {previewSrc && (
                                  <div className="flex items-center gap-3">
                                    <img
                                      src={previewSrc}
                                      alt={`Remark ${i + 1}`}
                                      className="w-24 h-16 object-cover rounded-md border border-[#F0FFC5]/40"
                                    />
                                    <button
                                      type="button"
                                      onClick={() => clearRemarkPhoto(i)}
                                      className="text-[#F0FFC5] underline text-sm"
                                    >
                                      Remove photo
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}

                        <button
                          type="button"
                          onClick={addRemarkRow}
                          className="self-start text-[#191F09] bg-[#ADD144] font-semibold py-2 px-6 rounded-full"
                        >
                          + Add remark
                        </button>
                      </div>

                      <div className="w-full flex justify-center pt-8 gap-10 flex-col lg:flex-row">
                      <button
                          className="bg-[#ADD144] text-md sm:text-lg font-semibold py-3 px-10 sm:px-16 text-[#191F09] rounded-full"
                          onClick={handleFormSubmitPreview}
                        >
                          {isPdfGenerated ? "PDF Generated" : "Preview PDF"}
                        </button>
                        <button
                          className="text-[#F0FFC5] text-md sm:text-lg font-semibold py-3 px-10 sm:px-16 bg-[#0B7300] rounded-full"
                          onClick={handleFormSubmit}
                          disabled={isLoading} // Optional: Disable button while loading
                        >
                          {isLoading ? "Generating PDF..." : isPdfGenerated ? "PDF Generated" : "Generate PDF"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            {/* </form> */}

            {/* <form className="space-y-4">
              <input
                type="text"
                name="technicianName"
                value={reportData.technicianName}
                onChange={(e) =>
                  setReportData({
                    ...reportData,
                    technicianName: e.target.value,
                  })
                }
                placeholder="Technician Name"
                className="w-full p-3 border rounded-lg"
                disabled={isFormDisabled}
              />
              <input
                type="text"
                name="customerName"
                value={reportData.customerName}
                onChange={(e) =>
                  setReportData({ ...reportData, customerName: e.target.value })
                }
                placeholder="Customer Name"
                className="w-full p-3 border rounded-lg"
                disabled={isFormDisabled}
              />
              <input
                type="date"
                name="date"
                value={reportData.date}
                onChange={(e) =>
                  setReportData({ ...reportData, date: e.target.value })
                }
                className="w-full p-3 border rounded-lg"
                disabled={isFormDisabled}
              />
              <textarea
                name="inspectionType"
                value={reportData.inspectionType}
                onChange={(e) =>
                  setReportData({
                    ...reportData,
                    inspectionType: e.target.value,
                  })
                }
                placeholder="Job Details"
                className="w-full p-3 border rounded-lg"
                disabled={isFormDisabled}
              ></textarea>
              <input
                type="text"
                name="vehicleModel"
                value={reportData.vehicleModel}
                onChange={(e) =>
                  setReportData({ ...reportData, vehicleModel: e.target.value })
                }
                placeholder="Vehicle Model"
                className="w-full p-3 border rounded-lg"
                disabled={isFormDisabled}
              />
              <input
                type="text"
                name="variant"
                value={reportData.variant}
                onChange={(e) =>
                  setReportData({ ...reportData, variant: e.target.value })
                }
                placeholder="Variant"
                className="w-full p-3 border rounded-lg"
                disabled={isFormDisabled}
              />
              <input
                type="text"
                name="allottedVin"
                value={reportData.allottedVin}
                onChange={(e) =>
                  setReportData({ ...reportData, allottedVin: e.target.value })
                }
                placeholder="Allotted VIN"
                className="w-full p-3 border rounded-lg"
                disabled={isFormDisabled}
              />
              <textarea
                name="address"
                value={reportData.address}
                onChange={(e) =>
                  setReportData({ ...reportData, address: e.target.value })
                }
                placeholder="Address"
                className="w-full p-3 border rounded-lg"
                disabled={isFormDisabled}
              ></textarea>
              <textarea
                name="vehicleCondition"
                value={reportData.vehicleCondition}
                onChange={(e) =>
                  setReportData({
                    ...reportData,
                    vehicleCondition: e.target.value,
                  })
                }
                placeholder="Vehicle Condition"
                className="w-full p-3 border rounded-lg"
                disabled={isFormDisabled}
              ></textarea>
            </form>
            <div className="flex justify-end space-x-4 mt-6">
              <button
                onClick={handleSaveProgress}
                className="bg-blue-500 text-white px-6 py-3 rounded-lg"
              >
                Save Progress
              </button>
              <button
                onClick={handleFormSubmit}
                className="bg-green-500 text-white px-6 py-3 rounded-lg"
              >
                {isPdfGenerated ? "Regenerate PDF" : "Generate PDF"}
              </button>
            </div> */}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default PDI;
